export const battery0 = [
  '50.000002 40.000001',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-battery0-styling {
        fill: inherit;
        stroke-width: 0px;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.20352091,0,0,0.20352091,15.101761,0)">
     <g
       id="bat-border"
       class="his-battery0-styling"
     >
    <path
       d="M 85.04,196.54 H 12.23 C 5.47,196.54 0,191.06 0,184.31 V 30.91 C 0,24.15 5.48,18.68 12.23,18.68 h 72.81 c 6.76,0 12.23,5.48 12.23,12.23 v 153.4 c 0,6.76 -5.48,12.23 -12.23,12.23 z M 15.08,186.08 h 67.11 c 2.55,0 4.62,-2.07 4.62,-4.62 V 33.76 c 0,-2.55 -2.07,-4.62 -4.62,-4.62 H 15.08 c -2.55,0 -4.62,2.07 -4.62,4.62 v 147.7 c 0,2.55 2.07,4.62 4.62,4.62 z"
       />
    <path
       d="M 74.16,12.11 H 23.11 C 19.77,12.11 17.05,9.4 17.05,6.05 17.05,2.7 19.77,0 23.11,0 h 51.05 c 3.34,0 6.06,2.71 6.06,6.06 0,3.35 -2.71,6.06 -6.06,6.06 z"
       />
     </g>
  </g>
  `
]
export const battery100 = [
  '50.000002 39.999999',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-battery100-styling-0 {
        fill: inherit;
      }
      .his-battery100-styling-0, .his-battery100-styling-1 {
        stroke-width: 0px;
      }
      .his-battery100-styling-1 {
        fill: inherit;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.20385282,0,0,0.20385282,15.085618,-1.7020001e-7)">
      <g
         id="bat-border"
         class="his-battery100-styling-1"
      >
    <path
       d="M 85.04,196.21 H 12.23 C 5.47,196.21 0,190.73 0,183.98 V 30.59 C 0,23.83 5.48,18.36 12.23,18.36 h 72.81 c 6.76,0 12.23,5.48 12.23,12.23 v 153.4 c 0,6.76 -5.48,12.23 -12.23,12.23 z M 15.08,185.75 h 67.11 c 2.55,0 4.62,-2.07 4.62,-4.62 V 33.44 c 0,-2.55 -2.07,-4.62 -4.62,-4.62 H 15.08 c -2.55,0 -4.62,2.07 -4.62,4.62 v 147.7 c 0,2.55 2.07,4.62 4.62,4.62 z"
      />
    <path
       d="M 74.16,12.11 H 23.11 C 19.77,12.11 17.05,9.4 17.05,6.05 17.05,2.7 19.77,0 23.11,0 h 51.05 c 3.34,0 6.06,2.71 6.06,6.06 0,3.35 -2.71,6.06 -6.06,6.06 z"
      />
      </g>
      <g
        id="bat-level-100"
        class="e-board-svg-bat-level-100"
      >
    <rect
       x="14.79"
       y="157.42999"
       width="67.699997"
       height="23.639999"
       rx="5.0100002"
       ry="5.0100002"
       />
    <rect
       x="14.79"
       y="126.67"
       width="67.699997"
       height="23.639999"
       rx="5.0100002"
       ry="5.0100002"
       />
    <rect
       x="14.79"
       y="95.910004"
       width="67.699997"
       height="23.639999"
       rx="5.0100002"
       ry="5.0100002"
       />
    <rect
       x="14.79"
       y="65.150002"
       width="67.699997"
       height="23.639999"
       rx="5.0100002"
       ry="5.0100002"
       />
    <rect
       x="14.79"
       y="34.389999"
       width="67.699997"
       height="23.639999"
       rx="5.0100002"
       ry="5.0100002"
       />
  </g>
  `
]
export const battery20 = [
  '50.000002 39.999999',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-battery20-styling {
        fill: inherit;
        stroke-width: 0px;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.20385282,0,0,0.20385282,15.085618,-1.7020001e-7)">
     <g
       id="bat-border"
     >
    <path
       class="his-battery20-styling"
       d="M 85.04,196.21 H 12.23 C 5.47,196.21 0,190.73 0,183.98 V 30.59 C 0,23.83 5.48,18.36 12.23,18.36 h 72.81 c 6.76,0 12.23,5.48 12.23,12.23 v 153.4 c 0,6.76 -5.48,12.23 -12.23,12.23 z M 15.08,185.75 h 67.11 c 2.55,0 4.62,-2.07 4.62,-4.62 V 33.44 c 0,-2.55 -2.07,-4.62 -4.62,-4.62 H 15.08 c -2.55,0 -4.62,2.07 -4.62,4.62 v 147.7 c 0,2.55 2.07,4.62 4.62,4.62 z"
       />
    <path
       class="his-battery20-styling"
       d="M 74.16,12.11 H 23.11 C 19.77,12.11 17.05,9.4 17.05,6.05 17.05,2.7 19.77,0 23.11,0 h 51.05 c 3.34,0 6.06,2.71 6.06,6.06 0,3.35 -2.71,6.06 -6.06,6.06 z"
       />
     </g>
    <rect
       id="bat-level-20"
       class="e-board-svg-bat-level-20"
       x="14.79"
       y="157.42999"
       width="67.699997"
       height="23.639999"
       rx="5.0100002"
       ry="5.0100002"
      />
  </g>
  `
]
export const battery40 = [
  '50.000002 39.999999',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-battery40-styling-0 {
        fill: inherit;
      }
      .his-battery40-styling-0, .his-battery40-styling-1 {
        stroke-width: 0px;
      }
      .his-battery40-styling-1 {
        fill: inherit;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.20385282,0,0,0.20385282,15.085618,-1.7020001e-7)">
     <g
       id="bat-border"
       class="his-battery40-styling-0"
     >
    <path
       d="M 85.04,196.21 H 12.23 C 5.47,196.21 0,190.73 0,183.98 V 30.59 C 0,23.83 5.48,18.36 12.23,18.36 h 72.81 c 6.76,0 12.23,5.48 12.23,12.23 v 153.4 c 0,6.76 -5.48,12.23 -12.23,12.23 z M 15.08,185.75 h 67.11 c 2.55,0 4.62,-2.07 4.62,-4.62 V 33.44 c 0,-2.55 -2.07,-4.62 -4.62,-4.62 H 15.08 c -2.55,0 -4.62,2.07 -4.62,4.62 v 147.7 c 0,2.55 2.07,4.62 4.62,4.62 z"
       />
    <path
       d="M 74.16,12.11 H 23.11 C 19.77,12.11 17.05,9.4 17.05,6.05 17.05,2.7 19.77,0 23.11,0 h 51.05 c 3.34,0 6.06,2.71 6.06,6.06 0,3.35 -2.71,6.06 -6.06,6.06 z"
      />
      </g>
       <g
       id="bat-level-40"
       class="e-board-svg-bat-level-40"
      >
    <rect
       x="14.79"
       y="157.42999"
       width="67.699997"
       height="23.639999"
       rx="5.0100002"
       ry="5.0100002"
       />
    <rect
       x="14.79"
       y="126.67"
       width="67.699997"
       height="23.639999"
       rx="5.0100002"
       ry="5.0100002"
      />
      </g>
  </g>
  `
]
export const battery60 = [
  '50.000002 39.999999',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-battery60-styling-0 {
        fill: inherit;
      }
      .his-battery60-styling-0, .his-battery60-styling-1 {
        stroke-width: 0px;
      }
      .his-battery60-styling-1 {
        fill: inherit;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.20385282,0,0,0.20385282,15.085618,-1.7020001e-7)">
      <g
        id="bat-border"
        class="his-battery60-styling-1"
      >
    <path
       d="M 85.04,196.21 H 12.23 C 5.47,196.21 0,190.73 0,183.98 V 30.59 C 0,23.83 5.48,18.36 12.23,18.36 h 72.81 c 6.76,0 12.23,5.48 12.23,12.23 v 153.4 c 0,6.76 -5.48,12.23 -12.23,12.23 z M 15.08,185.75 h 67.11 c 2.55,0 4.62,-2.07 4.62,-4.62 V 33.44 c 0,-2.55 -2.07,-4.62 -4.62,-4.62 H 15.08 c -2.55,0 -4.62,2.07 -4.62,4.62 v 147.7 c 0,2.55 2.07,4.62 4.62,4.62 z"
       />
    <path
       d="M 74.16,12.11 H 23.11 C 19.77,12.11 17.05,9.4 17.05,6.05 17.05,2.7 19.77,0 23.11,0 h 51.05 c 3.34,0 6.06,2.71 6.06,6.06 0,3.35 -2.71,6.06 -6.06,6.06 z"
       />
      </g>
      <g
       id="bat-level-60"
       class="e-board-svg-bat-level-60"
      >
    <rect
       x="14.79"
       y="157.42999"
       width="67.699997"
       height="23.639999"
       rx="5.0100002"
       ry="5.0100002"
      />
    <rect
       x="14.79"
       y="126.67"
       width="67.699997"
       height="23.639999"
       rx="5.0100002"
       ry="5.0100002"
      />
    <rect
       x="14.79"
       y="95.910004"
       width="67.699997"
       height="23.639999"
       rx="5.0100002"
       ry="5.0100002"
      />
      </g>
  </g>
  `
]
export const battery80 = [
  '50.000002 39.999999',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-battery80-styling-0 {
        fill: inherit;
      }
      .his-battery80-styling-0, .his-battery80-styling-1 {
        stroke-width: 0px;
      }
      .his-battery80-styling-1 {
        fill: inherit;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.20385282,0,0,0.20385282,15.085618,-1.7020001e-7)">
      <g
        id="bat-border"
        class="his-battery80-styling-0"
      >
    <path
       d="M 85.04,196.21 H 12.23 C 5.47,196.21 0,190.73 0,183.98 V 30.59 C 0,23.83 5.48,18.36 12.23,18.36 h 72.81 c 6.76,0 12.23,5.48 12.23,12.23 v 153.4 c 0,6.76 -5.48,12.23 -12.23,12.23 z M 15.08,185.75 h 67.11 c 2.55,0 4.62,-2.07 4.62,-4.62 V 33.44 c 0,-2.55 -2.07,-4.62 -4.62,-4.62 H 15.08 c -2.55,0 -4.62,2.07 -4.62,4.62 v 147.7 c 0,2.55 2.07,4.62 4.62,4.62 z"
       />
    <path
       d="M 74.16,12.11 H 23.11 C 19.77,12.11 17.05,9.4 17.05,6.05 17.05,2.7 19.77,0 23.11,0 h 51.05 c 3.34,0 6.06,2.71 6.06,6.06 0,3.35 -2.71,6.06 -6.06,6.06 z"
       />
      </g>
      <g
        id="bat-level-80"
        class="e-board-svg-bat-level-80"
      >
    <rect
       x="14.79"
       y="157.42999"
       width="67.699997"
       height="23.639999"
       rx="5.0100002"
       ry="5.0100002"
      />
    <rect
       x="14.79"
       y="126.67"
       width="67.699997"
       height="23.639999"
       rx="5.0100002"
       ry="5.0100002"
       />
    <rect
       x="14.79"
       y="95.910004"
       width="67.699997"
       height="23.639999"
       rx="5.0100002"
       ry="5.0100002"
       />
    <rect
       x="14.79"
       y="65.150002"
       width="67.699997"
       height="23.639999"
       rx="5.0100002"
       ry="5.0100002"
       />
      </g>
  </g>
  `
]
export const chp = [
  '49.999999 40.000002',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-chp-styling {
        fill: inherit;
        stroke-width: 0px;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.22161156,0,0,0.22161156,-8.36e-8,1.197699)">
    <g
       id="g2">
      <ellipse
         class="his-chp-styling"
         cx="5.3800001"
         cy="97.489998"
         rx="4.8099999"
         ry="22.870001"
         id="ellipse1" />
      <ellipse
         class="his-chp-styling"
         cx="4.8099999"
         cy="70.910004"
         rx="4.8099999"
         ry="22.17"
         id="ellipse2" />
      <path
         class="his-chp-styling"
         d="m 179.29,73.42 c 0.57,-1.59 0.95,-3.12 1.17,-4.59 1.5,-10.19 -5.82,-19.46 -15.99,-21.06 -4.65,-0.74 -9.32,-2.64 -8.04,-7.44 1.32,-4.94 -0.43,-9.52 -2.28,-12.65 -1.54,-2.61 -4.37,-4.2 -7.4,-4.2 H 105.28 V 12.65 h 32.5 V 0 H 55.33 V 12.64 H 80.6 L 80.4,23.87 H 53.72 c -9.03,2.61 -5.82,13.44 -8.83,14.44 -3.01,1 -18.25,8.22 -24.07,15.85 -5.82,7.62 -1.6,24.07 -1.6,24.07 H 8.59 v 2.01 l 1.6,13.04 h 10.23 c -1.2,39.12 33.7,37.31 33.1,39.72 -0.45,1.8 17.81,19.39 26.98,28.08 3.45,3.26 7.75,5.5 12.42,6.35 52.36,9.48 97.8,-13.97 97.8,-13.97 v -15.04 h 7.22 v 10.83 c 13.24,18.66 27.68,0 27.68,0 V 73.43 H 179.28 Z M 82.71,60.2 75,81.98 c -0.34,0.95 0.37,1.94 1.37,1.94 H 81 c 1.09,0 1.79,1.16 1.29,2.12 l -14.9,28.71 c -0.72,1.38 -2.81,0.82 -2.74,-0.73 l 0.74,-16.71 c 0.04,-0.83 -0.62,-1.52 -1.45,-1.52 h -5.38 c -0.8,0 -1.45,-0.65 -1.45,-1.45 V 59.72 c 0,-0.8 0.65,-1.45 1.45,-1.45 h 22.78 c 1,0 1.71,0.99 1.37,1.94 z m 37.25,53.15 c -1.06,-0.62 -1.72,-2.35 -0.9,-3.42 5.16,-6.75 -0.66,-15.06 -4.05,-21.13 -2.13,-3.81 -3.96,-7.87 -4.25,-12.29 -0.27,-4.1 1,-8.32 3.41,-11.63 0.8,-1.1 2.16,-1.64 3.42,-0.9 1.08,0.63 1.69,2.33 0.9,3.42 -2.24,3.08 -3.28,6.86 -2.52,10.64 0.83,4.13 3.07,7.73 5.13,11.33 3.89,6.78 7.71,15.97 2.27,23.08 -0.82,1.08 -2.13,1.65 -3.42,0.9 z m 15.77,0 c -1.06,-0.62 -1.72,-2.35 -0.9,-3.42 5.16,-6.75 -0.66,-15.06 -4.05,-21.13 -2.13,-3.81 -3.96,-7.87 -4.25,-12.29 -0.27,-4.1 1,-8.32 3.41,-11.63 0.8,-1.1 2.16,-1.64 3.42,-0.9 1.08,0.63 1.69,2.33 0.9,3.42 -2.24,3.08 -3.28,6.86 -2.52,10.64 0.83,4.13 3.07,7.73 5.13,11.33 3.89,6.78 7.71,15.97 2.27,23.08 -0.82,1.08 -2.13,1.65 -3.42,0.9 z m 15.77,0 c -1.06,-0.62 -1.72,-2.35 -0.9,-3.42 5.16,-6.75 -0.66,-15.06 -4.05,-21.13 -2.13,-3.81 -3.96,-7.87 -4.25,-12.29 -0.27,-4.1 1,-8.32 3.41,-11.63 0.8,-1.1 2.16,-1.64 3.42,-0.9 1.08,0.63 1.69,2.33 0.9,3.42 -2.24,3.08 -3.28,6.86 -2.52,10.64 0.83,4.13 3.07,7.73 5.13,11.33 3.89,6.78 7.71,15.97 2.27,23.08 -0.82,1.08 -2.13,1.65 -3.42,0.9 z"
         id="path2" />
    </g>
  </g>
  `
]
export const container = [
  '50 40',
  `
  <defs
     id="defs2" />
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-6.0000038,-132.16438)">
    <g
       id="g26887"
       transform="matrix(-0.21161124,0,0,0.2456282,51.72743,126.23038)">
      <path
         style="fill:none;stroke: inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 86.900993,149.77917 V 99.779163 l -4,-2.999996 v 50.000003 z"
         id="path19468"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;stroke: inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 59.950993,132 V 81.999986 l -4,-2.99999 V 129 Z"
         id="path19468-9"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;stroke: inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 32.900993,114.25 V 64.249985 l -4,-2.99999 V 111.25 Z"
         id="path19468-9-1"
         sodipodi:nodetypes="ccccc" />
      <rect
         style="fill:none;stroke: inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         id="rect7608"
         width="80"
         height="80"
         x="-191.901"
         y="101.05833"
         transform="scale(-1,1)" />
      <path
         style="fill:none;stroke: inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 111.94531,101.188 3.9006233,29.999517"
         id="path7619-5"
         sodipodi:nodetypes="cc" />
      <path
         style="fill:none;stroke: inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="m 111.99324,181.20633 c 0,0 -108.1214667,-70.17681 -108.0922467,-71.20633 0.0647,-2.27934 -0.10351,-80.608706 0,-80 0,0 2.65227,-0.0064 11.9279797,0 20.00275,0.01381 67.45079,-0.100276 68.07202,0 0.91981,0.148471 107.866097,70.66985 107.866097,70.66985"
         id="path7619-5-3"
         sodipodi:nodetypes="cssssc" />
      <path
         style="fill:none;stroke: inherit;stroke-width:5;stroke-linecap:butt;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         d="m 166.901,180 v -40 h -30 v 40"
         id="path26851"
         sodipodi:nodetypes="cccc" />
    </g>
  </g>
  `
]
export const containerAlarm = [
  '50 40',
  `
  <defs
     id="defs13" />
  
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-6.0000038,-132.16438)">
    <g
       id="g26887"
       transform="matrix(-0.21193464,0,0,0.24600356,51.938646,126.37029)"
       style="fill:none;fill-opacity:1;stroke:inherit;stroke-opacity:1">
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 86.900993,149.77917 V 99.779163 l -4,-2.999996 v 50.000003 z"
         id="path19468"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 59.950993,132 V 81.999986 l -4,-2.99999 V 129 Z"
         id="path19468-9"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 32.900993,114.25 V 64.249985 l -4,-2.99999 V 111.25 Z"
         id="path19468-9-1"
         sodipodi:nodetypes="ccccc" />
      <rect
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         id="rect7608"
         width="80"
         height="80"
         x="-191.901"
         y="101.05833"
         transform="scale(-1,1)" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 111.94531,101.188 3.9006233,29.999517"
         id="path7619-5"
         sodipodi:nodetypes="cc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="m 111.99324,181.20633 c 0,0 -108.1214667,-70.17681 -108.0922467,-71.20633 0.0647,-2.27934 -0.10351,-80.608706 0,-80 0,0 2.65227,-0.0064 11.9279797,0 20.00275,0.01381 67.45079,-0.100276 68.07202,0 0.91981,0.148471 107.866097,70.66985 107.866097,70.66985"
         id="path7619-5-3"
         sodipodi:nodetypes="cssssc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:butt;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         d="m 166.901,180 v -40 h -30 v 40"
         id="path26851"
         sodipodi:nodetypes="cccc" />
    </g>
    <circle
       style="fill:#f92224;fill-opacity:1;stroke:inherit;stroke-width:1;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:17;stroke-dasharray:none;stroke-opacity:1"
       id="path499"
       cx="15.267975"
       cy="137.63654"
       r="4.4884591" />
  </g>
  `
]
export const containerOk = [
  '50 40',
  `
  <defs
     id="defs13" />
  
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-6.0000038,-132.16438)">
    <g
       id="g26887"
       transform="matrix(-0.21193464,0,0,0.24600356,51.938646,126.37029)"
       style="fill:none;fill-opacity:1;stroke:inherit;stroke-opacity:1">
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 86.900993,149.77917 V 99.779163 l -4,-2.999996 v 50.000003 z"
         id="path19468"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 59.950993,132 V 81.999986 l -4,-2.99999 V 129 Z"
         id="path19468-9"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 32.900993,114.25 V 64.249985 l -4,-2.99999 V 111.25 Z"
         id="path19468-9-1"
         sodipodi:nodetypes="ccccc" />
      <rect
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         id="rect7608"
         width="80"
         height="80"
         x="-191.901"
         y="101.05833"
         transform="scale(-1,1)" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 111.94531,101.188 3.9006233,29.999517"
         id="path7619-5"
         sodipodi:nodetypes="cc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="m 111.99324,181.20633 c 0,0 -108.1214667,-70.17681 -108.0922467,-71.20633 0.0647,-2.27934 -0.10351,-80.608706 0,-80 0,0 2.65227,-0.0064 11.9279797,0 20.00275,0.01381 67.45079,-0.100276 68.07202,0 0.91981,0.148471 107.866097,70.66985 107.866097,70.66985"
         id="path7619-5-3"
         sodipodi:nodetypes="cssssc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:butt;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         d="m 166.901,180 v -40 h -30 v 40"
         id="path26851"
         sodipodi:nodetypes="cccc" />
    </g>
    <circle
       style="fill:#5ec44e;fill-opacity:1;stroke:inherit;stroke-width:1;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:17;stroke-dasharray:none;stroke-opacity:1"
       id="path499"
       cx="15.267975"
       cy="137.63654"
       r="4.4884591" />
  </g>
  `
]
export const containerWarning = [
  '50 40',
  `
  <defs
     id="defs13" />
  
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-6.0000038,-132.16438)">
    <g
       id="g26887"
       transform="matrix(-0.21193464,0,0,0.24600356,51.938646,126.37029)"
       style="fill:none;fill-opacity:1;stroke:inherit;stroke-opacity:1">
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 86.900993,149.77917 V 99.779163 l -4,-2.999996 v 50.000003 z"
         id="path19468"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 59.950993,132 V 81.999986 l -4,-2.99999 V 129 Z"
         id="path19468-9"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 32.900993,114.25 V 64.249985 l -4,-2.99999 V 111.25 Z"
         id="path19468-9-1"
         sodipodi:nodetypes="ccccc" />
      <rect
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         id="rect7608"
         width="80"
         height="80"
         x="-191.901"
         y="101.05833"
         transform="scale(-1,1)" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 111.94531,101.188 3.9006233,29.999517"
         id="path7619-5"
         sodipodi:nodetypes="cc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="m 111.99324,181.20633 c 0,0 -108.1214667,-70.17681 -108.0922467,-71.20633 0.0647,-2.27934 -0.10351,-80.608706 0,-80 0,0 2.65227,-0.0064 11.9279797,0 20.00275,0.01381 67.45079,-0.100276 68.07202,0 0.91981,0.148471 107.866097,70.66985 107.866097,70.66985"
         id="path7619-5-3"
         sodipodi:nodetypes="cssssc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:butt;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         d="m 166.901,180 v -40 h -30 v 40"
         id="path26851"
         sodipodi:nodetypes="cccc" />
    </g>
    <circle
       style="fill:#fafb5c;fill-opacity:1;stroke:inherit;stroke-width:1;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:17;stroke-dasharray:none;stroke-opacity:1"
       id="path499"
       cx="15.267975"
       cy="137.63654"
       r="4.4884591" />
  </g>
  `
]
export const dashboardCenterIcon = [
  '320 320',
  `
  <defs
     id="defs150">
    <style
       id="style148">
      .mpg-dashboard-center-icon-styling-1, .mpg-dashboard-center-icon-styling-2 {
        fill: #ebf1f3;
      }
      .mpg-dashboard-center-icon-styling-3 {
        fill: #c4794f;
      }
      .mpg-dashboard-center-icon-styling-3, .mpg-dashboard-center-icon-styling-2, .mpg-dashboard-center-icon-styling-4, .mpg-dashboard-center-icon-styling-5, .mpg-dashboard-center-icon-styling-6, .mpg-dashboard-center-icon-styling-7, .mpg-dashboard-center-icon-styling-8, .mpg-dashboard-center-icon-styling-9, .mpg-dashboard-center-icon-styling-10, .mpg-dashboard-center-icon-styling-11, .mpg-dashboard-center-icon-styling-12, .mpg-dashboard-center-icon-styling-13, .mpg-dashboard-center-icon-styling-14, .mpg-dashboard-center-icon-styling-15, .mpg-dashboard-center-icon-styling-16, .mpg-dashboard-center-icon-styling-17, .mpg-dashboard-center-icon-styling-18 {
        fill-rule: evenodd;
      }
      .mpg-dashboard-center-icon-styling-4 {
        fill: #c9e8d9;
      }
      .mpg-dashboard-center-icon-styling-5 {
        fill: #759ac9;
      }
      .mpg-dashboard-center-icon-styling-19 {
        fill: #b2c8de;
      }
      .mpg-dashboard-center-icon-styling-6 {
        fill: #90b0d0;
      }
      .mpg-dashboard-center-icon-styling-7 {
        fill: #406a97;
      }
      .mpg-dashboard-center-icon-styling-8 {
        fill: #33425d;
      }
      .mpg-dashboard-center-icon-styling-9 {
        fill: #495977;
      }
      .mpg-dashboard-center-icon-styling-10 {
        fill: #b3c8dd;
      }
      .mpg-dashboard-center-icon-styling-11 {
        fill: #b5683f;
      }
      .mpg-dashboard-center-icon-styling-12 {
        fill: #59b847;
      }
      .mpg-dashboard-center-icon-styling-13 {
        fill: #5984c0;
      }
      .mpg-dashboard-center-icon-styling-14 {
        fill: #4977b7;
      }
      .mpg-dashboard-center-icon-styling-15 {
        fill: #479b3e;
      }
      .mpg-dashboard-center-icon-styling-16 {
        fill: #9ebbd7;
      }
      .mpg-dashboard-center-icon-styling-17 {
        fill: #dee9f4;
      }
      .mpg-dashboard-center-icon-styling-18 {
        fill: #c6d7e6;
      }
      .mpg-dashboard-center-icon-styling-20 {
        fill: #d4e0ec;
      }
    </style>
  </defs>
  <path
     class="mpg-dashboard-center-icon-styling-10"
     d="m 298.07891,241.95784 c 0,0.98073 -14.58502,1.92071 -40.54755,2.61508 -25.96175,0.69316 -61.17425,1.08292 -97.89009,1.08292 -36.71583,0 -71.927717,-0.38976 -97.890299,-1.08292 -25.961699,-0.69437 -40.547712,-1.63435 -40.547712,-2.61508 0,-0.98049 14.586004,-1.9207 40.547712,-2.61412 25.962582,-0.69312 61.174199,-1.08266 97.890299,-1.08266 36.71611,0 71.92834,0.38954 97.89009,1.08266 25.96253,0.69342 40.54755,1.63363 40.54755,2.61412 z m 0,0"
     id="path152"
     style="stroke-width:0.929932" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 24.505723,238.43187 c 0,0 -9.566315,-4.70703 -7.268973,-8.67276 2.296268,-3.96577 10.84972,-0.0534 10.84972,-0.0534 0,0 -0.368748,-3.99892 1.602604,-4.89072 1.971407,-0.89202 7.20359,3.08323 7.20359,3.08323 0,0 -2.724148,-3.86183 -1.516904,-5.00997 1.207179,-1.14915 4.483963,1.60453 4.483963,1.60453 0,0 -1.817946,-9.41965 1.300616,-11.12712 3.119628,-1.7075 9.108954,4.42967 9.108954,4.42967 0,0 1.93431,-4.41163 4.868912,-2.73635 2.935016,1.67505 0.839681,5.15001 0.839681,5.15001 0,0 4.443053,-3.31591 5.957109,-2.06386 1.515057,1.25107 -0.786145,5.42831 -0.786145,5.42831 0,0 8.19632,-9.02525 12.179154,-5.35025 3.982834,3.67523 -3.342533,9.64651 -3.342533,9.64651 0,0 5.737898,-1.69211 6.645938,-0.0334 0.906974,1.65992 -2.557464,3.94672 -2.557464,3.94672 0,0 13.281704,-2.79661 13.707618,1.96576 0.42586,4.76217 -14.082082,4.68118 -14.082082,4.68118 l -49.193749,0.002 z m 0,0"
     id="path154"
     style="stroke-width:0.91893" />
  <path
     class="mpg-dashboard-center-icon-styling-15"
     d="m 37.950297,238.47477 c 0,0 -5.260706,-2.58902 -3.998198,-4.76994 1.263574,-2.18094 5.967648,-0.0295 5.967648,-0.0295 0,0 -0.202955,-2.19927 0.881309,-2.68903 1.084319,-0.49056 3.960862,1.69526 3.960862,1.69526 0,0 -1.497736,-2.12383 -0.833671,-2.75563 0.664184,-0.63175 2.465984,0.88328 2.465984,0.88328 0,0 -0.999584,-5.18048 0.715516,-6.1201 1.715219,-0.93861 5.008975,2.43632 5.008975,2.43632 0,0 1.063542,-2.42581 2.677513,-1.50452 1.614035,0.92056 0.46224,2.83198 0.46224,2.83198 0,0 2.442937,-1.82383 3.275653,-1.135 0.832835,0.6881 -0.432411,2.98538 -0.432411,2.98538 0,0 4.507726,-4.96335 6.698344,-2.94245 2.189488,2.02093 -1.837951,5.30537 -1.837951,5.30537 0,0 3.154704,-0.93081 3.653995,-0.0171 0.499282,0.91178 -1.40644,2.16943 -1.40644,2.16943 0,0 7.30459,-1.53768 7.538981,1.0816 0.234456,2.61829 -7.744619,2.57462 -7.744619,2.57462 H 37.95027 Z m 0,0"
     id="path156"
     style="stroke-width:0.91893" />
  <path
     class="mpg-dashboard-center-icon-styling-4"
     d="m 42.447539,213.06562 c -0.461946,-0.005 -0.896618,0.0866 -1.287218,0.30003 -3.118563,1.70746 -1.300617,11.12711 -1.300617,11.12711 0,0 -3.275892,-2.75367 -4.483016,-1.60453 -1.207235,1.14815 1.515958,5.00998 1.515958,5.00998 0,0 -5.232174,-3.97526 -7.20359,-3.08323 -1.971353,0.89179 -1.602605,4.89071 -1.602605,4.89071 0,0 -8.553452,-3.91234 -10.849719,0.0534 -1.168235,2.01724 0.732433,4.22306 2.88214,5.90565 -1.904766,-1.61503 -3.402447,-3.61228 -2.335331,-5.45389 2.296387,-3.96576 10.848883,-0.0544 10.848883,-0.0544 0,0 -0.367618,-3.99892 1.603735,-4.89094 1.971407,-0.8918 7.203406,3.08442 7.203406,3.08442 0,0 -2.724148,-3.86282 -1.516969,-5.01094 1.207115,-1.14816 4.484083,1.60548 4.484083,1.60548 0,0 -1.818001,-9.4206 1.300616,-11.1281 1.898931,-1.03957 4.849853,0.82694 6.877417,2.44782 -1.629401,-1.376 -4.126711,-3.17959 -6.137191,-3.1986 v 0 z m 11.152066,1.62356 c -2.010471,0.18952 -3.254996,2.94711 -3.307403,3.06248 0.191524,0.18366 0.524176,0.4954 0.524176,0.4954 0,0 1.934126,-4.41162 4.868967,-2.73754 0.08754,0.0504 0.15609,0.10682 0.235173,0.16001 -0.209562,-0.22005 -0.460991,-0.42689 -0.782331,-0.61058 -0.549722,-0.31369 -1.06515,-0.41371 -1.538582,-0.36978 v 0 z m 17.60059,2.65925 c -2.965092,-0.14097 -6.728899,2.99393 -8.703164,4.86705 -0.367618,1.00059 -0.802281,1.80943 -0.802281,1.80943 0,0 7.628494,-8.39713 11.742763,-5.68832 -0.03805,-0.037 -0.0695,-0.0764 -0.109518,-0.11343 -0.622263,-0.5735 -1.347482,-0.83836 -2.127791,-0.87473 v 0 z m -10.377234,0.52225 c -1.199672,0.0934 -2.775654,0.97935 -3.80186,1.63403 -0.212484,0.67935 -0.496424,1.15475 -0.496424,1.15475 0,0 3.92847,-2.93073 5.655948,-2.238 -0.06664,-0.10294 -0.147626,-0.19635 -0.245649,-0.27732 -0.28394,-0.23443 -0.670855,-0.30884 -1.112015,-0.27345 v 0 z m 13.864599,9.23866 c -1.069073,-0.022 -2.31913,0.19807 -3.272979,0.40783 -0.50214,0.48105 -0.8822,0.80327 -0.8822,0.80327 0,0 4.346703,-1.28061 6.070256,-0.51739 -0.29901,-0.48977 -1.032693,-0.6766 -1.915077,-0.6937 v 0 z m 7.341687,3.86183 c -2.420194,-0.0476 -4.933825,0.29443 -6.480328,0.54981 -0.505898,0.42686 -0.928891,0.71273 -0.928891,0.71273 0,0 9.249909,-1.94481 12.556236,0.181 -0.971768,-1.03472 -2.981467,-1.40061 -5.147017,-1.44354 z m 0,0"
     id="path158"
     style="stroke-width:0.91893" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 261.91538,76.874283 c -19.5816,-0.640927 -20.63786,12.322714 -20.63786,12.322714 0,0 -5.77234,-3.939503 -16.03506,2.524423 -10.26195,6.464185 -7.57192,15.73787 -7.57192,15.73787 0,0 -6.51093,-2.44411 -10.69041,6.23641 -4.17875,8.68054 1.03982,12.47186 1.03982,12.47186 0,0 -4.45989,3.72887 -1.17578,11.8165 3.28309,8.08837 11.0235,6.40466 11.0235,6.40466 0,0 -0.045,6.55773 6.40935,9.24603 6.45563,2.689 10.7032,-0.95194 10.7032,-0.95194 0,0 -0.0824,4.73738 7.79667,5.52571 7.87865,0.78907 10.78619,-5.73608 10.78619,-5.73608 0,0 9.04199,6.29469 17.13528,5.23942 8.09418,-1.05406 9.79995,-5.59158 9.79995,-5.59158 0,0 6.31081,4.70382 12.87251,1.44833 6.56068,-3.25547 3.86671,-9.39025 3.86671,-9.39025 0,0 8.85693,-0.17315 12.17823,-7.13863 3.32142,-6.96525 -2.51981,-12.07389 -2.51981,-12.07389 0,0 4.95537,-5.30164 3.50241,-12.00876 -1.45428,-6.70711 -6.54646,-6.36351 -6.54646,-6.36351 0,0 3.57499,-8.17556 -2.72554,-14.278008 -6.30132,-6.103454 -17.8518,0.629394 -17.8518,0.629394 0,0 -1.77758,-15.430511 -21.35917,-16.070673 v 0 z m 0,0"
     id="path160"
     style="stroke-width:0.922609" />
  <path
     class="mpg-dashboard-center-icon-styling-15"
     d="m 310.65844,115.54595 c -0.0432,5.43165 -3.76249,9.41989 -3.76249,9.41989 0,0 5.84122,5.10864 2.51981,12.07389 -3.3213,6.96548 -12.17823,7.13863 -12.17823,7.13863 0,0 2.69493,6.13478 -3.86671,9.39025 -6.56062,3.25548 -12.87251,-1.44833 -12.87251,-1.44833 0,0 -1.70577,4.53753 -9.79995,5.59256 -8.09329,1.0543 -17.13528,-5.24039 -17.13528,-5.24039 0,0 -2.90754,6.52515 -10.78619,5.73608 -7.87906,-0.78833 -7.79667,-5.52571 -7.79667,-5.52571 0,0 -4.24757,3.64094 -10.7032,0.95194 -6.45438,-2.6883 -6.40935,-9.24603 -6.40935,-9.24603 0,0 -7.74042,1.68371 -11.0235,-6.40393 -1.3594,-3.34902 -1.38414,-5.93885 -0.95563,-7.83757 1.09518,1.77724 2.83652,3.5557 5.61929,4.71433 7.51828,3.13207 12.46594,-1.10892 12.46594,-1.10892 0,0 -0.0954,5.51715 9.07953,6.43553 9.17615,0.91911 12.56172,-6.68042 12.56172,-6.68042 0,0 10.53178,7.33089 19.95775,6.10246 9.42673,-1.22818 11.41267,-6.51292 11.41267,-6.51292 0,0 7.34997,5.47895 14.9916,1.68761 7.64176,-3.79204 4.50401,-10.93631 4.50401,-10.93631 0,0 10.30405,-0.20278 14.17739,-8.30264 z m 0,0"
     id="path162"
     style="stroke-width:0.922609" />
  <path
     class="mpg-dashboard-center-icon-styling-4"
     d="m 260.13327,76.853202 c 0.57572,-0.0076 1.16986,0 1.78211,0.02205 9.77794,0.319592 15.11609,4.326925 18.01079,8.260781 -3.12148,-3.308143 -8.2167,-6.271941 -16.56631,-6.545494 -19.5987,-0.639922 -20.6558,12.333987 -20.6558,12.333987 0,0 -5.77814,-3.943165 -16.04984,2.526657 -10.27134,6.468816 -7.57849,15.752047 -7.57849,15.752047 0,0 -6.5165,-2.44605 -10.69902,6.24107 -2.51017,5.21567 -1.63096,8.65483 -0.52716,10.58146 -0.79964,-0.68304 -4.63586,-4.50471 -0.86876,-12.32905 4.17881,-8.68081 10.68975,-6.23642 10.68975,-6.23642 0,0 -2.69003,-9.274676 7.57192,-15.73886 10.26272,-6.463927 16.03506,-2.523474 16.03506,-2.523474 0,0 0.99121,-12.165722 18.85575,-12.344745 v 0 z m 34.06039,12.903366 c 2.48231,-9.22e-4 4.96296,0.651445 6.93174,2.558016 0.57405,0.555927 1.04011,1.132659 1.45978,1.714308 -6.3098,-6.07846 -17.84815,0.646768 -17.84815,0.646768 0,0 -0.12413,-0.900254 -0.52897,-2.214621 1.74229,-0.879219 5.82131,-2.699821 9.9856,-2.704471 z m -86.23393,36.466342 c 0.70481,1.15373 1.45691,1.70377 1.45691,1.70377 0,0 -4.46389,3.73183 -1.17673,11.82802 0.31193,0.77022 0.6754,1.42533 1.05895,2.029 -0.93261,-0.93259 -1.78779,-2.15612 -2.45469,-3.79891 -3.15304,-7.76509 0.79199,-11.47486 1.11557,-11.76188 v 0 z m 0,0"
     id="path164"
     style="stroke-width:0.922609" />
  <path
     class="mpg-dashboard-center-icon-styling-3"
     d="m 279.93641,141.2907 -16.28337,30.26177 -21.06753,-27.89771 -4.49908,1.03498 18.69421,35.24811 -3.18637,60.74116 h 22.49643 l -5.03625,-67.80041 13.32103,-33.06137 -4.43907,1.47346 z m 0,0"
     id="path166" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 273.09304,200.32217 2.99766,40.35686 h -22.49643 l 1.30947,-24.95713 c 10.34081,-3.70665 15.86233,-8.45782 18.18931,-15.39973 v 0 z m 0,0"
     id="path168" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 284.37444,139.81725 -13.31999,33.06137 c 2.03328,-6.51478 2.19919,-12.94971 0.76309,-16.49895 l 8.11784,-15.08897 4.43907,-1.47346 z m 0,0"
     id="path170" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 242.58648,143.65477 21.06539,27.89771 -3.40295,3.37514 c 0.33077,-0.0985 -8.85701,-16.01084 -19.34635,-30.88504 0.3889,-0.0902 0.96645,-0.22295 1.68391,-0.3878 v 0 z m 0,0"
     id="path172" />
  <rect
     class="mpg-dashboard-center-icon-styling-1"
     x="45.325871"
     y="166.00519"
     width="158.12296"
     height="74.71019"
     id="rect174" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 233.89783,240.67144 c 0,0 -9.87466,-4.85785 -7.50444,-8.95206 2.37054,-4.09293 11.19934,-0.0552 11.19934,-0.0552 0,0 -0.37974,-4.12778 1.65565,-5.04776 2.03459,-0.92032 7.43506,3.18279 7.43506,3.18279 0,0 -2.81173,-3.98778 -1.5655,-5.17227 1.24616,-1.1861 4.62951,1.65696 4.62951,1.65696 0,0 -1.87785,-9.72482 1.34249,-11.48695 3.21859,-1.76213 9.40251,4.57296 9.40251,4.57296 0,0 1.99697,-4.5539 5.02609,-2.82502 3.02871,1.72893 0.866,5.31621 0.866,5.31621 0,0 4.58579,-3.42297 6.1504,-2.13076 1.56333,1.29258 -0.81258,5.60367 -0.81258,5.60367 0,0 8.46061,-9.31645 12.57297,-5.52254 4.1109,3.79361 -3.45129,9.95816 -3.45129,9.95816 0,0 5.92306,-1.74796 6.86006,-0.0345 0.93708,1.71214 -2.63998,4.07223 -2.63998,4.07223 0,0 13.71106,-2.88511 14.15129,2.03057 0.43895,4.91561 -14.53641,4.83217 -14.53641,4.83217 l -50.78117,0.001 z m 0,0"
     id="path176"
     style="stroke-width:1.23779" />
  <path
     class="mpg-dashboard-center-icon-styling-15"
     d="m 247.77607,240.71645 c 0,0 -5.43054,-2.67219 -4.12776,-4.92354 1.30408,-2.25099 6.15923,-0.0296 6.15923,-0.0296 0,0 -0.208,-2.27037 0.91141,-2.77603 1.11917,-0.50697 4.08892,1.7506 4.08892,1.7506 0,0 -1.54648,-2.19351 -0.86104,-2.84538 0.68536,-0.65187 2.54501,0.91146 2.54501,0.91146 0,0 -1.03199,-5.34709 0.7379,-6.31734 1.77126,-0.96894 5.17233,2.51549 5.17233,2.51549 0,0 1.09744,-2.50398 2.76312,-1.55409 1.66625,0.95085 0.47656,2.92354 0.47656,2.92354 0,0 2.52158,-1.88137 3.38182,-1.17163 0.85992,0.71097 -0.4468,3.08287 -0.4468,3.08287 0,0 4.65373,-5.1236 6.91525,-3.03789 2.26017,2.0867 -1.89815,5.47654 -1.89815,5.47654 0,0 3.25741,-0.96141 3.77192,-0.0207 0.51627,0.94198 -1.45159,2.24079 -1.45159,2.24079 0,0 7.54021,-1.58759 7.78183,1.11549 0.24241,2.70408 -7.99336,2.6581 -7.99336,2.6581 l -27.92661,0.001 z m 0,0"
     id="path178"
     style="stroke-width:1.23779" />
  <path
     class="mpg-dashboard-center-icon-styling-4"
     d="m 252.41832,214.48746 c -0.47776,-0.007 -0.92698,0.0888 -1.32837,0.30954 -3.22034,1.76213 -1.34249,11.48695 -1.34249,11.48695 0,0 -3.38335,-2.84307 -4.62951,-1.65696 -1.24503,1.18449 1.5655,5.17096 1.5655,5.17096 0,0 -5.40046,-4.10313 -7.43505,-3.18148 -2.0354,0.91996 -1.65566,5.04776 -1.65566,5.04776 0,0 -8.8288,-4.03776 -11.19934,0.0552 -1.20621,2.08178 0.75595,4.35843 2.97505,6.09617 -1.96602,-1.66714 -3.51257,-3.7295 -2.41033,-5.63028 2.3707,-4.09421 11.19942,-0.0552 11.19942,-0.0552 0,0 -0.37982,-4.12909 1.65446,-5.0491 2.03572,-0.92028 7.43625,3.18282 7.43625,3.18282 0,0 -2.81172,-3.98643 -1.56558,-5.17224 1.24591,-1.18482 4.62782,1.65693 4.62782,1.65693 0,0 -1.87641,-9.72486 1.3425,-11.48691 1.95991,-1.07313 5.00699,0.85454 7.10039,2.52695 -1.68262,-1.42071 -4.25987,-3.2817 -6.33506,-3.30112 v 0 z m 11.51116,1.67637 c -2.07552,0.19517 -3.36009,3.04055 -3.41279,3.1598 0.19661,0.1899 0.54017,0.51225 0.54017,0.51225 0,0 1.9961,-4.55491 5.02617,-2.82502 0.09,0.0512 0.16188,0.10905 0.24273,0.1643 -0.21586,-0.22706 -0.47649,-0.44159 -0.80721,-0.63023 -0.56745,-0.32459 -1.10016,-0.42742 -1.58907,-0.3811 z m 18.16873,2.74416 c -3.06,-0.14524 -6.94629,3.09047 -8.98427,5.02477 -0.37982,1.03297 -0.82799,1.86724 -0.82799,1.86724 0,0 7.87529,-8.66721 12.12239,-5.87181 -0.0397,-0.0384 -0.0734,-0.0782 -0.11301,-0.11672 -0.64301,-0.59303 -1.39127,-0.86506 -2.19712,-0.90353 v 0 z m -10.71195,0.53886 c -1.23869,0.0975 -2.86475,1.0113 -3.92464,1.68785 -0.21947,0.70081 -0.51219,1.19104 -0.51219,1.19104 0,0 4.05444,-3.02508 5.83861,-2.31015 -0.0694,-0.10546 -0.1529,-0.20307 -0.25308,-0.2852 -0.29367,-0.24249 -0.69299,-0.31937 -1.1487,-0.28353 v 0 z m 14.31205,9.53759 c -1.10401,-0.0233 -2.39404,0.20402 -3.3783,0.42088 -0.51859,0.49678 -0.91108,0.82895 -0.91108,0.82895 0,0 4.4868,-1.32178 6.26702,-0.53388 -0.30931,-0.50571 -1.06655,-0.69823 -1.97764,-0.71594 v 0 z m 7.57856,3.98612 c -2.49872,-0.0486 -5.09267,0.30425 -6.68912,0.56743 -0.52253,0.4416 -0.95874,0.7353 -0.95874,0.7353 0,0 9.54859,-2.0072 12.96144,0.18763 -1.00374,-1.06782 -3.07764,-1.4467 -5.31358,-1.49036 z m 0,0"
     id="path180"
     style="stroke-width:1.23779" />
  <rect
     class="mpg-dashboard-center-icon-styling-19"
     x="203.44908"
     y="166.00519"
     width="53.659088"
     height="74.71019"
     id="rect182" />
  <path
     class="mpg-dashboard-center-icon-styling-5"
     d="M 77.914452,116.21868 H 230.31894 L 203.44909,166.0052 H 45.325872 Z m 0,0"
     id="path184" />
  <path
     class="mpg-dashboard-center-icon-styling-6"
     d="m 230.31999,116.26461 26.79028,49.74801 h -53.66119 l 26.8709,-49.74801 z m 0,0"
     id="path186"
     style="stroke-width:0.999633" />
  <path
     class="mpg-dashboard-center-icon-styling-7"
     d="m 132.63745,143.3904 -0.5701,0.14518 0.17413,0.1752 H 69.513472 c -0.69362,0 -1.2142,0.21473 -1.47861,0.60971 l -7.47088,11.18612 -0.53484,-0.27687 0.57651,0.8067 c 0.13065,0.18447 0.34723,0.37746 0.70288,0.37746 l 0.28327,-0.006 h 63.564328 c 0.69187,0 1.20312,-0.22376 1.44355,-0.63229 l 6.63501,-11.26918 c 0.0528,-0.09 0.0457,-0.19908 -0.0363,-0.31931 l -0.56096,-0.79633 z m 0,0"
     id="path188" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="M 68.970082,142.91655 H 131.8152 c 0.45416,0 1.03599,0.52773 0.87728,0.79633 l -6.63404,11.26894 c -0.24153,0.40957 -0.75168,0.63361 -1.44348,0.63361 H 60.764192 c -0.44074,0 -1.00054,-0.51629 -0.8325,-0.76845 l 7.55992,-11.31855 c 0.26434,-0.39606 0.78486,-0.61188 1.47848,-0.61188 v 0 z m 0,0"
     id="path190" />
  <path
     class="mpg-dashboard-center-icon-styling-13"
     d="m 68.261102,144.04364 -6.97939,10.44871 c -0.10797,0.16192 0.2519,0.49374 0.53601,0.49374 h 62.306968 c 0.55986,0 0.97254,-0.18053 1.16748,-0.51234 l 6.13121,-10.41151 c 0.10239,-0.17308 -0.2718,-0.51205 -0.56303,-0.51205 H 69.456322 c -0.56083,0 -0.98181,0.17413 -1.19521,0.49345 v 0 z m 0,0"
     id="path192" />
  <path
     class="mpg-dashboard-center-icon-styling-14"
     d="m 131.15359,143.64337 -66.690758,11.34272 h 59.661858 c 0.55986,0 0.97254,-0.18053 1.16748,-0.51125 l 6.13219,-10.41259 c 0.0622,-0.10567 -0.0612,-0.29757 -0.27076,-0.41887 v 0 z m 0,0"
     id="path194" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="m 79.156512,142.91762 -8.48392,12.69674 h 1.35541 l 8.486,-12.69674 z m 13.21119,0 -8.48392,12.69674 h 1.35515 l 8.48496,-12.69674 z m 14.134928,0 -8.483918,12.69674 h 1.36151 l 8.484958,-12.69674 h -1.36254 z m 13.54376,0 -8.48392,12.69674 h 1.36047 l 8.486,-12.69674 h -1.36254 z m 0,0"
     id="path196" />
  <path
     class="mpg-dashboard-center-icon-styling-7"
     d="m 142.80535,125.97058 -0.56938,0.1452 0.17407,0.17413 H 79.682412 c -0.69368,0 -1.21427,0.21477 -1.47861,0.61078 l -7.47205,11.18612 -0.534,-0.27687 0.57548,0.8067 c 0.13084,0.18447 0.34742,0.37641 0.70424,0.37641 l 0.28191,-0.005 H 135.3241 c 0.69251,0 1.20273,-0.22376 1.44348,-0.63255 l 6.63501,-11.26892 c 0.0529,-0.09 0.0457,-0.19908 -0.0364,-0.31933 l -0.56083,-0.79633 z m 0,0"
     id="path198" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="m 79.137982,125.49675 h 62.846088 c 0.45422,0 1.03475,0.52773 0.87624,0.79633 l -6.6343,11.26894 c -0.24043,0.40957 -0.75175,0.63361 -1.44316,0.63361 H 70.932012 c -0.44061,0 -1.00073,-0.51629 -0.83269,-0.76845 l 7.56005,-11.31963 c 0.26441,-0.39603 0.78499,-0.61079 1.47861,-0.61079 v 0 z m 0,0"
     id="path200" />
  <path
     class="mpg-dashboard-center-icon-styling-13"
     d="m 78.428682,126.62383 -6.97933,10.44871 c -0.10784,0.16192 0.25287,0.49374 0.53614,0.49374 h 62.306778 c 0.56005,0 0.97254,-0.18157 1.16774,-0.51234 l 6.13206,-10.41125 c 0.10162,-0.17334 -0.2716,-0.51231 -0.56407,-0.51231 H 79.624232 c -0.56083,0 -0.98194,0.17413 -1.19554,0.49345 v 0 z m 0,0"
     id="path202" />
  <path
     class="mpg-dashboard-center-icon-styling-14"
     d="m 141.32156,126.22356 -66.689788,11.34272 h 59.660498 c 0.56005,0 0.97254,-0.18053 1.16774,-0.51125 l 6.13206,-10.41233 c 0.0623,-0.10593 -0.0611,-0.29783 -0.2705,-0.41913 v 0 z m 0,0"
     id="path204" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="m 89.324352,125.49675 -8.48282,12.69781 h 1.35431 l 8.48574,-12.69781 z m 13.211188,0 -8.483858,12.69781 h 1.35509 l 8.484898,-12.69781 z m 14.13492,0 -8.48386,12.69781 h 1.36151 l 8.48457,-12.69781 z m 13.54377,0 -8.48386,12.69781 h 1.36034 l 8.48606,-12.69781 z m 0,0"
     id="path206" />
  <path
     class="mpg-dashboard-center-icon-styling-7"
     d="m 207.78939,143.3904 -0.57023,0.14518 0.17413,0.1752 h -62.72801 c -0.69355,0 -1.21407,0.21473 -1.47848,0.60971 l -7.47172,11.18612 -0.53406,-0.27687 0.57548,0.8067 c 0.13058,0.18447 0.34749,0.37746 0.70392,0.37746 l 0.28223,-0.006 h 63.56459 c 0.69154,0 1.2028,-0.22376 1.44323,-0.63229 l 6.63508,-11.26918 c 0.0528,-0.09 0.0456,-0.19908 -0.036,-0.31931 l -0.56012,-0.79633 z m 0,0"
     id="path208" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="M 144.12221,142.91655 H 206.967 c 0.45416,0 1.03501,0.52773 0.87728,0.79633 l -6.63501,11.26894 c -0.24043,0.40957 -0.75168,0.63361 -1.44323,0.63361 h -63.85077 c -0.4399,0 -1.0008,-0.51629 -0.83282,-0.76845 l 7.56102,-11.31855 c 0.26428,-0.39606 0.78486,-0.61188 1.47874,-0.61188 z m 0,0"
     id="path210" />
  <path
     class="mpg-dashboard-center-icon-styling-13"
     d="m 143.41194,144.04364 -6.97829,10.44871 c -0.10777,0.16192 0.2519,0.49374 0.53484,0.49374 h 62.30814 c 0.55876,0 0.97144,-0.18053 1.16625,-0.51234 l 6.13232,-10.41151 c 0.10175,-0.17308 -0.2718,-0.51205 -0.56401,-0.51205 h -61.40377 c -0.56115,0 -0.98181,0.17413 -1.19547,0.49345 v 0 z m 0,0"
     id="path212" />
  <path
     class="mpg-dashboard-center-icon-styling-14"
     d="m 206.30559,143.64337 -66.69095,11.34272 h 59.66199 c 0.55876,0 0.97144,-0.18053 1.16625,-0.51125 l 6.13232,-10.41259 c 0.0622,-0.10567 -0.0612,-0.29757 -0.26959,-0.41887 v 0 z m 0,0"
     id="path214" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="m 154.30871,142.91762 -8.48392,12.69674 h 1.35502 l 8.48503,-12.69674 z m 13.20982,0 -8.48392,12.69674 h 1.35541 l 8.48567,-12.69674 z m 14.1359,0 -8.48379,12.69674 h 1.36034 l 8.48606,-12.69674 z m 13.54306,0 -8.48392,12.69674 h 1.36047 l 8.48574,-12.69674 h -1.36228 z m 0,0"
     id="path216" />
  <path
     class="mpg-dashboard-center-icon-styling-7"
     d="m 216.73888,125.97058 -0.57023,0.1452 0.1731,0.17413 h -62.72691 c -0.69362,0 -1.21414,0.21477 -1.47854,0.61078 l -7.47172,11.18612 -0.53406,-0.27687 0.57548,0.8067 c 0.13156,0.18447 0.34716,0.37641 0.70386,0.37641 l 0.28223,-0.005 h 63.56466 c 0.69264,0 1.2028,-0.22376 1.44323,-0.63255 l 6.63508,-11.26892 c 0.0528,-0.09 0.0457,-0.19908 -0.0364,-0.31933 l -0.55979,-0.79633 z m 0,0"
     id="path218" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="m 153.07137,125.49675 h 62.84512 c 0.45416,0 1.03501,0.52773 0.87728,0.79633 l -6.63508,11.26894 c -0.24043,0.40957 -0.75168,0.63361 -1.44348,0.63361 h -63.85084 c -0.43951,0 -1.00047,-0.51629 -0.83243,-0.76845 l 7.56096,-11.31963 c 0.26441,-0.39603 0.78486,-0.61079 1.47848,-0.61079 v 0 z m 0,0"
     id="path220" />
  <path
     class="mpg-dashboard-center-icon-styling-13"
     d="m 152.36136,126.62383 -6.97823,10.44871 c -0.10803,0.16192 0.2519,0.49374 0.53484,0.49374 h 62.30807 c 0.55876,0 0.9715,-0.18157 1.16631,-0.51234 l 6.13232,-10.41125 c 0.10175,-0.17334 -0.2718,-0.51231 -0.56401,-0.51231 h -61.40377 c -0.56109,0 -0.98207,0.17413 -1.19554,0.49345 v 0 z m 0,0"
     id="path222" />
  <path
     class="mpg-dashboard-center-icon-styling-14"
     d="m 215.25502,126.22356 -66.69089,11.34272 h 59.66192 c 0.55876,0 0.9715,-0.18053 1.16631,-0.51125 l 6.13232,-10.41233 c 0.0621,-0.10593 -0.0612,-0.29783 -0.26966,-0.41913 v 0 z m 0,0"
     id="path224" />
  <path
     class="mpg-dashboard-center-icon-styling-17"
     d="m 163.25781,125.49675 -8.48354,12.69781 h 1.35502 l 8.48503,-12.69781 h -1.35652 z m 13.21021,0 -8.48399,12.69781 h 1.35548 l 8.48567,-12.69781 z m 14.13597,0 -8.48386,12.69781 h 1.3604 l 8.486,-12.69781 z m 13.54299,0 -8.48392,12.69781 h 1.36047 l 8.48574,-12.69781 h -1.36228 z m 0,0"
     id="path226" />
  <path
     class="mpg-dashboard-center-icon-styling-8"
     d="m 57.534182,193.06278 h 72.026738 c 0.47172,0 0.92407,0.18661 1.25775,0.52054 0.33291,0.33288 0.52059,0.78598 0.52059,1.25769 V 240.7154 H 55.755982 v -45.87439 c 0,-0.47171 0.18761,-0.92481 0.52162,-1.25769 0.33284,-0.33393 0.78493,-0.52054 1.25658,-0.52054 z m 0,0"
     id="path228" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 70.189532,193.06278 -14.43355,13.62686 v 29.96421 l 43.59001,-43.59107 z m 46.212308,0 -47.652628,47.65262 h 13.1594 l 47.652298,-47.65262 h -13.15908 z m 14.93742,32.58651 -14.13894,14.1381 c -0.15054,0.15133 -0.23013,0.31616 -0.17731,0.36899 l 0.55869,0.55901 h 12.49378 l 1.26268,-1.26299 z m 0,0"
     id="path230" />
  <rect
     class="mpg-dashboard-center-icon-styling-1"
     x="79.820137"
     y="193.06171"
     width="2.00438"
     height="47.653412"
     id="rect232" />
  <rect
     class="mpg-dashboard-center-icon-styling-1"
     x="107.53433"
     y="193.06171"
     width="2.00334"
     height="47.653412"
     id="rect234" />
  <path
     class="mpg-dashboard-center-icon-styling-8"
     d="m 169.76555,200.9815 h 19.58892 c 0.80567,0 1.46001,0.65434 1.46001,1.45994 v 38.27395 H 168.3056 v -38.27395 c 0,-0.38672 0.1534,-0.75782 0.42701,-1.03178 0.27504,-0.27364 0.64618,-0.42816 1.03294,-0.42816 z m 0,0"
     id="path236" />
  <path
     class="mpg-dashboard-center-icon-styling-8"
     d="m 222.68643,193.06278 h 20.78135 c 0.49479,0 0.89588,0.40031 0.89588,0.89588 v 46.75674 h -23.30527 v -46.0257 c 0,-0.43136 0.17238,-0.84517 0.4771,-1.15098 0.30601,-0.30473 0.71954,-0.47593 1.15095,-0.47593 v 0 z m 0,0"
     id="path238" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 235.50236,193.06278 -14.44399,14.44497 v 9.84001 l 23.30527,-23.30309 v -0.0871 c -0.001,-0.49451 -0.40212,-0.89482 -0.89698,-0.89482 h -7.96431 z m 8.86129,12.224 -23.30527,23.30524 v 12.12337 h 5.79837 l 17.5069,-17.50609 z m 0,0"
     id="path240" />
  <rect
     class="mpg-dashboard-center-icon-styling-19"
     x="232.71118"
     y="193.06171"
     width="1.40292"
     height="47.653412"
     id="rect242" />
  <path
     class="mpg-dashboard-center-icon-styling-8"
     d="m 233.57197,149.05901 c 0,4.80912 -2.14576,8.70747 -4.79197,8.70747 -1.2703,0 -2.48925,-0.9174 -3.3885,-2.55041 -0.89829,-1.63299 -1.40322,-3.84766 -1.40322,-6.15706 0,-2.30918 0.50493,-4.52481 1.40322,-6.15781 0.89925,-1.633 2.1182,-2.55042 3.3885,-2.55042 2.64621,0 4.79197,3.89933 4.79197,8.70822 v 0 z m 0,0"
     id="path244"
     style="stroke-width:0.922609" />
  <rect
     class="mpg-dashboard-center-icon-styling-20"
     x="45.325871"
     y="166.00519"
     width="158.12296"
     height="8.8424902"
     id="rect246" />
  <path
     class="mpg-dashboard-center-icon-styling-16"
     d="m 203.44805,166.00599 v 8.8417 h 37.9604 c 7.45455,0 11.70989,0.10991 11.70989,5.29243 v 60.57527 h 3.99094 v -74.7094 z m 0,0"
     id="path248" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 228.78001,140.35079 c -0.17776,0.003 -0.35485,0.0238 -0.53094,0.0629 2.31897,0.0404 4.18922,3.89836 4.18922,8.64429 -9e-4,4.7528 -1.87521,8.6127 -4.19681,8.64331 0.17871,0.0401 0.3588,0.0622 0.53853,0.0651 1.27049,0 2.48914,-0.91643 3.38839,-2.5504 0.89835,-1.633 1.40358,-3.84767 1.40358,-6.15806 0,-2.30917 -0.50523,-4.52478 -1.40358,-6.1578 -0.89925,-1.633 -2.1179,-2.5504 -3.38839,-2.54944 v 0 z m 0,0"
     id="path250"
     style="stroke-width:0.922609" />
  <path
     class="mpg-dashboard-center-icon-styling-2"
     d="m 170.61787,218.96537 h 1.62151 c 0.17122,0 0.30906,0.13805 0.30906,0.30902 v 4.67339 c 0,0.17096 -0.13784,0.30899 -0.30906,0.30899 h -1.62151 c -0.17128,0 -0.30899,-0.13803 -0.30899,-0.30899 v -4.67339 c 0,-0.17097 0.13771,-0.30902 0.30899,-0.30902 z m 0,0"
     id="path252" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 175.65309,200.9815 -7.34866,7.34857 v 20.90694 l 22.51004,-22.50891 v -4.28558 c 0,-0.80669 -0.65434,-1.46102 -1.46098,-1.46102 z m 15.16139,19.62858 -20.10633,20.10532 h 12.65003 l 7.4563,-7.45635 v -12.64896 z m 0,0"
     id="path254" />
  <path
     class="mpg-dashboard-center-icon-styling-18"
     d="m 55.502877,70.264968 c -4.33525,0.0064 -8.16981,2.81319 -9.48666,6.94402 -0.23226,-0.02176 -0.46563,-0.03423 -0.69867,-0.03423 -2.78218,0.0053 -5.32464,1.57089 -6.58544,4.05015 -0.75888,-0.18236 -1.53778,-0.27476 -2.31843,-0.27581 -5.5072,10e-4 -9.97193,4.46506 -9.97193,9.97196 0.01348,0.85419 0.12955,1.70044 0.35248,2.51643 0.46161,1.68715 2.73435,2.88352 4.49085,2.88352 h 49.30952 c 1.75637,0 3.9225,-1.26483 4.23467,-2.98625 0.10162,-0.55984 0.15651,-1.12816 0.16078,-1.70149 0,-5.50694 -4.46506,-9.97169 -9.97193,-9.97169 -0.99328,0.0021 -1.97943,0.15448 -2.92812,0.44885 -1.1074,-2.84608 -3.84681,-4.72093 -6.90156,-4.72199 -0.04348,0.0011 -0.08606,0.0053 -0.12851,0.0082 -1.25684,-4.23038 -5.14396,-7.13169 -9.55704,-7.13276 v 0.0011 z m 0,0"
     id="path256" />
  <path
     class="mpg-dashboard-center-icon-styling-18"
     d="m 213.49539,30.173101 c -4.33525,0.0064 -8.16981,2.81319 -9.48666,6.94402 -0.23226,-0.02176 -0.46563,-0.03423 -0.69867,-0.03423 -2.78218,0.0053 -5.32464,1.57089 -6.58544,4.05015 -0.75888,-0.18236 -1.53777,-0.27476 -2.31842,-0.27581 -5.5072,0.001 -9.97193,4.46506 -9.97193,9.97196 0.0135,0.85419 0.12955,1.70044 0.35248,2.51643 0.46161,1.68715 2.73435,2.88352 4.49085,2.88352 h 49.30951 c 1.75637,0 3.9225,-1.26483 4.23467,-2.98625 0.10162,-0.55984 0.15651,-1.12816 0.16078,-1.70149 0,-5.50694 -4.46506,-9.97169 -9.97193,-9.97169 -0.99328,0.0021 -1.97943,0.15448 -2.92812,0.44885 -1.1074,-2.84608 -3.84681,-4.72093 -6.90156,-4.72199 -0.0435,0.0011 -0.0861,0.0053 -0.12851,0.0082 -1.25684,-4.23038 -5.14396,-7.13169 -9.55704,-7.13276 v 0.0011 z m 0,0"
     id="path256-3"
     style="fill:#c6d7e6;fill-rule:evenodd" />
  <path
     class="mpg-dashboard-center-icon-styling-18"
     d="m 144.71527,65.52324 c -3.73683,0.0064 -7.04141,2.42539 -8.17674,5.98501 -0.20006,-0.0186 -0.40134,-0.02897 -0.6025,-0.02897 -2.3973,0.0051 -4.58929,1.35405 -5.67602,3.49115 -0.65428,-0.15767 -1.32515,-0.23758 -1.99796,-0.23758 -4.74696,0 -8.59481,3.84814 -8.59481,8.59484 0.0124,0.73739 0.11088,1.46523 0.30387,2.16921 0.39713,1.45489 2.35589,2.48561 3.86962,2.48561 h 42.50335 c 1.5138,0 3.38014,-1.09099 3.6498,-2.57375 0.0882,-0.48313 0.13486,-0.97364 0.13881,-1.46711 0,-4.74696 -3.84888,-8.59484 -8.59584,-8.59484 -0.85524,0.0011 -1.70556,0.13272 -2.52367,0.38676 -0.95394,-2.45326 -3.31618,-4.06981 -5.94853,-4.07087 -0.0374,0.0021 -0.0749,0.0064 -0.11101,0.0082 -1.08349,-3.64562 -4.43401,-6.14664 -8.23837,-6.14771 v 0 z m 0,0"
     id="path258" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 192.51394,233.67248 c -0.11419,0.53514 0.2678,0.39363 0.59622,0.49277 8.08442,2.44036 12.26939,7.25824 18.81075,11.97416 4.39775,3.1705 9.00278,5.54769 13.96771,7.71713 0.19587,0.83256 -1.45234,-0.0126 -1.37097,0.86006 1.21446,2.72128 3.71309,2.97599 6.3673,3.13373 -0.0698,0.4158 0.0848,0.36676 0.3997,0.39963 l 0.71481,2.80886 29.06266,-0.0114 c 0.60783,3.57217 -0.1092,6.29703 -1.39894,9.59122 l -4.86906,-0.0272 c -0.61498,-0.20751 -0.50489,-2.43155 -1.42592,-2.57063 l -12.68969,0.10113 c -0.43483,0.59874 -1.77135,2.49674 -2.49909,2.49674 h -16.2877 c 0.57471,-3.77143 -1.1268,-7.99161 -4.10125,-10.38613 -2.01067,-1.61867 -4.31555,-2.22372 -6.89043,-2.00252 0.20039,-3.56072 -0.31757,-7.05668 -0.60055,-10.58954 -0.46828,-0.0309 -0.35256,-0.0648 -0.40069,0.29688 -0.0906,0.68068 0.14374,1.40837 0.20185,2.10017 l -26.57991,-0.59946 c 0.0838,-0.59294 0.19799,-1.19542 0.19876,-1.79736 -0.60423,-0.0988 -0.31878,0.15273 -0.40361,0.48786 -0.0912,0.3604 -0.127,0.74548 -0.19484,1.10968 l -11.49956,-0.19157 -10.68367,-0.8075 c 0.0736,-0.61441 0.16359,-1.49004 0.20142,-2.10032 0.0247,-0.3976 -0.0435,-0.31233 -0.39918,-0.2977 -0.67724,4.09153 -1.13536,8.22902 -1.20119,12.38886 -4.47027,0.31163 -9.19304,4.7024 -9.19304,9.29148 v 3.09717 h -2.19834 c -3.12848,-6.50808 -4.08868,-11.9305 -4.09421,-11.95068 -0.24739,-1.52649 -1.11028,-6.80876 2.10392,-13.71758 0.42307,-0.39683 2.25815,-1.1653 2.97262,-1.62364 7.84141,-5.03036 13.19195,-9.33081 23.10147,-9.87203 6.70355,-0.36612 13.66377,0.14253 20.28265,0.19781 z m -20.58443,1.79835 c -2.79377,0.0664 -5.55264,0.56832 -8.19376,1.49867 l -1.58903,7.62182 0.17958,0.58164 20.6718,0.90029 c 0.36842,-0.099 0.26259,-1.68397 0.3228,-2.01029 0.10594,-0.57415 0.28333,-1.15758 0.39969,-1.79835 0.37729,-2.07759 0.98867,-4.54531 1.1991,-6.59397 0.0138,-0.13453 0.075,-0.42404 -0.11681,-0.40275 z m 13.78958,6.59396 c -0.11133,0.72803 -1.07545,3.90324 -0.27189,4.16821 3.8933,-0.056 7.77839,0.38797 11.66327,0.42758 0.57983,0.40691 1.56251,0.14525 2.30548,0.19257 0.25929,0.0165 0.52259,0.20706 0.59233,0.20706 h 4.39667 c 0.19337,0 0.9206,2.10987 1.89732,1.59962 l 0.2011,-1.19998 c 0.0456,-0.004 0.21991,-0.20311 0.48315,-0.20799 0.70479,-0.013 1.41211,0.0237 2.11488,0.008 0.56522,0.0343 1.25394,0.0602 1.79765,-0.0989 -0.5389,-0.74294 -1.34337,-1.15233 -1.99749,-1.69942 -1.39397,-1.16588 -2.57088,-1.95483 -3.99699,-2.99726 -2.60393,-1.90337 -5.18921,-4.04444 -8.1938,-5.39506 -3.15999,-1.42045 -6.51884,-2.05891 -9.99052,-1.79649 -0.30814,2.26517 -0.65563,4.53228 -1.00116,6.79192 z m -24.58143,0.59945 c 0.30016,-1.42728 0.74407,-2.89869 0.99925,-4.39597 0.0313,-0.18347 0.51625,-0.6779 -0.0942,-0.59702 -0.64391,0.0853 -1.50851,0.59391 -2.10818,0.89269 -1.10581,0.55096 -5.89584,2.91012 -6.00178,4.01055 0.1846,1.27343 2.05985,1.61498 3.13344,1.86269 1.17976,0.27222 2.39519,0.35863 3.58451,0.56742 0.61192,-0.10989 0.40426,-1.947 0.48698,-2.34036 z m 76.74192,24.17985 c -1.50647,0.18468 -3.00756,-0.32645 -4.50094,-0.20115 -0.3022,0.0253 -0.57131,-0.1597 -0.49822,0.30106 0.15569,0.98173 3.06428,0.82105 3.91054,0.70782 0.5356,-0.0717 0.84479,-0.31889 1.08862,-0.80773 z m 21.98256,-0.20078 -4.99436,0.29771 c 1.00554,1.32681 3.17573,0.45495 4.66116,0.70813 z"
     id="path4607"
     style="fill:#e1e7f0;stroke-width:0.358479"
     sodipodi:nodetypes="ccsccccccccccscsccscccscccsccsccccsscccccccsssccsccssscccccssscsssssscscsscsssccccc" />
  <path
     class="mpg-dashboard-center-icon-styling-22"
     d="m 192.51394,233.67248 c 8.6454,0.0722 18.41112,-0.61632 26.88736,-0.008 5.25552,0.37736 9.9632,3.50863 14.06097,6.52244 0.95183,0.70007 3.70273,3.27318 4.42309,3.58386 0.2913,0.12565 1.25105,-0.32766 1.88251,-0.31245 0.9357,0.0225 3.48363,0.59693 3.81949,1.59014 0.39325,1.16295 -0.15899,1.66256 -1.31006,1.61285 -0.075,0.33084 0.10632,0.40539 0.3018,0.59546 4.10515,3.99192 13.82355,5.74643 17.08408,10.39342 -0.36245,-0.12446 -0.75398,0.17391 -0.99925,0.19982 -0.0279,-0.3006 -0.57156,-0.3006 -0.59956,0 -0.79446,0.0373 -1.60329,-0.0335 -2.39819,0 -0.46638,-0.27843 -0.94351,-0.49417 -1.39892,-0.79928 -0.21484,-0.14392 -0.30102,-0.60282 -0.68025,-0.59052 -5.29308,0.42124 -10.69496,0.173 -16.01367,-0.0246 -0.40304,0.0373 -0.42158,0.51587 -0.78801,0.819 -1.05948,0.8764 -3.23104,0.62551 -4.60806,0.60518 -0.3849,-0.006 -1.05433,0.004 -1.29236,-0.01 -2.65417,-0.15774 -5.1528,-0.41245 -6.36726,-3.13373 -0.0814,-0.87269 1.5668,-0.0275 1.37097,-0.86006 -4.96493,-2.16944 -9.56996,-4.54663 -13.96771,-7.71713 -6.54136,-4.71592 -10.72633,-9.5338 -18.81076,-11.97416 -0.32842,-0.0991 -0.71041,0.0423 -0.59621,-0.49278 z m 25.58067,0.79926 c -7.05553,-0.10043 -14.12763,0.0733 -21.18393,0.002 0.97544,0.7546 2.25307,1.15383 3.33167,1.76214 5.43502,3.06524 9.65388,7.76992 14.95444,11.02414 h 25.68061 l -12.00785,-9.07476 c -2.51165,-1.54702 -5.20716,-2.9204 -8.1769,-3.31389 -0.053,-0.19279 -0.23068,-0.18927 -0.39971,-0.19981 -0.33012,-0.0206 -0.66763,0.008 -0.99926,0 -0.21741,-0.33575 -0.82177,-0.19445 -1.19907,-0.19982 z"
     id="path4609"
     style="fill:#f3f6fa;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 159.53887,258.24996 c 0.19701,-0.0137 0.40133,2.3e-4 0.59956,0 6.74583,-0.008 10.5093,6.12845 10.19229,12.38866 h 31.77597 v -3.89643 c 0,-3.80546 4.64184,-7.71639 8.19381,-8.29241 0.16072,-0.026 0.36023,-0.17926 0.59954,-0.19982 2.57488,-0.2212 4.87976,0.38386 6.89043,2.00253 2.97445,2.39451 4.67596,6.6147 4.10125,10.38613 h 16.2877 c 0.72774,0 2.06429,-1.898 2.49909,-2.49674 l 12.68969,-0.10114 c 0.92103,0.13909 0.81094,2.36313 1.42592,2.57064 l 4.86906,0.0273 c -0.0998,0.2548 -0.11818,0.95466 -0.32273,1.01143 -1.95647,-0.0158 -3.91774,-0.0206 -5.8726,-0.0124 -5.79212,0.0244 -11.5946,0.006 -17.38682,0 -3.92707,-0.004 -7.86431,0.0279 -11.79112,0 -1.13014,-0.008 -2.26799,0.007 -3.39816,-2.6e-4 0.82607,-4.9219 -1.33724,-10.22028 -6.19457,-11.98876 -0.72527,-0.26405 -0.72745,-0.32803 -1.59879,-0.39964 -0.066,-0.005 -0.13346,0.003 -0.19985,0 -0.30683,-0.33313 -1.28385,-0.33598 -1.5988,0 -0.0661,0.006 -0.13398,-0.007 -0.19985,0 -0.54556,-0.0157 -1.18664,-0.009 -1.59878,0.39964 -0.0647,0.0112 -0.13517,-0.0112 -0.19985,0 -0.15585,0.027 -0.29139,0.081 -0.39969,0.19982 -4.09847,1.25182 -6.7147,7.64731 -5.59578,11.58938 v 0.19982 h -5.59577 c -5.7793,0 -11.67675,0.20872 -17.38684,0.19981 -2.46423,-0.004 -5.0776,-0.18422 -7.59426,-0.19981 -1.19679,-0.007 -2.40078,0.007 -3.59758,-7.3e-4 0.87247,-4.96826 -1.29985,-10.20838 -6.19503,-11.98809 -0.22955,-0.0835 -0.32148,-0.1325 -0.59954,-0.19982 -0.40972,-0.0992 -0.49425,-0.15613 -0.99925,-0.19981 -0.0659,-0.006 -0.13347,0.003 -0.19985,0 -0.30681,-0.33313 -1.28384,-0.33598 -1.59879,0 -0.0659,0.007 -0.13441,-0.008 -0.19984,0 -0.54557,-0.0157 -1.18665,-0.009 -1.59879,0.39963 -4.81095,1.49377 -7.16498,7.29184 -6.19532,11.98902 -0.88216,-3.5e-4 -1.7742,0.0445 -2.6555,-0.0416 -0.58073,-0.1684 -0.55011,-0.69439 -0.74194,-0.95746 h 2.19835 v -3.09716 c 0,-4.58909 4.72277,-8.97987 9.19304,-9.29149 z"
     id="path4613"
     style="fill:#92a9c6;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-22"
     d="m 254.06741,257.25087 c 0.16285,0.0435 0.68086,0.66652 0.99926,0.79927 1.10547,0.46096 3.7765,0.22365 4.99622,0 0.54546,0.97104 0.81547,1.91725 0.99923,2.99725 l -29.06263,0.0114 -0.71484,-2.80885 c 1.29117,0.13475 3.96238,0.30099 5.07413,-0.22175 1.53357,-0.72109 0.36486,-0.79341 2.41231,-0.76752 1.53429,0.0194 4.26127,-0.26256 5.59958,-0.006 0.63479,0.12181 0.94584,1.088 1.79608,1.00132 l 1.20424,-1.00688 c 0.55145,-0.10364 6.27087,-0.11216 6.69642,0.001 z"
     id="path4617"
     style="fill:#f3f6fa;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-19"
     d="m 253.46785,271.6377 c -0.43598,3.51278 -3.35088,5.71346 -6.39515,6.99359 h -4.19682 c -0.87501,-0.5833 -1.85322,-0.73834 -2.78136,-1.31534 -1.93034,-1.20003 -3.53661,-3.46272 -4.01349,-5.67825 5.79222,0.006 11.5947,0.0244 17.38682,0 z"
     id="path4619"
     style="fill:#1a2331;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 259.66318,257.65051 c 0.0659,0.094 0.26657,0.16262 0.39971,0.39963 -1.21972,0.22365 -3.89075,0.46096 -4.99622,0 0.0966,-0.26113 0.38045,-0.19056 0.59951,-0.19981 0.79493,-0.0335 1.60373,0.0373 2.39823,0 0.19767,-0.009 0.40411,0.0207 0.59952,0 0.24527,-0.0259 0.6368,-0.32428 0.99925,-0.19982 z"
     id="path4629"
     style="fill:#4b5c79;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-20"
     d="m 165.33449,228.27742 0.79941,-0.59945 c -0.34362,0.58475 -0.47628,0.38486 -0.79941,0.59945 z"
     id="path4631"
     style="fill:#b2ddae;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-19"
     d="m 197.71002,271.6377 c -0.97307,3.40927 -3.41714,6.14388 -6.99471,6.79378 -1.44188,0.26192 -2.14901,0.26308 -3.59728,0 -3.303,-0.60001 -6.17347,-3.26205 -6.79486,-6.59397 5.7101,0.009 11.60755,-0.19981 17.38685,-0.19981 z"
     id="path4667"
     style="fill:#1a2331;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 152.54417,271.6377 c -1.17418,-6.1507 3.79829,-13.45724 10.59044,-10.68866 6.1104,2.49068 6.82168,12.32631 1.60269,16.18602 l -1.80099,1.29642 c -1.5725,0.0202 -2.43937,0.34234 -4.19682,0 -0.4358,-0.0849 -0.79571,-0.23227 -1.1991,-0.39964 -2.55006,-1.05802 -4.47586,-3.6683 -4.99622,-6.39414 z m 12.99017,1.99817 c 1.01618,-1.65697 1.07333,-2.35823 0.99925,-4.19616 -0.0711,-1.76533 0.0268,-1.98925 -0.7994,-3.59671 -0.83428,-1.62327 -1.64377,-2.57568 -3.39743,-3.19707 -5.54905,-1.96623 -9.39364,4.00463 -8.10316,9.00106 1.44699,5.60239 8.10613,7.19797 11.30074,1.98888 z"
     id="path4671"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 204.10519,271.6377 c -0.0279,-0.13345 -0.0152,-2.3517 0.004,-2.69523 0.20503,-3.61837 2.86206,-7.9676 6.70772,-8.47764 9.35134,-1.24023 12.69631,12.69163 4.40844,17.40605 -0.26937,0.15322 -0.63803,0.0645 -0.52842,0.5606 -1.27377,1.2e-4 -2.79601,0.19849 -4.19682,0.19981 -3.25839,-1.17916 -5.14883,-3.32507 -6.04873,-6.6493 -0.0673,-0.24853 -0.34143,-0.32039 -0.34643,-0.34429 z m 13.19001,1.79835 c 0.95349,-1.68055 1.06343,-2.11752 0.99926,-3.99634 -0.0596,-1.74441 -0.0661,-1.84597 -0.79941,-3.39689 -0.79155,-1.67409 -1.57953,-2.72549 -3.39742,-3.39689 -3.85174,-1.42254 -7.266,1.18685 -8.13424,4.95505 -1.76959,7.68006 7.22138,13.07994 11.33181,5.83507 z"
     id="path4673"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-19"
     d="m 212.89854,259.24904 c 0.0664,0.003 0.13382,-0.005 0.19984,0 l 1.59879,0.39964 c 4.85734,1.76848 7.02065,7.06686 6.19458,11.98876 1.13017,0.007 2.26802,-0.008 3.39816,2.6e-4 -0.36224,3.13164 -2.91766,6.05313 -5.99545,6.79378 h -3.59728 c -0.10962,-0.49608 0.25904,-0.40738 0.5284,-0.5606 8.28787,-4.71442 4.9429,-18.64628 -4.40843,-17.40606 -3.84566,0.51004 -6.50269,4.85928 -6.70772,8.47765 -0.0195,0.34352 -0.0322,2.56178 -0.004,2.69523 h -0.59956 l -0.19985,-0.19983 c -1.11892,-3.94207 1.4973,-10.33754 5.59577,-11.58938 0.14648,-0.0447 0.32213,0.006 0.39969,-0.19981 0.0647,-0.0112 0.13518,0.0112 0.19986,0 0.4961,-0.0859 1.27744,-0.36643 1.59879,-0.39964 0.0659,-0.007 0.13375,0.006 0.19985,0 0.47983,-0.0431 1.10847,-0.0246 1.59879,0 z"
     id="path4679"
     style="fill:#1a2331;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-19"
     d="m 161.13766,259.24904 c 0.0663,0.003 0.13395,-0.006 0.19986,0 0.17186,0.35207 0.70068,0.14945 0.99924,0.19982 0.0957,0.0162 0.35495,0.29832 0.59955,0.19982 4.89518,1.77971 7.06749,7.01982 6.19502,11.98809 1.1968,0.007 2.4008,-0.007 3.59758,7.2e-4 -0.79971,3.09205 -2.92384,6.1067 -6.19532,6.79378 -1.19503,-0.0121 -2.40235,-0.0154 -3.59728,0 l 1.80099,-1.29642 c 5.21898,-3.8597 4.50771,-13.69533 -1.60269,-16.18602 -6.79215,-2.76858 -11.76463,4.53795 -10.59044,10.68866 -0.33306,-9e-5 -0.66619,1.4e-4 -0.99925,0 -0.96966,-4.69718 1.38436,-10.49525 6.19531,-11.98901 0.29084,-0.0903 1.35883,-0.36911 1.59879,-0.39964 0.0655,-0.008 0.13393,0.007 0.19985,0 0.46961,-0.0485 1.11353,-0.023 1.59879,0 z"
     id="path4681"
     style="fill:#1a2331;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 196.71077,237.06936 c 3.00459,1.35061 5.58987,3.49169 8.1938,5.39506 -0.20737,0.33087 -0.75832,0.19974 -1.0963,0.20329 -5.91907,0.0623 -11.77988,0.24495 -17.68949,-0.20329 l 1.22677,-6.76678 c 2.92854,-0.24276 5.75471,0.37519 8.49287,1.34527 0.2556,0.0906 0.67908,0.44898 0.87235,0.0265 z"
     id="path4711"
     style="fill:#92a9c6;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 174.32769,235.67064 c 3.51834,-0.12848 7.07109,0.0954 10.59199,0 -0.21042,2.04866 -0.8218,4.51638 -1.19909,6.59396 -6.23717,-0.87288 -12.79894,-1.73304 -18.18625,-5.19524 3.03914,-0.97304 5.5746,-1.28118 8.79335,-1.39872 z"
     id="path4713"
     style="fill:#92a9c6;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 165.53434,237.06936 c 5.38731,3.4622 11.94908,4.32236 18.18625,5.19524 -0.11636,0.64078 -0.29375,1.22421 -0.39969,1.79835 l -20.18572,-1.19799 c -0.18714,-0.19017 0.66156,-4.90816 0.83934,-5.25711 0.31171,-0.61183 1.10934,-0.39426 1.55982,-0.53849 z"
     id="path4715"
     style="fill:#6a7e99;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-6"
     d="m 210.10065,250.05747 c 0.0675,0.80394 0.14721,1.58699 0.19985,2.3978 l -27.17945,-0.59945 c 0.10891,-0.80332 0.28783,-1.60577 0.39969,-2.39781 z"
     id="path4717"
     style="fill:#e6f1f5;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-6"
     d="m 183.12105,249.2582 c -0.16134,0.86628 -0.27035,1.72734 -0.3997,2.59762 l -13.69789,-0.39139 -8.48534,-0.80752 c 0.0831,-0.83579 0.30503,-1.60746 0.3997,-2.3978 l 10.68367,0.80751 z"
     id="path4721"
     style="fill:#e6f1f5;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 171.92951,235.47083 c 0.74025,-0.0176 1.81442,-0.15312 2.39818,0.19981 -3.21875,0.11754 -5.75421,0.42568 -8.79335,1.39872 -0.45048,0.14423 -1.24811,-0.0733 -1.55982,0.53849 -0.17778,0.34895 -1.02648,5.06694 -0.83934,5.25711 l 20.18572,1.19799 c -0.0602,0.32633 0.0456,1.91126 -0.3228,2.0103 l -20.6718,-0.90029 -0.17958,-0.58165 1.58903,-7.62181 c 2.64112,-0.93035 5.39999,-1.43226 8.19376,-1.49868 z"
     id="path4723"
     style="fill:#4b5c79;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 204.90457,242.46442 c 1.42611,1.04242 2.60302,1.83139 3.99699,2.99725 h -2.59804 c -0.30317,-1.10839 -0.80448,-2.12263 -2.10144,-2.21084 -1.10951,-0.0755 -3.91659,1.05285 -4.49357,2.01103 l -13.98876,-1.00041 c 0.17303,-0.60976 0.24007,-1.15839 0.19919,-1.79703 h 0.19984 c 5.90961,0.44824 11.77042,0.26556 17.68949,0.2033 0.33798,-0.004 0.88893,0.12757 1.0963,-0.2033 z"
     id="path4725"
     style="fill:#6a7e99;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 185.91893,242.46442 c 0.0409,0.63864 -0.0262,1.18727 -0.19918,1.79703 l 13.98875,1.00041 c -0.11162,0.18537 -0.32402,0.93447 0,0.99909 -0.0177,0.0116 0.0799,0.34626 -0.13112,0.40271 -0.44885,0.12007 -1.86175,0.003 -2.46692,-0.003 -3.88487,-0.0396 -7.76997,-0.4836 -11.66326,-0.42758 -0.80357,-0.26495 0.16055,-3.44017 0.27188,-4.16821 0.19209,0.054 0.189,0.23031 0.19985,0.39964 z"
     id="path4727"
     style="fill:#4b5c79;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 161.13766,242.66424 c -0.0827,0.39336 0.12495,2.23047 -0.48698,2.34036 -1.18931,-0.20879 -2.40475,-0.2952 -3.58451,-0.56742 -1.07358,-0.24771 -2.94884,-0.58926 -3.13344,-1.86269 0.10594,-1.10043 4.89598,-3.45959 6.00179,-4.01055 0.59966,-0.29878 1.46427,-0.80737 2.10817,-0.89269 0.61047,-0.0809 0.12548,0.41355 0.0942,0.59702 -0.87979,0.3322 -5.82366,2.59042 -5.97098,3.12631 -0.13855,0.50397 0.12302,0.52549 0.47625,0.66915 1.25182,0.50913 3.14041,0.34408 4.49549,0.6005 z"
     id="path4729"
     style="fill:#4b5c79;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-6"
     d="m 206.30352,245.46167 c 0.10671,0.39016 -0.10903,1.12018 0.22825,1.57085 0.68667,0.1099 1.3969,-0.04 2.08583,0.0197 0.25561,0.0222 0.45714,0.20622 0.48381,0.20783 -0.70278,0.0156 -1.41009,-0.0212 -2.11489,-0.008 -0.26324,0.005 -0.43757,0.2033 -0.48315,0.20798 -0.9866,0.10135 -0.97679,-0.83449 -1.40592,-1.092 -0.50482,-0.30291 -5.16207,-0.25535 -5.38894,-0.1069 -0.32402,-0.0646 -0.11162,-0.81372 0,-0.99909 0.57698,-0.95817 3.38407,-2.08649 4.49358,-2.01103 1.29696,0.0882 1.79826,1.10245 2.10143,2.21085 z"
     id="path4733"
     style="fill:#e6f1f5;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 254.26726,257.05106 -0.19985,0.19981 c -0.42555,-0.11365 -6.14497,-0.10514 -6.69642,-0.001 l -1.20424,1.00687 c -0.85024,0.0867 -1.16129,-0.8795 -1.79608,-1.00131 -1.33831,-0.2568 -4.06529,0.0252 -5.59958,0.006 -2.04745,-0.0259 -0.87874,0.0464 -2.41231,0.76752 -1.11175,0.52275 -3.78296,0.3565 -5.07413,0.22174 -0.31492,-0.0329 -0.46949,0.0162 -0.3997,-0.39963 0.23803,0.0142 0.90742,0.004 1.29232,0.01 1.37702,0.0203 3.54858,0.27122 4.60806,-0.60518 0.36643,-0.30313 0.38501,-0.78177 0.78801,-0.81899 5.31875,0.19754 10.72062,0.44579 16.01367,0.0246 0.37923,-0.0123 0.46541,0.44661 0.68025,0.59053 z"
     id="path4735"
     style="fill:#4b5c79;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 162.13691,238.26827 c -0.25518,1.49728 -0.69909,2.96869 -0.99925,4.39597 -1.35507,-0.25642 -3.24365,-0.0914 -4.49548,-0.60051 -0.35322,-0.14366 -0.61479,-0.16517 -0.47625,-0.66915 0.14732,-0.53589 5.0912,-2.79411 5.97098,-3.12631 z"
     id="path4737"
     style="fill:#6a7e99;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 183.12105,249.2582 c 0.0678,-0.36421 0.1036,-0.74929 0.19484,-1.10969 0.0848,-0.33512 -0.20062,-0.58661 0.40361,-0.48786 -7.2e-4,0.60195 -0.11501,1.20442 -0.19876,1.79736 -0.11186,0.79204 -0.29078,1.59449 -0.39969,2.39781 -0.4888,3.60528 -0.86712,7.14229 -0.99925,10.79011 -0.0384,1.06002 0.0154,2.13563 0,3.19707 -0.01,0.66188 0.0795,1.47818 3.6e-4,2.10202 -0.0371,0.29244 -0.15329,0.61789 -0.39905,0.29475 -0.009,-0.86304 0.009,-1.73355 -7.3e-4,-2.59658 -0.0117,-0.99355 -0.0247,-2.00431 0,-2.99726 0.0916,-3.67434 0.4604,-7.1646 0.99924,-10.79011 0.12935,-0.87028 0.23836,-1.73134 0.3997,-2.59762 z"
     id="path4739"
     style="fill:#b2c8de;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-1"
     d="m 196.71077,237.06936 c -0.19327,0.42254 -0.61675,0.0641 -0.87235,-0.0265 -2.73816,-0.97008 -5.56433,-1.58802 -8.49287,-1.34526 l -1.22677,6.76677 h -0.19984 c -0.0108,-0.16932 -0.008,-0.34567 -0.19985,-0.39964 0.34553,-2.25964 0.69302,-4.52674 1.00116,-6.79192 3.47169,-0.26242 6.83054,0.37604 9.99053,1.7965 z"
     id="path4741"
     style="fill:#4e709b;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-30"
     d="m 206.50337,247.45985 -0.2011,1.19998 c -0.97672,0.51025 -1.70395,-1.59962 -1.89732,-1.59962 h -4.39667 c -0.0698,0 -0.33304,-0.19054 -0.59233,-0.20706 -0.74297,-0.0473 -1.72565,0.21434 -2.30548,-0.19257 0.60517,0.006 2.01806,0.12315 2.46691,0.003 0.211,-0.0564 0.1134,-0.39111 0.13113,-0.40272 0.22687,-0.14844 4.88412,-0.196 5.38893,0.10692 0.42914,0.2575 0.41933,1.19334 1.40593,1.09199 z"
     id="path4743"
     style="fill:#d4e0ec;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 208.90156,245.46167 c 0.65413,0.5471 1.45859,0.95648 1.99749,1.69943 -0.54371,0.15907 -1.23243,0.13323 -1.79765,0.0989 -0.0267,-0.001 -0.2282,-0.18569 -0.4838,-0.20783 -0.68893,-0.0597 -1.39917,0.0902 -2.08583,-0.0197 -0.33728,-0.45067 -0.12154,-1.18069 -0.22826,-1.57084 h 2.59804 z"
     id="path4745"
     style="fill:#4b5c79;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 159.53887,258.24996 c 0.0658,-4.15984 0.52396,-8.29732 1.20119,-12.38886 0.35566,-0.0146 0.42382,-0.0999 0.39918,0.29771 -0.0378,0.61028 -0.12783,1.4859 -0.20142,2.10031 -0.0947,0.79034 -0.31656,1.56201 -0.3997,2.3978 -0.11509,1.15702 -0.24862,2.33364 -0.40794,3.48856 l 0.008,4.10448 c -0.19822,2.3e-4 -0.40253,-0.0137 -0.59954,0 z"
     id="path4747"
     style="fill:#b2c8de;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-1"
     d="m 171.92951,235.47083 12.87337,-0.20294 c 0.19181,-0.0213 0.13063,0.26822 0.11681,0.40275 -3.52091,0.0954 -7.07365,-0.12848 -10.59199,0 -0.58377,-0.35293 -1.65794,-0.21741 -2.39819,-0.19981 z"
     id="path4751"
     style="fill:#4e709b;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 210.10065,250.05747 c -0.0581,-0.69179 -0.2924,-1.41948 -0.20185,-2.10017 0.0482,-0.36166 -0.0676,-0.3278 0.40069,-0.29687 0.28298,3.53285 0.80094,7.0288 0.60055,10.58953 -0.2393,0.0205 -0.43882,0.17376 -0.59954,0.19982 0.47922,-1.94791 0.12757,-4.02969 0,-5.99451 -0.0527,-0.81081 -0.13232,-1.59386 -0.19985,-2.3978 z"
     id="path4755"
     style="fill:#b2c8de;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-22"
     d="m 259.86214,266.64331 -0.3332,1.00584 c -1.48539,-0.25318 -3.65562,0.61868 -4.66112,-0.70814 z"
     id="path4757"
     style="fill:#f3f6fa;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-22"
     d="m 237.87958,266.84409 c -0.24383,0.48884 -0.55302,0.73606 -1.08862,0.80773 -0.84623,0.11323 -3.75485,0.27391 -3.91054,-0.70782 -0.0731,-0.46076 0.19602,-0.2757 0.49822,-0.30106 1.49338,-0.1253 2.99447,0.38583 4.50094,0.20115 z"
     id="path4759"
     style="fill:#f3f6fa;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 218.09461,234.47174 c 0.21889,0.3384 0.82117,0.19099 1.19907,0.19982 0.33163,0.008 0.66914,-0.0206 0.99926,0 0.0514,0.20067 0.23334,0.17777 0.39971,0.19981 2.96974,0.39349 5.66525,1.76687 8.1769,3.31389 l 12.00785,9.07477 h -25.68061 c -5.30056,-3.25423 -9.51942,-7.95891 -14.95444,-11.02415 -1.0786,-0.60831 -2.35623,-1.00754 -3.33167,-1.76214 7.0563,0.0713 14.1284,-0.10244 21.18393,-0.002 z m 14.78882,7.59305 0.19885,-0.29846 c -0.0305,-0.12569 -0.1887,-0.0905 -0.19885,-0.10118 -1.06532,-1.11697 -4.54275,-3.31798 -5.99122,-4.10052 -1.57404,-0.85041 -5.39944,-2.49344 -7.09888,-2.49344 h -11.29147 c 4.48597,3.52266 10.52121,5.28582 16.12108,6.1611 2.74247,0.42867 5.5201,0.5462 8.26049,0.83249 z"
     id="path4767"
     style="fill:#6a7e99;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 255.66618,257.85033 c -0.21906,0.009 -0.50294,-0.0613 -0.59951,0.19981 -0.3184,-0.13275 -0.83641,-0.75577 -0.99926,-0.79927 l 0.19985,-0.19981 c 0.45541,0.3051 0.93254,0.52084 1.39892,0.79927 z"
     id="path4769"
     style="fill:#6a7e99;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-29"
     d="m 219.29368,234.67156 c -0.3779,-0.009 -0.98018,0.13858 -1.19907,-0.19982 0.3773,0.005 0.98162,-0.13592 1.19907,0.19982 z"
     id="path4771"
     style="fill:#bbcee0;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-6"
     d="m 258.66393,257.85033 c -0.19541,0.0207 -0.40185,-0.009 -0.59956,0 0.0279,-0.3006 0.57156,-0.3006 0.59956,0 z"
     id="path4773"
     style="fill:#e6f1f5;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-29"
     d="m 220.69265,234.87137 c -0.16637,-0.022 -0.34834,7.2e-4 -0.39971,-0.19981 0.16903,0.0105 0.3468,0.007 0.39971,0.19981 z"
     id="path4775"
     style="fill:#bbcee0;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 182.72135,251.85582 c -0.53885,3.62551 -0.90768,7.11577 -0.99925,10.79011 -1.27891,-0.3059 -7.96558,0.49765 -7.99597,2.09611 2.57403,0.72974 5.3278,0.84739 7.99597,0.90115 0.0101,0.86303 -0.008,1.73354 7.3e-4,2.59658 0.24576,0.32314 0.36198,-0.002 0.39905,-0.29475 0.0791,-0.62384 -0.01,-1.44014 -3.5e-4,-2.10202 5.24706,-0.0837 10.58929,0.66135 15.79003,-0.10189 0.0241,-0.39474 -0.36337,-0.45221 -0.64018,-0.55882 -1.49297,-0.57503 -3.92086,-0.93294 -5.55245,-1.24221 -3.16525,-0.59999 -6.38628,-1.04947 -9.5974,-1.29415 0.13212,-3.64783 0.51044,-7.18483 0.99924,-10.79012 l 27.17945,0.59945 c 0.12757,1.96483 0.47922,4.0466 0,5.99451 -3.55197,0.57602 -8.1938,4.48696 -8.1938,8.29241 v 3.89643 h -31.776 c 0.31702,-6.2602 -3.44645,-12.39639 -10.19229,-12.38865 l -0.008,-4.10449 c 0.15931,-1.15492 0.29284,-2.33153 0.40794,-3.48856 l 8.48533,0.80752 13.6979,0.39138 z"
     id="path4783"
     style="fill:#e1e7f0;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 161.13766,259.24904 c -0.48525,-0.0231 -1.12918,-0.0485 -1.59879,0 0.31495,-0.33598 1.29198,-0.33313 1.59879,0 z"
     id="path4785"
     style="fill:#4b5c79;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 212.89854,259.24904 c -0.49032,-0.0246 -1.11897,-0.0431 -1.5988,0 0.31495,-0.33598 1.29197,-0.33313 1.5988,0 z"
     id="path4787"
     style="fill:#4b5c79;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-28"
     d="m 162.33676,259.44886 c -0.29856,-0.0504 -0.82738,0.15224 -0.99924,-0.19982 0.50499,0.0436 0.58952,0.10063 0.99924,0.19982 z"
     id="path4789"
     style="fill:#323a4b;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-28"
     d="m 211.09989,259.24904 c -0.32134,0.0332 -1.10268,0.31376 -1.59879,0.39964 0.41215,-0.40845 1.05323,-0.41536 1.59879,-0.39964 z"
     id="path4791"
     style="fill:#323a4b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-28"
     d="m 214.69718,259.64868 -1.59879,-0.39964 c 0.87135,0.0716 0.87352,0.13558 1.59879,0.39964 z"
     id="path4793"
     style="fill:#323a4b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-28"
     d="m 159.33903,259.24904 c -0.23997,0.0305 -1.30796,0.30933 -1.59879,0.39964 0.41215,-0.40845 1.05323,-0.41536 1.59879,-0.39964 z"
     id="path4795"
     style="fill:#323a4b;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-5"
     d="m 162.93631,259.64868 c -0.2446,0.0985 -0.50382,-0.18367 -0.59955,-0.19982 0.27806,0.0673 0.37,0.11636 0.59955,0.19982 z"
     id="path4797"
     style="fill:#33425d;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-28"
     d="m 209.30125,259.64868 c -0.0776,0.20597 -0.25322,0.15508 -0.39969,0.19981 0.1083,-0.11885 0.24384,-0.17288 0.39969,-0.19981 z"
     id="path4799"
     style="fill:#323a4b;stroke-width:0.358479;stroke:none" />
  <polygon
     class="mpg-dashboard-center-icon-styling-23"
     points="963.4444,448.709 963.4444,448.15159 964.00189,448.709 "
     id="polygon4801"
     style="fill:#252c3b"
     transform="matrix(0.35847865,0,0,0.35847865,-142.06846,110.7851)" />
  <path
     class="mpg-dashboard-center-icon-styling-24"
     d="m 162.33676,262.64593 c -0.04,0.12821 -0.18548,0.28823 -0.19985,0.39964 -0.0722,0.55971 -0.33386,4.41025 -0.19784,4.59574 l 3.59527,-1.79831 h 0.19985 c 0.82615,1.60746 0.72825,1.83138 0.7994,3.59671 h -0.19985 l -3.59722,0.80129 c 0.72279,1.11469 1.66358,2.06253 2.59797,2.99523 0.0811,0.0809 0.12127,0.28962 0.19985,0.39964 -3.19461,5.2091 -9.85375,3.61352 -11.30074,-1.98887 -1.29048,-4.99643 2.55411,-10.9673 8.10316,-9.00106 z m 0,7.79287 c 0.16621,-0.15697 0.1503,-0.494 0.34294,-0.60052 0.4764,-0.26343 3.23838,-0.53078 3.42813,-0.82367 0.20932,-0.4043 -0.3453,-2.51375 -0.66714,-2.54324 -0.80889,0.0622 -4.12842,2.68373 -4.06209,0.73244 0.022,-0.64635 0.55674,-4.07715 0.33605,-4.33643 -0.88362,-0.28181 -1.66886,-0.28247 -2.55243,8e-5 l 0.35596,4.95156 c -0.44351,0.70465 -3.30953,-1.12079 -3.96948,-1.29474 -0.23468,-0.0618 -0.34532,-0.15867 -0.50412,0.11869 l -0.48661,2.38274 c 0.12126,0.14121 3.08389,0.52706 3.63341,0.81142 1.22355,0.63317 -2.06127,3.25514 -2.41376,3.8966 l 1.86279,1.89694 c 0.26552,-0.004 1.77297,-3.02373 2.12126,-3.46983 0.33117,-0.42417 0.86292,-0.49886 1.27882,-0.12491 0.42315,0.38047 1.66098,3.22771 1.89973,3.39707 0.598,0.0296 2.05089,-1.43536 1.9745,-1.86921 -0.43245,-0.81204 -2.41446,-2.3778 -2.57796,-3.12499 z m -3.59829,-7.39219 c -1.52789,0.28382 -2.72272,1.63697 -3.39666,2.99288 l 3.59552,1.60182 z m -0.59873,7.19453 -3.59576,-0.8007 c -0.0921,1.32837 0.3438,2.58656 0.80092,3.7952 0.23727,0.17896 0.75061,-0.43626 0.89894,-0.59639 0.20251,-0.21859 2.00368,-2.28973 1.8959,-2.39811 z m 2.29846,1.80014 -2.29365,3.6939 c 1.2916,0.87015 3.32867,0.9566 4.58472,7.2e-4 l -2.29108,-3.69455 z"
     id="path4891"
     style="fill:#769ac9;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 165.73419,265.843 h -0.19985 c -0.8027,-1.17249 -1.89263,-2.60428 -3.39743,-2.79743 0.0144,-0.11141 0.15982,-0.27143 0.19985,-0.39964 1.75366,0.62139 2.56315,1.5738 3.39743,3.19707 z"
     id="path4893"
     style="fill:#6a7e99;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 165.53434,273.63587 c -0.0786,-0.11002 -0.11879,-0.31872 -0.19985,-0.39964 0.82289,-1.01698 1.05614,-2.51345 0.99925,-3.79652 h 0.19985 c 0.0741,1.83793 0.017,2.53919 -0.99925,4.19616 z"
     id="path4895"
     style="fill:#4b5c79;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-24"
     d="m 214.09763,262.64593 c -0.0395,0.12774 -0.18663,0.28962 -0.19986,0.39964 -0.17357,1.44401 -0.0706,2.96619 -0.39903,4.39456 1.29595,-0.0156 2.34569,-1.0768 3.59661,-1.39731 0.11077,-0.0284 0.2728,0.0191 0.3997,0 0.7333,1.55092 0.73983,1.65248 0.79941,3.39689 h -0.19985 l -3.59709,0.80143 c -0.16661,0.1677 2.25939,2.73444 2.59783,2.99509 0.0726,0.0559 0.12615,0.14311 0.19985,0.19982 -4.11044,7.24487 -13.1014,1.84499 -11.33182,-5.83507 0.86825,-3.7682 4.2825,-6.37759 8.13425,-4.95505 z m -0.99924,5.19524 0.41145,-4.88082 c -0.0721,-0.23737 -2.48452,-0.5433 -2.61719,0.018 l 0.402,4.85252 c -0.57268,0.78975 -3.39603,-1.2931 -4.12769,-1.364 -0.66683,-0.0646 -0.96054,2.04043 -0.84436,2.55557 l 3.76108,0.83249 c 0.69262,0.81481 -2.11888,3.20058 -2.53289,3.87797 l 1.85085,1.89746 c 0.23553,-0.004 1.96405,-3.57972 2.43152,-3.76063 0.19979,-0.0773 0.64072,-0.0975 0.82678,0.01 l 2.14959,3.5526 c 0.83754,-0.30974 1.42588,-0.98406 1.85966,-1.73389 0.089,-0.57953 -3.52448,-3.18811 -2.23257,-3.86646 l 3.43591,-0.81435 c 0.006,-0.56906 -0.12869,-2.64626 -0.92587,-2.43877 -0.98351,0.25602 -2.12195,1.23244 -3.04248,1.3752 -0.37055,0.0575 -0.60875,-0.12151 -0.8058,-0.11288 z m -2.59904,-4.79487 c -1.51981,0.19806 -2.72491,1.68913 -3.39667,2.99319 l 3.59551,1.60182 z m -0.59876,7.19484 -3.59575,-0.80068 c -0.15497,1.34322 0.35482,2.5699 0.80093,3.79518 0.35013,0.0703 0.49187,-0.1815 0.69974,-0.39598 0.19874,-0.20505 2.21386,-2.48127 2.09508,-2.59852 z m 2.29843,1.8001 -2.27348,3.69664 c 0.0562,0.74271 4.04113,0.95414 4.5646,-0.002 z"
     id="path4897"
     style="fill:#769ac9;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 217.49505,266.04282 c -0.1269,0.0191 -0.28893,-0.0284 -0.3997,0 -0.24825,-1.36639 -1.83841,-2.79962 -3.19758,-2.99725 0.0132,-0.11001 0.16035,-0.2719 0.19986,-0.39964 1.81789,0.6714 2.60587,1.72279 3.39742,3.39689 z"
     id="path4899"
     style="fill:#6a7e99;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-25"
     d="m 217.2952,273.43605 c -0.0737,-0.0567 -0.12729,-0.14395 -0.19985,-0.19982 0.82289,-1.01698 1.05615,-2.51345 0.99926,-3.79652 h 0.19985 c 0.0642,1.87883 -0.0457,2.31579 -0.99926,3.99634 z"
     id="path4901"
     style="fill:#4b5c79;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-8"
     d="m 141.27584,212.85833 c 0.21719,0.33519 0.82198,0.19518 1.19909,0.19981 2.51015,0.0308 5.06332,0.30327 5.74539,3.14738 0.50575,2.10893 0.51624,6.98118 -0.005,9.08643 -0.34959,1.41274 -1.09856,2.40021 -2.5431,2.75246 -0.67604,0.16485 -1.68835,0.14127 -2.39819,0.19981 -0.43193,0.0356 -0.87682,-0.0411 -1.31194,-0.008 l -0.48669,0.2078 c -0.3392,0.0427 -0.69933,-0.19169 -0.99925,-0.19982 h -0.59955 c -3.04585,-0.0174 -4.70528,-0.47553 -5.19522,-3.69746 -0.33549,-2.20624 -0.38405,-6.80888 0.29595,-8.89398 0.79018,-2.42295 4.06889,-2.66965 6.29822,-2.79446 z m 4.59652,1.79835 c -1.67709,-1.09367 -7.53537,-1.22153 -9.06245,-0.0119 -0.20845,0.16512 -0.10788,0.38774 -0.1306,0.41148 -0.0773,0.0432 -0.13014,0.15177 -0.19985,0.19982 -0.0487,0.0725 -0.16818,0.13198 -0.19985,0.19981 -0.0658,0.0607 -0.14829,0.12945 -0.19985,0.19982 -0.6695,0.91375 -0.73488,1.93992 -0.80775,3.08881 -0.12251,1.93142 -0.17766,4.97355 0.60791,6.70222 0.0704,0.15484 0.0828,0.23442 0.19984,0.39963 0.0518,0.0732 0.13494,0.1356 0.19985,0.19982 0.0382,0.0687 0.14305,0.12881 0.19985,0.19982 0.0694,0.0491 0.12351,0.1603 0.19985,0.19982 0.0241,0.0239 -0.0845,0.26011 0.12667,0.41361 1.14527,0.83241 8.40296,0.87372 9.41828,-0.0672 0.0972,-0.09 0.0198,-0.31161 0.0478,-0.34639 0.079,-0.0376 0.13386,-0.15727 0.19985,-0.19981 0.0383,-0.064 0.16068,-0.11922 0.19984,-0.19982 0.0326,-0.028 0.26134,0.0852 0.41387,-0.12643 0.97142,-1.34783 0.77373,-6.61009 0.56008,-8.34029 -0.10351,-0.83826 -0.21639,-0.92399 -0.57425,-1.52412 -0.0494,-0.20132 -0.13493,-0.2664 -0.19984,-0.39964 -0.0284,-0.0582 0.0591,-0.23533 -0.0553,-0.34559 -0.0974,-0.0939 -0.29651,-0.0231 -0.34444,-0.0541 -0.0421,-0.0479 -0.009,-0.30864 -0.19994,-0.49253 -0.11926,-0.11511 -0.33394,-0.0641 -0.3996,-0.10692 z"
     id="path4907"
     style="fill:#ffffff;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-8"
     d="m 145.87236,214.65668 c 0.0411,0.0223 0.0687,0.25672 0.59955,0.59945 0.11533,0.13121 0.37217,0.35889 0.3997,0.39963 0.0498,0.0738 0.11487,0.25713 0.19984,0.39964 0.12381,0.50505 0.3997,2.06537 0.3997,2.49771 v 4.59579 c 0,0.57917 -0.51813,2.31849 -0.7994,2.89734 -0.0721,0.062 -0.13941,0.16085 -0.19984,0.19982 -0.0362,0.0605 -0.14006,0.1256 -0.19985,0.19982 -1.09294,0.52064 -2.86374,0.76818 -4.08688,0.8085 -1.45314,0.0479 -4.24232,-0.15449 -5.50587,-0.8085 -0.0644,-0.064 -0.14538,-0.13172 -0.19985,-0.19982 -0.0666,-0.0471 -0.13545,-0.1361 -0.19985,-0.19982 -0.0431,-0.0774 -0.16967,-0.13659 -0.19985,-0.19981 -0.0484,-0.10144 -0.19487,-0.37786 -0.19984,-0.39964 -0.0256,-0.11222 -0.19985,-1.42303 -0.19985,-1.49863 v -6.59395 c 0,-0.0872 0.34452,-1.54833 0.39969,-1.69845 0.0192,-0.0523 0.16127,-0.11718 0.19985,-0.19981 0.0684,-0.0631 0.13352,-0.1541 0.19985,-0.19982 0.0409,-0.0609 0.13655,-0.13368 0.19985,-0.19982 1.49138,-0.83332 4.19834,-1.12025 5.89231,-0.99605 0.37145,0.0273 3.1428,0.51077 3.30074,0.59642 z m -4.19612,5.39369 0.70074,-3.59132 c -0.54275,0.99708 -2.72953,3.56657 -2.90361,4.48946 -0.11458,0.60739 1.42468,0.17944 1.80319,0.30231 l -0.59825,3.59649 2.99292,-4.49967 c 0.19469,-0.63093 -1.79195,-0.12165 -1.99499,-0.29727 z"
     id="path4909"
     style="fill:#ffffff;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-9"
     d="m 142.47493,212.85833 c -0.39757,0.0152 -0.80195,-0.0223 -1.19909,0 -2.22934,0.1248 -5.50805,0.3715 -6.29822,2.79446 -0.68,2.08509 -0.63144,6.68773 -0.29595,8.89397 0.48994,3.22194 2.14936,3.68011 5.19522,3.69747 l 0.29533,0.18255 c 0.14836,0.007 0.26691,-0.18356 0.30422,-0.18255 0.29991,0.008 0.66005,0.24255 0.99924,0.19981 l 1.19811,0.002 0.001,0.19781 h -5.29609 c -0.094,0 -1.32185,-0.23656 -1.51142,-0.28717 -1.21648,-0.32475 -2.12963,-1.07057 -2.49158,-2.30442 -0.57827,-1.97125 -0.60332,-8.64837 0.003,-10.59946 0.95139,-3.062 5.40763,-2.82486 7.99995,-2.79778 0.33778,0.004 0.88867,-0.12762 1.0963,0.20329 z"
     id="path4911"
     style="fill:#b2c8de;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-3"
     d="m 142.47493,212.85833 v 0.19981 c -0.37711,-0.004 -0.9819,0.13538 -1.19909,-0.19981 0.39714,-0.0223 0.80152,0.0152 1.19909,0 z"
     id="path4915"
     style="fill:#d6e3f1;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-6"
     d="m 182.1218,262.64593 c 3.21113,0.24469 6.43216,0.69416 9.59741,1.29415 1.63159,0.30927 4.05948,0.66718 5.55245,1.24221 0.2768,0.10661 0.66434,0.16408 0.64018,0.55882 -5.20075,0.76324 -10.54297,0.0182 -15.79004,0.10189 0.0154,-1.06144 -0.0384,-2.13705 0,-3.19706 z"
     id="path4917"
     style="fill:#e6f1f5;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-6"
     d="m 181.72211,262.64593 c -0.0247,0.99295 -0.0117,2.00371 0,2.99726 -2.66818,-0.0538 -5.42195,-0.17141 -7.99598,-0.90115 0.0304,-1.59846 6.71707,-2.40201 7.99598,-2.09611 z"
     id="path4919"
     style="fill:#e6f1f5;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 232.88343,241.66515 v 0.39964 c -2.74039,-0.2863 -5.51802,-0.40383 -8.26049,-0.83249 -5.59987,-0.87529 -11.63511,-2.63844 -16.12108,-6.16111 h 11.29147 c 1.69944,0 5.52484,1.64304 7.09888,2.49345 1.44847,0.78253 4.9259,2.98355 5.99122,4.10051 z"
     id="path4921"
     style="fill:#92a9c6;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-2"
     d="m 232.88343,242.06479 v -0.39964 c 0.01,0.0106 0.16824,-0.0245 0.19885,0.10118 z"
     id="path4923"
     style="fill:#5f88bd;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 162.33676,270.4388 c 0.1635,0.74719 2.14551,2.31295 2.57796,3.12498 0.0764,0.43385 -1.3765,1.89881 -1.97451,1.86922 -0.23875,-0.16936 -1.47658,-3.0166 -1.89973,-3.39707 -0.41589,-0.37395 -0.94765,-0.29927 -1.27881,0.1249 -0.34829,0.4461 -1.85575,3.46522 -2.12126,3.46983 l -1.86279,-1.89693 c 0.35249,-0.64146 3.63731,-3.26343 2.41375,-3.8966 -0.54951,-0.28437 -3.51214,-0.67021 -3.63341,-0.81143 l 0.48662,-2.38273 c 0.1588,-0.27736 0.26944,-0.18054 0.50412,-0.11869 0.65995,0.17394 3.52597,1.99939 3.96948,1.29474 l -0.35596,-4.95156 c 0.88356,-0.28256 1.66881,-0.2819 2.55243,-9e-5 0.22068,0.25929 -0.31409,3.69008 -0.33606,4.33644 -0.0663,1.95129 3.2532,-0.67024 4.06209,-0.73245 0.32185,0.0295 0.87647,2.13894 0.66714,2.54324 -0.18975,0.2929 -2.95173,0.56024 -3.42813,0.82368 -0.19264,0.10652 -0.17673,0.44355 -0.34294,0.60051 -0.1642,-0.75041 0.10345,-2.18827 -1.13993,-2.55545 -2.70869,-0.79991 -3.58454,2.80646 -1.46925,3.46431 1.2935,0.40227 1.75915,-0.10613 2.60918,-0.90886 z"
     id="path4971"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 160.4382,272.04128 2.29108,3.69455 c -1.25606,0.95595 -3.29313,0.8695 -4.58472,-7.1e-4 l 2.29364,-3.6939 z"
     id="path4973"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 158.73847,263.04661 0.19886,4.5947 -3.59552,-1.60182 c 0.67394,-1.35591 1.86877,-2.70906 3.39666,-2.99288 z"
     id="path4975"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 165.53434,265.843 -3.59527,1.79831 c -0.13602,-0.18549 0.12562,-4.03603 0.19784,-4.59574 1.5048,0.19315 2.59473,1.62494 3.39743,2.79743 z"
     id="path4977"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 158.13974,270.24114 c 0.10778,0.10838 -1.69338,2.17952 -1.8959,2.39811 -0.14833,0.16013 -0.66167,0.77535 -0.89894,0.59639 -0.45712,-1.20864 -0.89301,-2.46683 -0.80092,-3.7952 z"
     id="path4979"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 166.33374,269.43971 c 0.0569,1.28307 -0.17636,2.77954 -0.99925,3.79652 -0.93439,-0.9327 -1.87518,-1.88054 -2.59797,-2.99523 z"
     id="path4981"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 213.09839,267.84117 c 0.19705,-0.009 0.43525,0.17035 0.80579,0.11288 0.92053,-0.14276 2.05898,-1.11918 3.04251,-1.37519 0.79715,-0.2075 0.93208,1.86971 0.92584,2.43877 l -3.4359,0.81435 c -1.29192,0.67834 2.32154,3.28692 2.23256,3.86646 -0.43377,0.74982 -1.02212,1.42415 -1.85966,1.73389 l -2.14959,-3.55261 c -0.18606,-0.10749 -0.62699,-0.0873 -0.82678,-0.01 -0.46746,0.18093 -2.19598,3.75594 -2.43151,3.76064 l -1.85086,-1.89742 c 0.41401,-0.67739 3.22552,-3.06317 2.5329,-3.87797 l -3.76108,-0.83249 c -0.11619,-0.51514 0.17753,-2.6202 0.84435,-2.55558 0.73166,0.0709 3.55501,2.15375 4.1277,1.36401 l -0.402,-4.85252 c 0.13267,-0.56129 2.54511,-0.25536 2.61718,-0.018 l -0.41145,4.88082 c -1.22885,0.0538 -2.73563,-0.0571 -2.81164,1.7026 -0.15,3.4729 6.31519,1.61131 2.81164,-1.7026 z"
     id="path4983"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 212.19902,272.04124 2.29112,3.69459 c -0.52347,0.95619 -4.50847,0.74476 -4.5646,0.002 z"
     id="path4985"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 217.09535,266.04282 c -1.25092,0.32051 -2.30066,1.38175 -3.59661,1.39731 0.32841,-1.42837 0.22546,-2.95055 0.39904,-4.39456 1.35916,0.19763 2.94932,1.63086 3.19757,2.99725 z"
     id="path4987"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 210.49935,263.0463 0.19884,4.59501 -3.59551,-1.60182 c 0.67176,-1.30406 1.87686,-2.79513 3.39666,-2.99319 z"
     id="path4989"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 218.09461,269.43971 c 0.0569,1.28307 -0.17637,2.77954 -0.99926,3.79652 -0.33844,-0.26065 -2.76443,-2.82739 -2.59783,-2.99509 z"
     id="path4991"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-23"
     d="m 209.90059,270.24114 c 0.11877,0.11726 -1.89634,2.39348 -2.09508,2.59853 -0.20787,0.21447 -0.34961,0.46629 -0.69974,0.39598 -0.44611,-1.22529 -0.95589,-2.45197 -0.80093,-3.79519 z"
     id="path4993"
     style="fill:#252c3b;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 146.47191,215.25613 c 0.0479,0.0309 0.24705,-0.0398 0.34443,0.054 0.11441,0.11026 0.0269,0.28741 0.0553,0.34559 -0.0275,-0.0407 -0.28436,-0.26843 -0.39969,-0.39963 z"
     id="path5041"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 136.27962,226.04624 c -0.0649,-0.0642 -0.14803,-0.12666 -0.19985,-0.19981 0.0302,0.0632 0.15676,0.12238 0.19985,0.19981 z"
     id="path5043"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 136.47946,226.24606 c -0.0568,-0.071 -0.16163,-0.13114 -0.19984,-0.19982 0.0644,0.0637 0.13326,0.15273 0.19984,0.19982 z"
     id="path5045"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 136.67931,226.44588 c -0.0763,-0.0395 -0.13045,-0.15074 -0.19985,-0.19982 0.0545,0.0681 0.13546,0.13582 0.19985,0.19982 z"
     id="path5049"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 136.27962,215.45594 c 0.0317,-0.0679 0.15112,-0.12726 0.19984,-0.19981 -0.0663,0.0458 -0.13141,0.13675 -0.19984,0.19981 z"
     id="path5053"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 145.87236,214.65668 c -0.15794,-0.0856 -2.92929,-0.56919 -3.30073,-0.59642 -1.69397,-0.12421 -4.40093,0.16272 -5.89232,0.99605 0.0227,-0.0237 -0.0778,-0.24635 0.13061,-0.41148 1.52707,-1.20968 7.38535,-1.08182 9.06244,0.0119 z"
     id="path5055"
     style="fill:#e1e7f0" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 146.27206,226.44588 c -0.028,0.0348 0.0494,0.25634 -0.0478,0.34638 -1.01532,0.94095 -8.27301,0.89964 -9.41827,0.0672 -0.21119,-0.1535 -0.10259,-0.38967 -0.12668,-0.41362 1.26355,0.65401 4.05273,0.8564 5.50588,0.8085 1.22313,-0.0403 2.99393,-0.28785 4.08687,-0.8085 z"
     id="path5057"
     style="fill:#e1e7f0" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 136.07977,215.65576 c 0.0516,-0.0703 0.13405,-0.13917 0.19985,-0.19981 -0.0386,0.0826 -0.18063,0.14751 -0.19985,0.19981 z"
     id="path5059"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 135.87992,225.44679 c -0.78557,-1.72866 -0.73042,-4.7708 -0.60791,-6.70223 0.0729,-1.14888 0.13825,-2.17505 0.80775,-3.0888 -0.0552,0.15012 -0.39969,1.61121 -0.39969,1.69845 v 6.59395 c 0,0.0756 0.17422,1.38641 0.19985,1.49863 z"
     id="path5061"
     style="fill:#e1e7f0" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 136.47946,215.25613 c 0.0697,-0.0481 0.12258,-0.15664 0.19985,-0.19982 -0.0633,0.0661 -0.15898,0.13897 -0.19985,0.19982 z"
     id="path5063"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 147.07145,216.0554 c -0.085,-0.14251 -0.15,-0.32587 -0.19984,-0.39964 0.0649,0.13324 0.1505,0.19832 0.19984,0.39964 z"
     id="path5065"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 147.07145,216.0554 c 0.35786,0.60013 0.47074,0.68586 0.57425,1.52412 0.21365,1.7302 0.41134,6.99247 -0.56008,8.34029 -0.15253,0.21163 -0.38124,0.0984 -0.41387,0.12643 0.28127,-0.57885 0.7994,-2.31817 0.7994,-2.89735 v -4.59578 c 0,-0.43234 -0.27589,-1.99266 -0.3997,-2.49771 z"
     id="path5067"
     style="fill:#e1e7f0" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 136.07977,225.84642 c -0.11703,-0.16521 -0.12949,-0.24479 -0.19985,-0.39963 0.005,0.0218 0.15143,0.2982 0.19985,0.39963 z"
     id="path5069"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 146.47191,215.25613 c -0.53082,-0.34273 -0.55842,-0.57715 -0.59955,-0.59945 0.0657,0.0428 0.28035,-0.008 0.3996,0.10691 0.19054,0.1839 0.15781,0.4446 0.19995,0.49254 z"
     id="path5071"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 162.33676,270.4388 c -0.85004,0.80272 -1.31568,1.31113 -2.60919,0.90886 -2.11529,-0.65785 -1.23943,-4.26423 1.46926,-3.46432 1.24337,0.36719 0.97572,1.80504 1.13993,2.55546 z"
     id="path5075"
     style="fill:#92a9c6;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-12"
     d="m 213.09839,267.84117 c 3.50355,3.31392 -2.96165,5.1755 -2.81164,1.70261 0.076,-1.75968 1.58278,-1.64879 2.81164,-1.70261 z"
     id="path5077"
     style="fill:#92a9c6;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-3"
     d="m 141.67624,220.05037 c 0.20304,0.17562 2.18968,-0.33366 1.99499,0.29727 l -2.99292,4.49967 0.59825,-3.59649 c -0.37851,-0.12287 -1.91777,0.30508 -1.80319,-0.30231 0.17408,-0.92289 2.36087,-3.49239 2.90361,-4.48946 z"
     id="path5079"
     style="fill:#d6e3f1" />
  <path
     class="mpg-dashboard-center-icon-styling-14"
     d="m 145.28863,249.10092 c 8.59543,6.59021 0.53212,5.13735 -1.40283,5.45038 -0.27459,-1.32607 -0.091,-4.68465 1.40283,-5.45038 z"
     id="path4749"
     style="fill:#c47a50;stroke-width:0.358479"
     sodipodi:nodetypes="ccc" />
  <path
     style="fill:none;fill-opacity:0.506283;stroke:#000000;stroke-width:1.88976;stroke-linecap:square;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
     d="m 144.44408,229.43631 v 6.10414 c 0,3.51999 -2.59648,13.88811 -2.68948,27.87117 -2.25067,23.26293 8.42581,8.68072 1.66657,9.26925 -13.5701,0.70353 -12.1799,-3.94591 -8.01069,-9.58533 3.54205,-3.04696 0.048,-0.11563 3.6058,-3.0051 0.4276,-0.34728 2.33396,-2.07316 2.55594,-2.59353 0.18328,-0.42968 0.4975,-0.84886 0.6457,-1.29347 0.0195,-0.0586 -0.0276,-0.13006 0,-0.18531 0.0138,-0.0276 0.0708,0.0218 0.0927,0 0.0218,-0.0217 -0.0125,-0.0642 0,-0.0922 0.12463,-0.279 0.34424,-0.50666 0.5444,-0.73754 0.49291,-0.56858 1.05034,-1.05034 1.57473,-1.57473 0.13984,-0.13984 0.23078,-0.32344 0.37062,-0.46328 0.36968,-0.36967 0.87802,-0.61208 1.29677,-0.92614 0.17891,-0.13419 0.24873,-0.44104 0.43733,-0.44104"
     id="path6044"
     sodipodi:nodetypes="cscccssssscssssc" />
  <path
     class="mpg-dashboard-center-icon-styling-8"
     d="m 152.61741,250.82317 c 0.35592,1.28093 0.12833,1.95565 -0.99925,2.59761 -0.32477,-0.11766 -0.66076,-0.14752 -0.99925,-0.19981 -2.14005,-0.3306 -1.64289,0.15605 -3.25965,0.84643 -0.27152,0.11595 -0.59084,0.0897 -0.73732,0.15265 -0.19187,-0.50994 -0.52129,-0.93956 -0.7994,-1.39872 -0.21,-0.34672 -0.36828,-0.9554 -0.39969,-0.99908 0.88567,-0.29676 2.29056,-1.64221 3.10813,-1.79085 1.19938,-0.21805 2.86907,0.62813 4.08643,0.79177 z"
     id="path4731"
     style="fill:#ffffff;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-29"
     d="m 151.21847,249.82408 c 0.16579,0.49202 0.79444,0.36976 1.19909,0.59945 0.0875,0.13937 0.15258,0.22951 0.19985,0.39964 -1.21736,-0.16364 -2.88705,-1.00982 -4.08643,-0.79177 -0.81757,0.14864 -2.22246,1.49409 -3.10813,1.79085 -0.0266,-0.037 -0.61708,0.14994 -0.38067,-0.5792 1.00087,-0.1872 2.28336,-1.55611 3.13048,-1.77408 0.63807,-0.16418 2.15244,0.30996 3.0458,0.35511 z"
     id="path4753"
     style="fill:#bbcee0;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-28"
     d="m 152.41756,250.42353 c -0.40465,-0.22969 -1.0333,-0.10743 -1.19909,-0.59945 0.12303,0.007 0.29732,-0.27652 0.74316,-0.0592 0.48266,0.2353 0.32515,0.45042 0.45593,0.65863 z"
     id="path4763"
     style="fill:#323a4b;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-11"
     d="m 151.61816,253.42078 c -0.0807,0.046 -0.0703,0.36363 -0.46107,0.36472 -0.35282,-0.10559 -0.6405,-0.14819 -0.53817,-0.56453 0.33848,0.0523 0.67447,0.0822 0.99925,0.19981 z"
     id="path4765"
     style="fill:#6a7e99;stroke-width:0.358479" />
  <path
     class="mpg-dashboard-center-icon-styling-27"
     d="m 145.67251,228.04442 c -0.0374,0.41585 0.0754,0.90342 -0.002,1.30208 -0.0804,0.41095 -0.3879,0.46585 -0.3971,0.49627 -0.39125,-0.0295 -0.81417,0.0426 -1.1991,0 -0.23035,-0.0255 -0.55306,0.0554 -0.70974,-0.18646 l -0.0896,-1.41208 c 0.70983,-0.0585 1.72214,-0.0349 2.39819,-0.19981 z"
     id="path4809"
     style="fill:#9ebbd7;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 146.47191,226.24606 c 0.0604,-0.039 0.12779,-0.13787 0.19985,-0.19982 -0.0392,0.0806 -0.16152,0.13584 -0.19985,0.19982 z"
     id="path5047"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-26"
     d="m 146.27206,226.44588 c 0.0598,-0.0742 0.16359,-0.1393 0.19985,-0.19982 -0.066,0.0426 -0.12089,0.1622 -0.19985,0.19982 z"
     id="path5051"
     style="fill:#e1e7f0;stroke-width:0.358479;stroke:none" />
  <path
     class="mpg-dashboard-center-icon-styling-30"
     d="m 140.47644,228.24423 c -0.0373,-7.3e-4 -0.15586,0.18944 -0.30422,0.18255 l -0.29532,-0.18255 h 0.59955 z"
     id="path5073"
     style="fill:#d4e0ec;stroke-width:0.358479;stroke:none" />
  `
]
export const factory = [
  '50.000002 39.999998',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-factory-styling {
        fill: inherit;
        stroke-width: 0px;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.28202778,0,0,0.28202778,3.8789984,-1.87e-8)">
    <g
       id="g4">
      <path
         class="his-factory-styling"
         d="M 139.09,141.82 H 10.21 c -5.82,0 -10.46,-4.86 -10.2,-10.68 L 5.72,7.25 C 5.91,3.2 9.25,0 13.31,0 H 23.5 c 4.19,0 7.6,3.4 7.6,7.6 v 55.17 c 0,0.9 1.03,1.42 1.75,0.87 L 58.24,44.47 c 5.11,-3.85 12.42,-0.21 12.42,6.19 v 12.11 c 0,0.9 1.03,1.42 1.75,0.87 L 97.8,44.48 c 5.11,-3.85 12.42,-0.21 12.42,6.19 v 12.11 c 0,0.9 1.03,1.42 1.75,0.87 l 25.39,-19.17 c 5.11,-3.85 12.42,-0.21 12.42,6.19 v 80.5 c 0,5.89 -4.77,10.66 -10.66,10.66 z M 11.15,134.1 h 127.58 c 1.83,0 3.31,-1.48 3.31,-3.31 V 52.72 c 0,-0.87 -1,-1.37 -1.7,-0.85 l -25.28,19.08 c -5.17,3.91 -12.58,0.21 -12.58,-6.27 V 52.71 c 0,-0.87 -1,-1.37 -1.7,-0.85 L 75.5,70.94 C 70.33,74.85 62.92,71.16 62.92,64.67 V 52.7 c 0,-0.87 -1,-1.37 -1.7,-0.85 L 35.94,70.93 C 30.77,74.84 23.36,71.14 23.36,64.66 V 9.9 c 0,-1.2 -0.98,-2.18 -2.18,-2.18 H 15.5 c -1.17,0 -2.12,0.92 -2.18,2.08 L 7.76,130.57 c -0.09,1.93 1.45,3.54 3.38,3.54 z"
         id="path1" />
      <rect
         class="his-factory-styling"
         x="8.3500004"
         y="5.3800001"
         width="18.200001"
         height="133.03999"
         transform="rotate(2.62,17.392661,71.793864)"
         id="rect1" />
      <rect
         class="his-factory-styling"
         x="45.880001"
         y="36.18"
         width="64.050003"
         height="133.03999"
         transform="rotate(90,77.9,102.7)"
         id="rect2" />
      <polygon
         class="his-factory-styling"
         points="63.38,48.66 66.43,85.7 32.22,71.16 "
         id="polygon2" />
      <polygon
         class="his-factory-styling"
         points="102.78,49.61 105.83,86.65 71.62,72.12 "
         id="polygon3" />
      <polygon
         class="his-factory-styling"
         points="141.95,49.13 144.99,86.18 110.79,71.64 "
         id="polygon4" />
    </g>
  </g>
  `
]
export const fuelcell = [
  '50 40',
  `
  <defs
     id="defs29" />
  
  <g
     id="g3787"
     style="stroke: none"
     transform="translate(5.66825,0.8797)">
    <g
       id="rect28">
      <path
         d="m 28.583,6.8413 v 30.3984 h -3.409 c 0.0969,-0.0792 0.1906,-0.1632 0.2809,-0.2519 0.7735,-0.76 1.1991,-1.7715 1.1984,-2.8477 -1e-4,-1.8749 -1.3097,-3.4541 -3.0742,-3.895 v -0.1103 c 1.7646,-0.4409 3.0741,-2.0201 3.0742,-3.8951 -1e-4,-1.8749 -1.3097,-3.4541 -3.0742,-3.895 v -0.1103 c 1.7646,-0.4409 3.0741,-2.0201 3.0742,-3.8951 -1e-4,-1.8748 -1.3097,-3.4539 -3.0741,-3.8949 v -0.0725 c 1.765,-0.4453 3.0745,-2.0409 3.0741,-3.9353 -7e-4,-1.5598 -0.8899,-2.9169 -2.1899,-3.5953 h 4.1196 m 1,-1 h -7.0039 v 1.5391 c 1.6974,2e-4 3.0735,1.3685 3.0742,3.0566 4e-4,1.6889 -1.3759,3.0582 -3.074,3.0586 h -2e-4 v 1.8262 c 1.6978,3e-4 3.0741,1.3512 3.0742,3.0176 -1e-4,1.6664 -1.3764,3.0173 -3.0742,3.0176 v 1.8652 c 1.6978,3e-4 3.0741,1.3512 3.0742,3.0176 -1e-4,1.6664 -1.3764,3.0173 -3.0742,3.0176 v 1.8652 c 1.6978,3e-4 3.0741,1.3512 3.0742,3.0176 10e-4,1.6667 -1.3748,3.0186 -3.0729,3.0195 h -0.0013 v 1.0801 h 7.0039 z"
         id="path2884" />
    </g>
    <g
       id="rect30">
      <path
         d="m 15.3343,6.8413 c -1.2956,0.6734 -2.1809,2.0151 -2.181,3.5567 10e-5,1.8749 1.3096,3.4541 3.0742,3.895 v 0.124 c -1.7646,0.4409 -3.0741,2.0201 -3.0742,3.8951 10e-5,1.8749 1.3096,3.4541 3.0742,3.895 v 0.124 c -1.7646,0.4409 -3.0741,2.0201 -3.0742,3.8951 10e-5,1.8749 1.3096,3.4541 3.0742,3.895 v 0.124 c -1.7646,0.4409 -3.0741,2.0202 -3.0742,3.8961 -2e-4,1.0767 0.4259,2.0881 1.1996,2.8478 0.0899,0.0883 0.1832,0.1719 0.2797,0.2507 H 11.3369 V 6.8413 h 3.9974 m 1.8932,-1 h -6.8906 v 32.3984 h 6.8906 V 37.1596 C 15.5294,37.1593 14.153,35.808 14.1533,34.1413 V 34.14 c 10e-5,-1.6664 1.3764,-3.0173 3.0742,-3.0176 v -1.8789 c -1.6978,-3e-4 -3.0741,-1.3512 -3.0742,-3.0176 10e-5,-1.6664 1.3764,-3.0173 3.0742,-3.0176 v -1.8789 c -1.6978,-3e-4 -3.0741,-1.3512 -3.0742,-3.0176 10e-5,-1.6664 1.3764,-3.0173 3.0742,-3.0176 v -1.8789 c -1.6978,-3e-4 -3.0741,-1.3512 -3.0742,-3.0176 10e-5,-1.6664 1.3764,-3.0173 3.0742,-3.0176 v -1.5391 0 z"
         id="path2887" />
    </g>
    <g
       id="rect50">
      <path
         d="M 21.5795,6.8422 V 37.2406 H 18.2272 V 6.8422 h 3.3523 m 1,-1 h -5.3523 v 32.3984 h 5.3523 z"
         id="path2890" />
    </g>
    <g
       style="isolation: isolate;"
       id="g2895">
      <path
         d="m 4.2124,24.1987 c 0,0.0283 -0.0093,0.0527 -0.0273,0.0752 -0.018,0.0225 -0.0479,0.04 -0.0894,0.0547 -0.042,0.0137 -0.0977,0.0244 -0.167,0.0332 -0.0693,0.0078 -0.1572,0.0127 -0.2627,0.0127 -0.1084,0 -0.1982,-0.0049 -0.269,-0.0127 C 3.3262,24.353 3.2705,24.3423 3.23,24.3286 3.19,24.314 3.1607,24.2964 3.1426,24.2739 3.1245,24.2514 3.1157,24.227 3.1157,24.1987 V 22.018 H 1.0972 v 2.1807 c 0,0.0283 -0.0083,0.0527 -0.0254,0.0752 -0.0166,0.0225 -0.0459,0.04 -0.0874,0.0547 -0.0415,0.0137 -0.0972,0.0244 -0.167,0.0332 -0.0693,0.0078 -0.1582,0.0127 -0.2666,0.0127 -0.106,0 -0.1938,-0.0049 -0.2651,-0.0127 C 0.2149,24.353 0.1587,24.3423 0.1168,24.3286 0.0753,24.314 0.0455,24.2964 0.0274,24.2739 0.0093,24.2514 1e-4,24.227 1e-4,24.1987 V 19.103 c 0,-0.0283 0.0093,-0.0527 0.0273,-0.0752 0.018,-0.0225 0.0479,-0.041 0.0894,-0.0547 0.042,-0.0137 0.0981,-0.0244 0.1689,-0.0332 0.0713,-0.0078 0.1592,-0.0127 0.2651,-0.0127 0.1084,0 0.1973,0.0049 0.2666,0.0127 0.0698,0.0088 0.1255,0.0195 0.167,0.0332 0.0415,0.0137 0.0708,0.0322 0.0874,0.0547 0.0171,0.0225 0.0254,0.0469 0.0254,0.0752 v 1.9805 H 3.1158 V 19.103 c 0,-0.0283 0.0088,-0.0527 0.0269,-0.0752 0.0181,-0.0225 0.0474,-0.041 0.0874,-0.0547 0.0405,-0.0137 0.0962,-0.0244 0.167,-0.0332 0.0708,-0.0078 0.1606,-0.0127 0.269,-0.0127 0.1055,0 0.1934,0.0049 0.2627,0.0127 0.0693,0.0088 0.125,0.0195 0.167,0.0332 0.0415,0.0137 0.0713,0.0322 0.0894,0.0547 0.0181,0.0225 0.0273,0.0469 0.0273,0.0752 v 5.0957 z"
         id="path2893" />
    </g>
    <g
       style="isolation: isolate;"
       id="g2899">
      <path
         d="m 8.1509,26.5229 c 0,0.041 -0.002,0.0742 -0.0054,0.1035 -0.0034,0.0273 -0.0088,0.0508 -0.0156,0.0703 -0.0068,0.0176 -0.0161,0.0293 -0.0273,0.0371 -0.0107,0.0078 -0.0234,0.0117 -0.0371,0.0117 H 6.5137 c -0.0303,0 -0.0571,-0.002 -0.0791,-0.0078 C 6.4121,26.7318 6.3941,26.7221 6.3804,26.7045 6.3662,26.6889 6.3565,26.6654 6.3501,26.6361 6.3438,26.6049 6.3408,26.5658 6.3408,26.517 c 0,-0.0469 0.002,-0.0859 0.0063,-0.1191 C 6.351,26.3667 6.3588,26.3374 6.37,26.312 6.3807,26.2847 6.3954,26.2612 6.4125,26.2358 6.4301,26.2124 6.4525,26.185 6.4804,26.1557 l 0.4673,-0.5 C 7.0405,25.558 7.1157,25.4702 7.1728,25.3901 7.2294,25.31 7.2744,25.2358 7.3061,25.1713 7.3383,25.1049 7.3598,25.0443 7.372,24.9877 7.3837,24.933 7.3896,24.8803 7.3896,24.8295 7.3896,24.7846 7.3823,24.7397 7.3676,24.6986 7.3529,24.6575 7.3315,24.6224 7.3031,24.5912 7.2743,24.5619 7.2386,24.5365 7.1957,24.5209 7.1522,24.5033 7.1019,24.4936 7.0434,24.4936 c -0.082,0 -0.1548,0.0117 -0.2178,0.0312 -0.0635,0.0215 -0.1191,0.0449 -0.167,0.0703 -0.0479,0.0254 -0.0879,0.0488 -0.1196,0.0703 -0.0322,0.0215 -0.0571,0.0332 -0.0752,0.0332 -0.0127,0 -0.0234,-0.0039 -0.0322,-0.0137 C 6.4223,24.6771 6.415,24.6634 6.4096,24.6439 6.4037,24.6244 6.3993,24.599 6.3959,24.5658 6.3925,24.5326 6.3905,24.4935 6.3905,24.4467 c 0,-0.0332 10e-4,-0.0586 0.0034,-0.0801 0.002,-0.0215 0.0049,-0.041 0.0093,-0.0566 0.0039,-0.0156 0.0098,-0.0312 0.0166,-0.043 0.0068,-0.0118 0.019,-0.0254 0.0366,-0.043 0.0171,-0.0156 0.0493,-0.0371 0.0957,-0.0625 0.0469,-0.0254 0.104,-0.0508 0.1724,-0.0762 0.0679,-0.0234 0.1431,-0.043 0.2251,-0.0605 0.082,-0.0175 0.1675,-0.0254 0.2563,-0.0254 0.1406,0 0.2632,0.0176 0.3682,0.0527 0.105,0.0371 0.1919,0.0859 0.2617,0.1484 0.0693,0.0645 0.1211,0.1387 0.1553,0.2246 0.0342,0.0879 0.0513,0.1816 0.0513,0.2812 0,0.0879 -0.0083,0.1738 -0.0254,0.2578 -0.0166,0.0859 -0.0513,0.1777 -0.104,0.2754 -0.0527,0.0977 -0.1274,0.207 -0.2231,0.3242 -0.0962,0.1191 -0.2231,0.2578 -0.3818,0.4141 L 6.9936,26.302 h 1.063 c 0.0142,0 0.0269,0.0039 0.0391,0.0117 0.0117,0.0098 0.0215,0.0215 0.0298,0.0391 0.0088,0.0176 0.0146,0.041 0.019,0.0684 0.0039,0.0293 0.0063,0.0625 0.0063,0.1016 z"
         id="path2897" />
    </g>
    <g
       id="g2240">
      <g
         style="isolation: isolate;"
         id="g2903">
        <path
           d="m 35.6328,21.5688 c 0,0.4307 -0.0488,0.8164 -0.1445,1.1562 -0.0957,0.3398 -0.2383,0.6279 -0.4277,0.8643 -0.1885,0.2373 -0.4229,0.418 -0.7021,0.542 -0.2793,0.125 -0.6016,0.1875 -0.9688,0.1875 -0.3613,0 -0.6777,-0.0537 -0.9473,-0.1592 -0.2696,-0.1055 -0.4941,-0.2666 -0.6738,-0.4834 -0.1797,-0.2168 -0.3145,-0.4922 -0.4043,-0.8271 -0.0898,-0.3349 -0.1348,-0.7305 -0.1348,-1.1885 0,-0.4199 0.0479,-0.7979 0.1445,-1.1338 0.0957,-0.3359 0.2383,-0.6221 0.4277,-0.8574 0.1885,-0.2354 0.4229,-0.416 0.7021,-0.542 0.2792,-0.126 0.6035,-0.1885 0.9717,-0.1885 0.3525,0 0.6631,0.0527 0.9326,0.1562 0.2695,0.1045 0.4951,0.2656 0.6758,0.4824 0.1816,0.2168 0.3174,0.4902 0.4102,0.8203 0.0918,0.3311 0.1387,0.7207 0.1387,1.1709 z m -0.9922,0.0557 c 0,-0.2725 -0.0195,-0.5215 -0.0576,-0.7441 -0.0381,-0.2236 -0.1035,-0.415 -0.1963,-0.5742 -0.0918,-0.1592 -0.2148,-0.2822 -0.3682,-0.3691 -0.1533,-0.0879 -0.3447,-0.1309 -0.5752,-0.1309 -0.2324,0 -0.4258,0.0488 -0.582,0.1465 -0.1553,0.0977 -0.2812,0.2285 -0.377,0.3916 -0.0958,0.1631 -0.1641,0.3535 -0.2031,0.5723 -0.04,0.2178 -0.0596,0.4482 -0.0596,0.6924 0,0.2832 0.0195,0.5381 0.0576,0.7646 0.0381,0.2256 0.1025,0.4189 0.1943,0.5801 0.0908,0.1602 0.2129,0.2832 0.3662,0.3672 0.1533,0.084 0.3467,0.126 0.5791,0.126 0.2324,0 0.4258,-0.0479 0.582,-0.1445 0.1553,-0.0957 0.2812,-0.2266 0.377,-0.3926 0.0958,-0.166 0.1641,-0.3594 0.2031,-0.5801 0.04,-0.2207 0.0596,-0.4561 0.0596,-0.7051 z"
           id="path2901" />
      </g>
      <g
         style="isolation: isolate;"
         id="g2907">
        <path
           d="m 38.6631,25.9526 c 0,0.04 -10e-4,0.0742 -0.0049,0.1025 -0.0039,0.0283 -0.0088,0.0518 -0.0156,0.0703 -0.0068,0.0176 -0.0156,0.0303 -0.0273,0.0381 -0.0107,0.0078 -0.0234,0.0117 -0.0371,0.0117 h -1.5518 c -0.0303,0 -0.0566,-0.0029 -0.0791,-0.0088 -0.0225,-0.0049 -0.04,-0.0156 -0.0547,-0.0322 -0.0137,-0.0156 -0.0234,-0.0391 -0.0293,-0.0693 -0.0068,-0.0303 -0.0098,-0.0703 -0.0098,-0.1191 0,-0.0459 0.002,-0.085 0.0059,-0.1182 0.0049,-0.0322 0.0117,-0.0615 0.0234,-0.0869 0.0107,-0.0264 0.0254,-0.0508 0.043,-0.0752 0.0166,-0.0244 0.0391,-0.0508 0.0674,-0.0801 l 0.4668,-0.501 c 0.0938,-0.0967 0.168,-0.1855 0.2256,-0.2656 0.0566,-0.0801 0.1016,-0.1533 0.1338,-0.2188 0.0312,-0.0664 0.0537,-0.127 0.0654,-0.1826 0.0117,-0.0556 0.0176,-0.1084 0.0176,-0.1582 0,-0.0459 -0.0078,-0.0898 -0.0215,-0.1309 -0.0146,-0.041 -0.0361,-0.0762 -0.0654,-0.1074 -0.0283,-0.0303 -0.0645,-0.0547 -0.1074,-0.0713 -0.043,-0.0176 -0.0938,-0.0264 -0.1523,-0.0264 -0.082,0 -0.1543,0.0107 -0.2178,0.0312 -0.0625,0.0205 -0.1182,0.0439 -0.166,0.0693 -0.0488,0.0264 -0.0889,0.0498 -0.1201,0.0713 -0.0322,0.0215 -0.0576,0.0322 -0.0752,0.0322 -0.0127,0 -0.0234,-0.0039 -0.0322,-0.0127 -0.0088,-0.0078 -0.0166,-0.0215 -0.0225,-0.041 -0.0049,-0.0195 -0.0098,-0.0459 -0.0137,-0.0781 -0.0029,-0.0332 -0.0049,-0.0732 -0.0049,-0.1201 0,-0.0322 0.001,-0.0586 0.0029,-0.0801 0.0019,-0.0215 0.0059,-0.041 0.0098,-0.0566 0.0039,-0.0156 0.0098,-0.0303 0.0166,-0.042 0.0068,-0.0117 0.0195,-0.0254 0.0361,-0.043 0.0176,-0.0166 0.0498,-0.0371 0.0967,-0.0635 0.0459,-0.0254 0.1035,-0.0508 0.1719,-0.0752 0.0684,-0.0234 0.1426,-0.0439 0.2246,-0.0615 0.082,-0.0166 0.168,-0.0244 0.2568,-0.0244 0.1406,0 0.2627,0.0176 0.3682,0.0527 0.1045,0.0361 0.1924,0.085 0.2617,0.1484 0.0693,0.0634 0.1211,0.1387 0.1553,0.2246 0.0342,0.0869 0.0508,0.1807 0.0508,0.2812 0,0.0869 -0.0078,0.1738 -0.0244,0.2578 -0.0166,0.085 -0.0518,0.1768 -0.1045,0.2744 -0.0527,0.0986 -0.127,0.207 -0.2236,0.3252 -0.0957,0.1191 -0.2227,0.2568 -0.3809,0.4141 l -0.3154,0.3232 h 1.0635 c 0.0137,0 0.0273,0.0039 0.0391,0.0127 0.0118,0.0088 0.0215,0.0215 0.0303,0.0381 0.0078,0.0176 0.0146,0.041 0.0186,0.0693 0.004,0.0283 0.0059,0.0625 0.0059,0.1016 z"
           id="path2905" />
      </g>
    </g>
    <g
       style="isolation: isolate;"
       id="g2912">
      <path
         d="m 15.2339,1.5513 c 0,0.1001 -0.0239,0.1704 -0.0723,0.2104 -0.0479,0.0396 -0.1245,0.0596 -0.229,0.0596 h -2.7261 c -0.1089,0 -0.1875,-0.0205 -0.2358,-0.061 -0.0479,-0.0405 -0.0718,-0.1104 -0.0718,-0.209 0,-0.0972 0.0239,-0.1655 0.0718,-0.2056 0.0483,-0.0396 0.127,-0.0596 0.2358,-0.0596 h 2.7261 c 0.0522,0 0.0972,0.0044 0.1343,0.0127 0.0371,0.0088 0.0688,0.0234 0.0947,0.0444 0.0264,0.0205 0.0449,0.0483 0.0557,0.083 0.0112,0.0347 0.0166,0.0762 0.0166,0.125 z"
         id="path2910" />
    </g>
    <g
       style="isolation: isolate;"
       id="g2916">
      <path
         d="m 27.4072,1.5415 c 0,0.0601 -0.0039,0.1104 -0.0098,0.1509 -0.0068,0.0405 -0.0166,0.0732 -0.0293,0.0977 -0.0127,0.0245 -0.0273,0.042 -0.0449,0.0527 -0.0166,0.0107 -0.0352,0.0161 -0.0547,0.0161 h -0.998 v 1.0864 c 0,0.0215 -0.0049,0.04 -0.0156,0.0562 -0.0107,0.0162 -0.0293,0.0298 -0.0547,0.0415 -0.0264,0.0117 -0.0605,0.021 -0.1025,0.0273 -0.043,0.0063 -0.0967,0.0093 -0.1611,0.0093 -0.0644,0 -0.1172,-0.0029 -0.1602,-0.0093 C 25.7334,3.0639 25.6993,3.0547 25.6739,3.043 25.6475,3.0313 25.629,3.0176 25.6173,3.0015 25.6056,2.9854 25.5997,2.9668 25.5997,2.9453 V 1.8589 H 24.6046 C 24.586,1.8589 24.5675,1.8535 24.5519,1.8428 24.5363,1.8321 24.5216,1.8145 24.5089,1.7901 24.4952,1.7657 24.4855,1.733 24.4777,1.6924 24.4709,1.6519 24.467,1.6016 24.467,1.5415 c 0,-0.0576 0.0029,-0.1074 0.0098,-0.1489 0.0059,-0.0415 0.0156,-0.0747 0.0273,-0.0991 0.0117,-0.0249 0.0244,-0.0425 0.04,-0.0532 0.0146,-0.0107 0.0322,-0.0161 0.0508,-0.0161 h 1.0049 V 0.1411 c 0,-0.0215 0.0059,-0.041 0.0176,-0.0591 C 25.6291,0.0639 25.6477,0.0488 25.674,0.0371 25.6994,0.0254 25.7336,0.0161 25.7765,0.0098 25.8194,0.0035 25.8722,0 25.9367,0 c 0.0645,0 0.1182,0.0034 0.1611,0.0098 0.042,0.0063 0.0762,0.0156 0.1025,0.0273 0.0254,0.0117 0.0439,0.0269 0.0547,0.0449 0.0108,0.018 0.0156,0.0376 0.0156,0.0591 v 1.083 h 1.0078 c 0.0176,0 0.0342,0.0054 0.0498,0.0161 0.0156,0.0107 0.0303,0.0283 0.042,0.0532 0.0117,0.0244 0.0205,0.0576 0.0273,0.0991 0.0059,0.0415 0.0098,0.0913 0.0098,0.1489 z"
         id="path2914" />
    </g>
    <rect
       id="rect30-9"
       x="11.7418"
       y="4.6564999"
       width="4.0812998"
       height="1.1823" />
    <rect
       id="rect30-9-1"
       x="24.0406"
       y="4.6574001"
       width="4.0812998"
       height="1.1822" />
  </g>
  `
]
export const generic = [
  '50.000001 40',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-generic-styling {
        fill: inherit;
        stroke-width: 0px;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.23361757,0,0,0.23361757,3.4931665,-1.6770001e-7)">
    <polygon
       class="his-generic-styling"
       points="0,77.37 12.18,43.7 75.94,65.19 75.94,0 106.75,0 106.75,63.76 171.22,42.99 184.12,77.37 118.21,95.28 158.33,153.31 132.54,171.22 91.7,115.34 53.01,169.07 25.07,150.45 67.34,99.58 "
       id="polygon1" />
  </g>
  `
]
export const grid = [
  '50 40.000001',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-grid-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 14px;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.19230074,0,0,0.19230074,4.592084,-4.7619066e-4)">
    <g
       id="g2">
      <line
         class="his-grid-styling"
         x1="7"
         y1="201.00999"
         x2="205.25"
         y2="201.00999"
         id="line1" />
      <polyline
         class="his-grid-styling"
         points="148.96 198.64 106.82 7 62.45 198.64 133.75 144.92 75.42 142.63 119.97 83.13 87.88 83.13 40.59 45.1"
         id="polyline1" />
      <polyline
         class="his-grid-styling"
         points="38.21 56.99 38.21 42.25 181.28 42.25 181.28 56.99"
         id="polyline2" />
      <line
         class="his-grid-styling"
         x1="123.84"
         y1="84.410004"
         x2="181.28"
         y2="42.25"
         id="line2" />
    </g>
  </g>
  `
]
export const heatingelement = [
  '49.999999 40',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-heatingelement-styling-0 {
        fill: inherit;
        stroke-width: 0px;
      }
      .his-heatingelement-styling-1 {
        fill: none;
        stroke: inherit;
        stroke-miterlimit: 10;
        stroke-width: 14px;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.20139364,0,0,0.20139364,6.8376764e-8,1.1957708)">
    <g
       id="g5">
      <rect
         class="his-heatingelement-styling-1"
         x="7"
         y="7"
         width="234.27"
         height="129.67"
         rx="14.33"
         ry="14.33"
         id="rect1" />
      <g
         id="g4">
        <g
           id="g1">
          <path
             class="his-heatingelement-styling-0"
             d="m 56.41,84.8 c -4.28,5.81 -6.65,12.89 -7.12,20.06 -0.48,7.36 1.59,14.48 4.49,21.16 2.74,6.31 6.44,12.14 9.78,18.14 0.8,1.45 1.59,2.9 2.33,4.38 0.4,0.8 0.8,1.61 1.18,2.43 0.19,0.41 0.37,0.82 0.55,1.23 0.23,0.53 0.24,0.55 0.03,0.04 0.09,0.21 0.17,0.41 0.25,0.62 1.24,3.09 2.17,6.25 2.72,9.53 0.16,0.94 0.02,0 -0.02,-0.16 0.12,0.49 0.12,1.07 0.16,1.57 0.07,0.92 0.1,1.84 0.1,2.76 0,0.78 -0.04,1.57 -0.1,2.35 -0.03,0.38 -0.04,0.79 -0.12,1.17 0.28,-1.37 -0.08,0.33 -0.13,0.59 -0.15,0.76 -0.33,1.51 -0.55,2.25 -0.11,0.37 -0.22,0.74 -0.35,1.1 -0.04,0.13 -0.58,1.52 -0.3,0.84 0.3,-0.74 -0.2,0.41 -0.22,0.45 -0.22,0.46 -0.46,0.91 -0.72,1.36 -0.19,0.33 -0.39,0.66 -0.6,0.98 -0.13,0.2 -1.14,1.56 -0.35,0.56 -0.85,1.09 -1.46,2.09 -1.46,3.54 0,1.23 0.54,2.69 1.46,3.54 1.8,1.65 5.35,2.2 7.07,0 4.4,-5.63 6.48,-12.36 6.36,-19.51 -0.12,-7.15 -2.42,-14.16 -5.54,-20.68 -3.12,-6.52 -6.83,-12.16 -10.09,-18.33 -0.8,-1.51 -1.56,-3.04 -2.27,-4.59 -0.15,-0.34 -0.31,-0.68 -0.45,-1.02 -0.1,-0.22 -0.47,-1.14 -0.1,-0.24 -0.39,-0.96 -0.76,-1.92 -1.1,-2.9 -0.53,-1.53 -0.99,-3.08 -1.35,-4.65 -0.2,-0.86 -0.35,-1.72 -0.5,-2.59 -0.24,-1.38 0.04,0.66 -0.03,-0.2 -0.04,-0.51 -0.1,-1.03 -0.14,-1.54 -0.12,-1.83 -0.03,-3.64 0.11,-5.46 0.1,-1.39 -0.2,1.04 0.04,-0.34 0.1,-0.55 0.19,-1.11 0.3,-1.66 0.17,-0.82 0.38,-1.64 0.61,-2.45 0.27,-0.95 0.61,-1.86 0.94,-2.79 0.46,-1.31 -0.44,0.9 0.14,-0.36 0.18,-0.38 0.35,-0.76 0.54,-1.14 0.87,-1.76 1.91,-3.43 3.07,-5.02 1.56,-2.11 0.42,-5.67 -1.79,-6.84 -2.61,-1.38 -5.18,-0.46 -6.84,1.79 v 0 z"
             id="path1" />
          <polygon
             class="his-heatingelement-styling-0"
             points="40.66,88.83 77.73,88.83 59.2,49.94 "
             id="polygon1" />
        </g>
        <g
           id="g2">
          <path
             class="his-heatingelement-styling-0"
             d="m 118.97,84.8 c -4.28,5.81 -6.65,12.89 -7.12,20.06 -0.48,7.36 1.59,14.48 4.49,21.16 2.74,6.31 6.44,12.14 9.78,18.14 0.8,1.45 1.59,2.9 2.33,4.38 0.4,0.8 0.8,1.61 1.18,2.43 0.19,0.41 0.37,0.82 0.55,1.23 0.23,0.53 0.24,0.55 0.03,0.04 0.09,0.21 0.17,0.41 0.25,0.62 1.24,3.09 2.17,6.25 2.72,9.53 0.16,0.94 0.02,0 -0.02,-0.16 0.12,0.49 0.12,1.07 0.16,1.57 0.07,0.92 0.1,1.84 0.1,2.76 0,0.78 -0.04,1.57 -0.1,2.35 -0.03,0.38 -0.04,0.79 -0.12,1.17 0.28,-1.37 -0.08,0.33 -0.13,0.59 -0.15,0.76 -0.33,1.51 -0.55,2.25 -0.11,0.37 -0.22,0.74 -0.35,1.1 -0.04,0.13 -0.58,1.52 -0.3,0.84 0.3,-0.74 -0.2,0.41 -0.22,0.45 -0.22,0.46 -0.46,0.91 -0.72,1.36 -0.19,0.33 -0.39,0.66 -0.6,0.98 -0.13,0.2 -1.14,1.56 -0.35,0.56 -0.85,1.09 -1.46,2.09 -1.46,3.54 0,1.23 0.54,2.69 1.46,3.54 1.8,1.65 5.35,2.2 7.07,0 4.4,-5.63 6.48,-12.36 6.36,-19.51 -0.12,-7.15 -2.42,-14.16 -5.54,-20.68 -3.12,-6.52 -6.83,-12.16 -10.09,-18.33 -0.8,-1.51 -1.56,-3.04 -2.27,-4.59 -0.15,-0.34 -0.31,-0.68 -0.45,-1.02 -0.1,-0.22 -0.47,-1.14 -0.1,-0.24 -0.39,-0.96 -0.76,-1.92 -1.1,-2.9 -0.53,-1.53 -0.99,-3.08 -1.35,-4.65 -0.2,-0.86 -0.35,-1.72 -0.5,-2.59 -0.24,-1.38 0.04,0.66 -0.03,-0.2 -0.04,-0.51 -0.1,-1.03 -0.14,-1.54 -0.12,-1.83 -0.03,-3.64 0.11,-5.46 0.1,-1.39 -0.2,1.04 0.04,-0.34 0.1,-0.55 0.19,-1.11 0.3,-1.66 0.17,-0.82 0.38,-1.64 0.61,-2.45 0.27,-0.95 0.61,-1.86 0.94,-2.79 0.46,-1.31 -0.44,0.9 0.14,-0.36 0.18,-0.38 0.35,-0.76 0.54,-1.14 0.87,-1.76 1.91,-3.43 3.07,-5.02 1.56,-2.11 0.42,-5.67 -1.79,-6.84 -2.61,-1.38 -5.18,-0.46 -6.84,1.79 v 0 z"
             id="path2" />
          <polygon
             class="his-heatingelement-styling-0"
             points="103.22,88.83 140.3,88.83 121.76,49.94 "
             id="polygon2" />
        </g>
        <g
           id="g3">
          <path
             class="his-heatingelement-styling-0"
             d="m 181.53,84.8 c -4.28,5.81 -6.65,12.89 -7.12,20.06 -0.48,7.36 1.59,14.48 4.49,21.16 2.74,6.31 6.44,12.14 9.78,18.14 0.8,1.45 1.59,2.9 2.33,4.38 0.4,0.8 0.8,1.61 1.18,2.43 0.19,0.41 0.37,0.82 0.55,1.23 0.23,0.53 0.24,0.55 0.03,0.04 0.09,0.21 0.17,0.41 0.25,0.62 1.24,3.09 2.17,6.25 2.72,9.53 0.16,0.94 0.02,0 -0.02,-0.16 0.12,0.49 0.12,1.07 0.16,1.57 0.07,0.92 0.1,1.84 0.1,2.76 0,0.78 -0.04,1.57 -0.1,2.35 -0.03,0.38 -0.04,0.79 -0.12,1.17 0.28,-1.37 -0.08,0.33 -0.13,0.59 -0.15,0.76 -0.33,1.51 -0.55,2.25 -0.11,0.37 -0.22,0.74 -0.35,1.1 -0.04,0.13 -0.58,1.52 -0.3,0.84 0.3,-0.74 -0.2,0.41 -0.22,0.45 -0.22,0.46 -0.46,0.91 -0.72,1.36 -0.19,0.33 -0.39,0.66 -0.6,0.98 -0.13,0.2 -1.14,1.56 -0.35,0.56 -0.85,1.09 -1.46,2.09 -1.46,3.54 0,1.23 0.54,2.69 1.46,3.54 1.8,1.65 5.35,2.2 7.07,0 4.4,-5.63 6.48,-12.36 6.36,-19.51 -0.12,-7.15 -2.42,-14.16 -5.54,-20.68 -3.12,-6.52 -6.83,-12.16 -10.09,-18.33 -0.8,-1.51 -1.56,-3.04 -2.27,-4.59 -0.15,-0.34 -0.31,-0.68 -0.45,-1.02 -0.1,-0.22 -0.47,-1.14 -0.1,-0.24 -0.39,-0.96 -0.76,-1.92 -1.1,-2.9 -0.53,-1.53 -0.99,-3.08 -1.35,-4.65 -0.2,-0.86 -0.35,-1.72 -0.5,-2.59 -0.24,-1.38 0.04,0.66 -0.03,-0.2 -0.04,-0.51 -0.1,-1.03 -0.14,-1.54 -0.12,-1.83 -0.03,-3.64 0.11,-5.46 0.1,-1.39 -0.2,1.04 0.04,-0.34 0.1,-0.55 0.19,-1.11 0.3,-1.66 0.17,-0.82 0.38,-1.64 0.61,-2.45 0.27,-0.95 0.61,-1.86 0.94,-2.79 0.46,-1.31 -0.44,0.9 0.14,-0.36 0.18,-0.38 0.35,-0.76 0.54,-1.14 0.87,-1.76 1.91,-3.43 3.07,-5.02 1.56,-2.11 0.42,-5.67 -1.79,-6.84 -2.61,-1.38 -5.18,-0.46 -6.84,1.79 v 0 z"
             id="path3" />
          <polygon
             class="his-heatingelement-styling-0"
             points="165.78,88.83 202.86,88.83 184.32,49.94 "
             id="polygon3" />
        </g>
      </g>
    </g>
  </g>
  `
]
export const heatpump = [
  '50.000002 39.999998',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-heatpump-styling {
        fill: none;
        stroke: inherit;
        stroke-miterlimit: 10;
        stroke-width: 5px;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.22852965,0,0,0.22852965,-2.9459115e-7,4.6325231)">
    <circle
       class="his-heatpump-styling"
       cx="76.739998"
       cy="66.089996"
       r="51.169998"
       id="circle1" />
    <g
       id="g5">
      <circle
         class="his-heatpump-styling"
         cx="76.940002"
         cy="66.660004"
         r="7.52"
         id="circle2" />
      <path
         class="his-heatpump-styling"
         d="m 107.27,61.35 c -5.85,3.75 -19.3,5.7 -23.05,-0.15 -3.75,-5.85 3.61,-17.27 9.46,-21.02 5.85,-3.75 13.63,-2.06 17.38,3.79 3.75,5.85 2.06,13.63 -3.79,17.38 z"
         id="path2" />
      <path
         class="his-heatpump-styling"
         d="m 72.12,35.48 c 3.75,5.85 5.7,19.3 -0.15,23.05 -5.85,3.75 -17.27,-3.61 -21.02,-9.46 -3.75,-5.85 -2.06,-13.63 3.79,-17.38 5.85,-3.75 13.63,-2.06 17.38,3.79 z"
         id="path3" />
      <path
         class="his-heatpump-styling"
         d="m 81.36,96.7 c -3.75,-5.85 -5.7,-19.3 0.15,-23.05 5.85,-3.75 17.27,3.61 21.02,9.46 3.75,5.85 2.06,13.63 -3.79,17.38 -5.85,3.75 -13.63,2.06 -17.38,-3.79 z"
         id="path4" />
      <path
         class="his-heatpump-styling"
         d="m 46.21,70.83 c 5.85,-3.75 19.3,-5.7 23.05,0.15 C 73.01,76.83 65.65,88.25 59.8,92 53.95,95.75 46.17,94.06 42.42,88.21 38.67,82.36 40.36,74.58 46.21,70.83 Z"
         id="path5" />
    </g>
    <rect
       class="his-heatpump-styling"
       x="2.5"
       y="2.5"
       width="213.78999"
       height="129.49001"
       id="rect5" />
    <rect
       class="his-heatpump-styling"
       x="146.31"
       y="18.799999"
       width="53.049999"
       height="36.18"
       id="rect6" />
    <rect
       class="his-heatpump-styling"
       x="146.31"
       y="71.089996"
       width="53.049999"
       height="0"
       id="rect7" />
    <rect
       class="his-heatpump-styling"
       x="146.31"
       y="85.639999"
       width="53.049999"
       height="0"
       id="rect8" />
    <rect
       class="his-heatpump-styling"
       x="146.31"
       y="100.18"
       width="53.049999"
       height="0"
       id="rect9" />
  </g>
  `
]
export const pv = [
  '50.000138 39.980998',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-pv-styling {
        fill: inherit;
        stroke-width: 0px;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="translate(6.6188272e-5,-0.00949993)">
    <g
       id="g6"
       transform="translate(-53.403866,-42.775667)">
      <g
         id="g5"
         transform="matrix(0.31885657,0,0,0.31885657,53.404279,42.759233)">
        <g
           id="_Radiale_Wiederholung_"
           data-name="&amp;lt;Radiale Wiederholung&amp;gt;">
          <rect
             class="his-pv-styling"
             x="102.15"
             y="10.47"
             width="4.1199999"
             height="12.25"
             rx="1.28"
             ry="1.28"
             transform="rotate(-53.36,104.21385,16.588422)"
             id="rect1" />
        </g>
        <g
           id="_Radiale_Wiederholung_-2"
           data-name="&amp;lt;Radiale Wiederholung&amp;gt;">
          <rect
             class="his-pv-styling"
             x="119.36"
             y="0.15000001"
             width="4.1199999"
             height="12.25"
             rx="1.28"
             ry="1.28"
             transform="rotate(-7.55,121.36077,6.257092)"
             id="rect2" />
        </g>
        <g
           id="_Radiale_Wiederholung_-3"
           data-name="&amp;lt;Radiale Wiederholung&amp;gt;">
          <rect
             class="his-pv-styling"
             x="138.75"
             y="5.3000002"
             width="4.1199999"
             height="12.25"
             rx="1.28"
             ry="1.28"
             transform="rotate(38.27,140.81478,11.429415)"
             id="rect3" />
        </g>
        <g
           id="_Radiale_Wiederholung_-4"
           data-name="&amp;lt;Radiale Wiederholung&amp;gt;">
          <rect
             class="his-pv-styling"
             x="148.58"
             y="22.790001"
             width="4.1199999"
             height="12.25"
             rx="1.28"
             ry="1.28"
             transform="rotate(84.09,150.63387,28.909979)"
             id="rect4" />
        </g>
        <g
           id="_Radiale_Wiederholung_-5"
           data-name="&amp;lt;Radiale Wiederholung&amp;gt;">
          <rect
             class="his-pv-styling"
             x="142.87"
             y="42.029999"
             width="4.1199999"
             height="12.25"
             rx="1.28"
             ry="1.28"
             transform="rotate(129.91,144.9316,48.148781)"
             id="rect5" />
        </g>
      </g>
      <path
         class="his-pv-styling"
         d="M 55.996582,77.339228 H 75.593507 V 80.20256 H 59.13732 c -0.707862,0 -1.281804,0.573942 -1.281804,1.281804 0,0.707861 0.573942,1.281803 1.281804,1.281803 h 35.539753 c 0.707862,0 1.281804,-0.573942 1.281804,-1.281803 0,-0.707862 -0.573942,-1.281804 -1.281804,-1.281804 H 78.157114 V 77.339228 H 96.9282 c 0.825839,0 1.610226,-0.39857 2.098077,-1.068169 0.484662,-0.669599 0.62177,-1.536889 0.366685,-2.324465 L 93.337875,55.366822 c -0.347553,-1.06817 -1.339197,-1.788785 -2.461572,-1.788785 H 61.669041 c -1.147884,0 -2.142716,0.736558 -2.477516,1.833425 l -5.672458,18.579772 c -0.242331,0.793953 -0.09885,1.629357 0.395382,2.298956 0.494228,0.66641 1.253106,1.049038 2.082133,1.049038 z m 26.538433,-10.598792 1.307312,8.022431 -14.849151,-0.01275 1.17977,-8.009677 h 12.35888 z m -11.98263,-2.563607 1.182958,-8.02562 9.071469,0.0064 1.307312,8.022432 H 70.552385 Z m 15.891811,10.589227 -1.3105,-8.022432 h 9.192635 l 2.601869,8.031997 -10.487192,-0.0096 z m 4.454427,-18.605281 2.598681,8.016054 h -8.78131 l -1.307312,-8.019243 h 7.489941 z m -29.255091,0 c 0,0 0.01275,-0.01913 0.02232,-0.01913 h 7.473998 c 0,0 -1.182958,8.031997 -1.182958,8.031997 h -8.762178 l 2.44563,-8.016054 z m -3.230017,10.579661 h 9.167127 l -1.17977,8.009677 -10.429798,-0.0096 z"
         id="path5" />
      <path
         class="his-pv-styling"
         d="m 91.246176,52.143182 c 1.613415,0 3.041892,1.029907 3.545685,2.560418 l 0.730182,2.222431 c 0,0 0,0 0,0 1.772843,-0.787576 2.981309,-2.608247 2.860143,-4.699946 -0.143485,-2.416933 -2.149093,-4.406598 -4.569214,-4.524575 -2.649698,-0.130731 -4.856186,1.874877 -5.053877,4.444861 0,0 0,0 0,0 h 2.483893 z"
         id="path6" />
    </g>
  </g>
  `
]
export const rest = [
  '50 40',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-rest-styling-0 {
        fill: inherit;
        stroke-width: 0px;
      }
      .his-rest-styling-1 {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 8px;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.26315789,0,0,0.26315789,5.0000004,3.6e-7)">
    <g
       id="g1">
      <circle
         class="his-rest-styling-1"
         cx="76"
         cy="76"
         r="72"
         id="circle1" />
      <path
         class="his-rest-styling-0"
         d="m 71.17,96.39 c -0.04,-1.27 -0.06,-2.22 -0.06,-2.86 0,-3.75 0.54,-6.99 1.6,-9.71 0.77,-2.05 2.03,-4.12 3.76,-6.2 1.27,-1.52 3.56,-3.74 6.87,-6.66 3.31,-2.91 5.46,-5.24 6.44,-6.97 0.99,-1.73 1.49,-3.63 1.49,-5.67 0,-3.72 -1.45,-6.98 -4.34,-9.79 -2.9,-2.81 -6.46,-4.22 -10.66,-4.22 -4.2,0 -7.46,1.27 -10.18,3.82 -2.72,2.55 -4.51,6.52 -5.36,11.93 l -9.81,-1.17 c 0.89,-7.25 3.51,-12.8 7.88,-16.65 4.37,-3.85 10.14,-5.78 17.32,-5.78 7.6,0 13.67,2.07 18.19,6.2 4.52,4.13 6.79,9.14 6.79,15.01 0,3.39 -0.79,6.52 -2.39,9.39 -1.59,2.86 -4.7,6.35 -9.34,10.45 -3.11,2.76 -5.14,4.79 -6.1,6.1 -0.96,1.31 -1.66,2.81 -2.12,4.51 -0.46,1.7 -0.72,4.46 -0.79,8.27 h -9.18 z m -0.58,19.15 v -10.88 h 10.87 v 10.88 z"
         id="path1" />
    </g>
  </g>
  `
]
export const trafo = [
  '50 40',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-trafo-styling-0 {
        fill: inherit;
        stroke-width: 0px;
      }
      .his-trafo-styling-1 {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 11px;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.21374372,0,0,0.21374372,4.4271669,3.8867131e-7)">
    <path
       class="his-trafo-styling-0"
       d="m 83.27,80.27 h 27.12 c 1.2,0 2.03,1.18 1.63,2.31 l -9.18,25.93 c -0.4,1.13 0.44,2.31 1.63,2.31 h 5.52 c 1.3,0 2.13,1.38 1.54,2.53 L 93.8,147.53 c -0.85,1.65 -3.35,0.98 -3.27,-0.87 l 0.88,-19.89 c 0.04,-0.99 -0.74,-1.81 -1.73,-1.81 h -6.41 c -0.96,0 -1.73,-0.78 -1.73,-1.73 V 82.01 c 0,-0.96 0.78,-1.73 1.73,-1.73 z"
       id="path1" />
    <rect
       class="his-trafo-styling-1"
       x="5.5"
       y="163.17"
       width="181.5"
       height="18.469999"
       id="rect1" />
    <rect
       class="his-trafo-styling-1"
       x="16.209999"
       y="60.91"
       width="161.69"
       height="101.72"
       id="rect2" />
    <g
       id="g7">
      <rect
         class="his-trafo-styling-1"
         x="30.43"
         y="44.580002"
         width="30.52"
         height="15.53"
         id="rect3" />
      <g
         id="g6">
        <line
           class="his-trafo-styling-1"
           x1="30.43"
           y1="31.120001"
           x2="60.950001"
           y2="31.120001"
           id="line3" />
        <g
           id="g5">
          <line
             class="his-trafo-styling-1"
             x1="30.43"
             y1="18.309999"
             x2="60.950001"
             y2="18.309999"
             id="line4" />
          <line
             class="his-trafo-styling-1"
             x1="30.43"
             y1="5.5"
             x2="60.950001"
             y2="5.5"
             id="line5" />
        </g>
      </g>
    </g>
    <g
       id="g10">
      <rect
         class="his-trafo-styling-1"
         x="81.580002"
         y="44.580002"
         width="30.52"
         height="15.53"
         id="rect7" />
      <g
         id="g9">
        <line
           class="his-trafo-styling-1"
           x1="81.580002"
           y1="31.120001"
           x2="112.09"
           y2="31.120001"
           id="line7" />
        <line
           class="his-trafo-styling-1"
           x1="81.580002"
           y1="18.309999"
           x2="112.09"
           y2="18.309999"
           id="line8" />
        <line
           class="his-trafo-styling-1"
           x1="81.580002"
           y1="5.5"
           x2="112.09"
           y2="5.5"
           id="line9" />
      </g>
    </g>
    <g
       id="g13">
      <rect
         class="his-trafo-styling-1"
         x="132.72"
         y="44.580002"
         width="30.52"
         height="15.53"
         id="rect10" />
      <g
         id="g12">
        <line
           class="his-trafo-styling-1"
           x1="132.72"
           y1="31.120001"
           x2="163.24001"
           y2="31.120001"
           id="line10" />
        <line
           class="his-trafo-styling-1"
           x1="132.72"
           y1="18.309999"
           x2="163.24001"
           y2="18.309999"
           id="line11" />
        <line
           class="his-trafo-styling-1"
           x1="132.72"
           y1="5.5"
           x2="163.24001"
           y2="5.5"
           id="line12" />
      </g>
    </g>
  </g>
  `
]
export const user = [
  '49.999999 39.999999',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-user-styling {
        fill: inherit;
        stroke-width: 0px;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.36672855,0,0,0.36672855,5.7724221,9.1693644e-4)">
    <path
       class="his-user-styling"
       d="m 5.96,53.14 44,-44 c 1.36,-1.36 3.58,-1.36 4.94,0 l 44,44 c 1.36,1.36 3.58,1.36 4.94,0 1.36,-1.36 1.36,-3.58 0,-4.94 L 57.81,2.24 c -2.99,-2.99 -7.84,-2.99 -10.84,0 L 1.02,48.2 c -1.36,1.36 -1.36,3.58 0,4.94 1.36,1.36 3.58,1.36 4.94,0 z"
       id="path1" />
    <path
       class="his-user-styling"
       d="m 89.56,55.23 c -1.98,0 -3.59,1.61 -3.59,3.59 v 40.19 c 0,1.59 -1.29,2.88 -2.88,2.88 H 21.78 c -1.59,0 -2.88,-1.29 -2.88,-2.88 V 58.82 c 0,-1.98 -1.61,-3.59 -3.59,-3.59 -1.98,0 -3.59,1.61 -3.59,3.59 v 41.4 c 0,4.89 3.96,8.85 8.85,8.85 H 84.3 c 4.89,0 8.85,-3.96 8.85,-8.85 v -41.4 c 0,-1.98 -1.61,-3.59 -3.59,-3.59 z"
       id="path2" />
    <path
       class="his-user-styling"
       d="m 70.63,86.1 c 3.3,0 5.99,-2.69 5.99,-5.99 V 58.56 c 0,-3.3 -2.69,-5.99 -5.99,-5.99 H 34.24 c -3.3,0 -5.99,2.69 -5.99,5.99 v 21.55 c 0,3.31 2.69,5.99 5.99,5.99 z M 34.99,73.02 h 14.07 v 6.33 H 34.99 Z m 20.82,6.34 v -6.33 h 14.07 v 6.33 z M 69.87,66.28 H 55.8 V 59.31 H 69.87 Z M 49.06,59.31 v 6.97 H 34.99 v -6.97 z"
       id="path3" />
  </g>
  `
]
export const wallbox = [
  '50.000001 40',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-wallbox-styling {
        fill: inherit;
        stroke-width: 0px;
      }
    </style>
  </defs>
  <g
     id="Ebene_1-2"
     data-name="Ebene 1"
     transform="matrix(0.33036009,0,0,0.33036009,9.5853982,1.5139999e-7)">
    <path
       class="his-wallbox-styling"
       d="M 91.91,31.71 C 91.5,30.33 90.92,29.02 90.2,27.77 88.14,24.22 84.15,14.69 80.39,9.67 76.9,5.02 70.86,1.79 66.83,0.68 65.2,0.23 63.52,0 61.92,0 H 31.48 c -1.69,0 -3.37,0.23 -5,0.68 C 22.46,1.79 16.41,5.02 12.92,9.67 9.16,14.68 5.16,24.22 3.11,27.77 2.39,29.01 1.81,30.33 1.4,31.71 0.17,35.8 -0.92,44.36 1.24,50.39 1.71,51.71 2,53.1 2.36,54.45 l 15.15,54.8 c 1.02,3.82 3.17,7.28 6.29,9.71 1.54,1.2 3.26,2.12 4.89,2.12 h 35.94 c 1.63,0 3.35,-0.92 4.89,-2.12 3.12,-2.42 5.27,-5.89 6.29,-9.71 l 15.15,-54.8 c 0.36,-1.35 0.65,-2.74 1.12,-4.06 2.16,-6.03 1.07,-14.59 -0.16,-18.68 z M 35.73,33.13 H 57.58 V 50.15 H 35.73 Z m 10.92,79.39 c -7.27,0 -13.16,-5.89 -13.16,-13.16 0,-7.27 5.89,-13.16 13.16,-13.16 7.27,0 13.16,5.89 13.16,13.16 0,7.27 -5.89,13.16 -13.16,13.16 z"
       id="path1" />
  </g>
  `
]
export const wallboxPlugged = [
  '50.000001 40',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-wallbox-plugged-styling-0, .his-wallbox-plugged-styling-1 {
        fill: inherit;
      }
      .his-wallbox-plugged-styling-0, .his-wallbox-plugged-styling-2, .his-wallbox-plugged-styling-3 {
        stroke: inherit;
        stroke-miterlimit: 10;
      }
      .his-wallbox-plugged-styling-0, .his-wallbox-plugged-styling-3 {
        stroke-width: 3px;
      }
      .his-wallbox-plugged-styling-1 {
        stroke-width: 0px;
      }
      .his-wallbox-plugged-styling-2 {
        stroke-width: 4px;
      }
      .his-wallbox-plugged-styling-2, .his-wallbox-plugged-styling-3 {
        fill: none;
      }
    </style>
  </defs>
  <g
     id="g9"
     transform="matrix(0.21768576,0,0,0.21768576,-4.3602924e-7,11.460188)">
    <path
       class="his-wallbox-plugged-styling-3"
       d="m 35.63,68.84 c 0,0 5.96,0 10.05,-21.26 4.1,-21.26 11.73,-21.67 11.73,-21.67"
       id="path1" />
    <path
       class="his-wallbox-plugged-styling-3"
       d="m 36.81,69.58 c 0,0 5.96,0 10.05,-21.26 4.1,-21.26 11.73,-21.67 11.73,-21.67"
       id="path2" />
    <rect
       class="his-wallbox-plugged-styling-2"
       x="-76.459999"
       y="2.0000007"
       width="74.459999"
       height="34.75"
       rx="2.5999999"
       ry="2.5999999"
       transform="rotate(-90)"
       id="rect2" />
    <path
       class="his-wallbox-plugged-styling-1"
       d="m 13.46,36.4 h 11.82 c 0.52,0 0.89,0.52 0.71,1.01 l -4,11.3 c -0.17,0.49 0.19,1.01 0.71,1.01 h 2.4 c 0.57,0 0.93,0.6 0.67,1.1 l -7.73,14.9 c -0.37,0.72 -1.46,0.43 -1.42,-0.38 L 17,56.67 c 0.02,-0.43 -0.32,-0.79 -0.75,-0.79 h -2.79 c -0.42,0 -0.75,-0.34 -0.75,-0.75 V 37.16 c 0,-0.42 0.34,-0.75 0.75,-0.75 z"
       id="path3" />
    <rect
       class="his-wallbox-plugged-styling-2"
       x="-26.049999"
       y="7.8399997"
       width="18.209999"
       height="23.07"
       rx="2.3199999"
       ry="2.3199999"
       transform="rotate(-90)"
       id="rect3" />
    <path
       class="his-wallbox-plugged-styling-0"
       d="m 71.41,22.46 c 2.89,0.99 6.25,2.19 8.17,2.89 0.21,-0.6 0.34,-1.34 0.25,-2.22 0,-0.07 -0.06,-0.14 -0.13,-0.16 l -4.05,-1.45 -0.1,-0.72 -5.56,-1.83 c 0,0 -1.28,-0.53 -2.97,0.22 -1.33,0.59 -7.84,3.67 -10.85,4.78 -0.52,0.19 -0.58,0.91 -0.1,1.18 l 0.03,-0.02 -0.02,0.02 c 0,0 0,0 0,0 l -1.31,0.78 c -0.09,0.06 -0.12,0.18 -0.05,0.27 l 0.8,1.08 9.57,-4.82 c 0,0 1.98,-1.49 6.32,0 z"
       id="path4" />
    <polygon
       class="his-wallbox-plugged-styling-0"
       points="56.08,25.15 56.11,25.13 "
       id="polygon4" />
    <path
       class="his-wallbox-plugged-styling-0"
       d="m 56.73,28.6 1.19,-0.87 c 0.19,-0.14 0.45,-0.17 0.65,-0.05 0.48,0.29 1.6,0.61 3.61,-0.64 3.72,-2.33 4.47,-4.27 7.31,-2.64 2.84,1.63 4.24,1.95 4.24,1.95 l 0.37,-0.63 4.28,1.38 c 0.07,0.02 0.14,0 0.19,-0.04 0.19,-0.2 0.7,-0.8 1.02,-1.72 -1.92,-0.69 -5.28,-1.89 -8.17,-2.89 -4.35,-1.49 -6.32,0 -6.32,0 l -9.57,4.82 0.96,1.29 c 0.06,0.08 0.18,0.1 0.26,0.04 z"
       id="path5" />
    <path
       class="his-wallbox-plugged-styling-1"
       d="m 107.87,50.68 c -6.3,0 -11.43,5.13 -11.43,11.43 0,6.3 5.12,11.43 11.43,11.43 6.31,0 11.43,-5.13 11.43,-11.43 0,-6.3 -5.13,-11.43 -11.43,-11.43 z m 0,15.25 c -2.11,0 -3.83,-1.72 -3.83,-3.83 0,-2.11 1.72,-3.83 3.83,-3.83 2.11,0 3.83,1.72 3.83,3.83 0,2.11 -1.72,3.83 -3.83,3.83 z"
       id="path6" />
    <path
       class="his-wallbox-plugged-styling-1"
       d="m 198.56,50.68 c -6.3,0 -11.43,5.13 -11.43,11.43 0,6.3 5.12,11.43 11.43,11.43 6.31,0 11.43,-5.13 11.43,-11.43 0,-6.3 -5.13,-11.43 -11.43,-11.43 z m 0,15.25 c -2.11,0 -3.83,-1.72 -3.83,-3.83 0,-2.11 1.72,-3.83 3.83,-3.83 2.11,0 3.83,1.72 3.83,3.83 0,2.11 -1.72,3.83 -3.83,3.83 z"
       id="path7" />
    <path
       class="his-wallbox-plugged-styling-1"
       d="m 135.52,45.7 h 3.54 c 0.54,0 0.98,0.45 0.95,1 l -0.49,10.98 c -0.05,1.02 1.33,1.39 1.8,0.48 l 9.79,-18.87 c 0.33,-0.64 -0.13,-1.4 -0.85,-1.4 h -3.05 c -0.66,0 -1.12,-0.65 -0.9,-1.27 l 5.07,-14.32 c 0.22,-0.62 -0.24,-1.27 -0.9,-1.27 H 135.5 c -0.53,0 -0.96,0.43 -0.96,0.96 v 22.76 c 0,0.53 0.43,0.96 0.96,0.96 z"
       id="path8" />
    <path
       class="his-wallbox-plugged-styling-1"
       d="m 92.35,68.34 c 0,0 0.04,0 0.07,0 1.17,0 2.29,-0.5 3.07,-1.38 0.21,-0.24 0.39,-0.5 0.53,-0.78 -0.44,-1.28 -0.69,-2.65 -0.69,-4.08 0,-6.91 5.63,-12.54 12.54,-12.54 6.91,0 12.54,5.63 12.54,12.54 0,1.31 -0.2,2.57 -0.58,3.76 0.16,0.29 0.35,0.56 0.57,0.81 0.89,1.02 2.17,1.6 3.52,1.6 h 0.01 l 55.4,-0.19 c 2.17,0 4.6,-0.24 6.22,-1.91 0.34,-0.35 0.6,-0.76 0.82,-1.19 -0.22,-0.93 -0.35,-1.89 -0.35,-2.88 0,-6.91 5.63,-12.54 12.54,-12.54 6.91,0 12.54,5.63 12.54,12.54 0,1.22 -0.18,2.4 -0.51,3.52 0.27,0.4 0.57,0.78 0.95,1.09 1.17,0.94 2.72,1.27 4.17,0.89 l 4.95,-1.29 c 5.16,-1.35 8.74,-6.19 8.51,-11.52 -0.22,-5.11 0.02,-6.69 0.09,-7.04 0.68,-1.55 0.55,-3.37 -0.38,-5.16 -3.05,-5.83 -14.14,-10.45 -31.21,-13 -3.91,-0.58 -7.7,-2.16 -10.97,-4.55 -8.82,-6.46 -27.67,-17 -54.87,-15 -24.31,1.79 -35.9,8.35 -43.58,12.69 -2.91,1.65 -5.21,2.95 -6.96,3.17 -1.48,0.18 -2.79,0.94 -3.7,2.12 -0.9,1.18 -1.3,2.7 -1.1,4.18 0.46,3.27 1.35,11.49 -0.2,17.01 -1.26,4.46 -0.48,8.89 2.18,12.47 3.04,4.09 8.23,6.58 13.87,6.67 z M 83.61,51.27 c 1.65,-5.85 1.22,-13.35 0.65,-18.24 2.47,-0.7 4.87,-2.05 7.74,-3.68 7.08,-4.01 17.79,-10.06 40.4,-11.73 24.76,-1.81 41.84,7.71 49.82,13.55 4.26,3.12 9.21,5.17 14.33,5.93 19.36,2.89 24.33,7.41 25.37,8.69 -0.34,1.37 -0.57,3.84 -0.33,9.32 0.08,1.78 -1.12,3.39 -2.84,3.84 l -1.57,0.41 c -0.28,-1.99 -0.88,-4.31 -2.15,-6.51 -2.7,-4.7 -7.08,-7.98 -12.32,-9.22 -5.09,-1.2 -10.35,-0.34 -14.46,2.37 -6.75,4.46 -8.49,10.59 -8.86,14.48 -0.03,0 -0.05,0 -0.08,0 l -52.36,0.18 c -0.23,-5.13 -2.68,-9.86 -6.99,-13.31 -2.47,-1.98 -7.07,-4.25 -12.38,-4.25 -3.88,0 -8.14,1.22 -12.23,4.66 -4.17,3.51 -6.02,8.17 -6.47,12.37 -1.79,-0.61 -3.32,-1.65 -4.31,-2.99 -1.26,-1.69 -1.58,-3.66 -0.96,-5.86 z"
       id="path9" />
  </g>
  `
]
export const wallboxUnplugged = [
  '49.999999 40.000001',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-wallbox-unplugged-styling-0, .his-wallbox-unplugged-styling-1 {
        fill: inherit;
      }
      .his-wallbox-unplugged-styling-0, .his-wallbox-unplugged-styling-2, .his-wallbox-unplugged-styling-3, .his-wallbox-unplugged-styling-4 {
        stroke: inherit;
        stroke-miterlimit: 10;
      }
      .his-wallbox-unplugged-styling-0, .his-wallbox-unplugged-styling-3 {
        stroke-width: 3px;
      }
      .his-wallbox-unplugged-styling-1, .his-wallbox-unplugged-styling-5 {
        stroke-width: 0px;
      }
      .his-wallbox-unplugged-styling-2 {
        stroke-width: 6px;
      }
      .his-wallbox-unplugged-styling-2, .his-wallbox-unplugged-styling-5, .his-wallbox-unplugged-styling-3, .his-wallbox-unplugged-styling-4 {
        fill: none;
      }
      .his-wallbox-unplugged-styling-4 {
        stroke-width: 2px;
      }
    </style>
  </defs>
  <g
     id="g1"
     transform="matrix(0.34867503,0,0,0.34867503,-6.6495573,-16.673637)">
    <path
       class="his-wallbox-unplugged-styling-4"
       d="m 76.719999,150.4 c 0,0 4.94,-5.64 -11.79,-27.12 -16.73,-21.49 -10.79,-29.05 -10.79,-29.05"
       id="path1" />
    <path
       class="his-wallbox-unplugged-styling-3"
       d="m 78.399999,149.9 c 0,0 4.94,-5.64 -11.79,-27.12 -16.73,-21.48 -10.79,-29.05 -10.79,-29.05"
       id="path2" />
    <rect
       class="his-wallbox-unplugged-styling-2"
       x="-159.53999"
       y="77.619995"
       width="108.72"
       height="50.73"
       rx="2.5999999"
       ry="2.5999999"
       transform="rotate(-90)"
       id="rect2" />
    <path
       class="his-wallbox-unplugged-styling-1"
       d="M 94.359999,101.05 H 111.62 c 0.76,0 1.29,0.75 1.04,1.47 l -5.84,16.5 c -0.25,0.72 0.28,1.47 1.04,1.47 h 3.51 c 0.83,0 1.36,0.88 0.98,1.61 l -11.29,21.76 c -0.54,1.05 -2.130001,0.62 -2.080001,-0.56 l 0.56,-12.66 c 0.03,-0.63 -0.47,-1.15 -1.1,-1.15 h -4.08 c -0.61,0 -1.1,-0.49 -1.1,-1.1 v -26.24 c 0,-0.61 0.49,-1.1 1.1,-1.1 z"
       id="path3" />
    <rect
       class="his-wallbox-unplugged-styling-2"
       x="-85.93"
       y="86.150002"
       width="26.58"
       height="33.68"
       rx="2.3199999"
       ry="2.3199999"
       transform="rotate(-90)"
       id="rect3" />
    <path
       class="his-wallbox-unplugged-styling-0"
       d="m 62.929999,77.6 c 3.34,-1.92 7.25,-4.1 9.5,-5.34 -0.4,-0.7 -0.99,-1.44 -1.89,-2.07 -0.07,-0.05 -0.18,-0.06 -0.26,-0.01 l -4.73,2.63 -0.76,-0.5 -6.34,3.75 c 0,0 -1.56,0.77 -2.25,3 -0.55,1.75 -3.02,10.46 -4.46,14.23 -0.25,0.66 0.38,1.3 1.04,1.07 v -0.04 c 0,0 0,0.04 0,0.04 0,0 0,0 0,0 l -0.34,1.89 c -0.02,0.14 0.07,0.26 0.21,0.27 l 1.69,0.13 3.37,-13.05 c 0,0 0.22,-3.11 5.24,-5.98 z"
       id="path4" />
    <polygon
       class="his-wallbox-unplugged-styling-0"
       points="52.78,94.34 52.78,94.33 52.79,94.3 "
       id="polygon4" />
    <path
       class="his-wallbox-unplugged-styling-0"
       d="m 56.589999,96.58 0.16,-1.84 c 0.03,-0.3 0.21,-0.57 0.49,-0.66 0.67,-0.21 1.91,-1.01 2.38,-3.95 0.88,-5.45 -0.34,-7.77 3.56,-9.1 3.9,-1.33 5.36,-2.39 5.36,-2.39 l -0.29,-0.88 4.85,-2.9 c 0.08,-0.05 0.12,-0.12 0.11,-0.21 -0.03,-0.35 -0.18,-1.32 -0.78,-2.38 -2.25,1.25 -6.16,3.43 -9.5,5.34 -5.01,2.88 -5.24,5.98 -5.24,5.98 l -3.37,13.05 2.01,0.16 c 0.13,0.01 0.24,-0.08 0.25,-0.21 z"
       id="path5" />
  </g>
  `
]
export const wallboxWarning = [
  '49.999999 40.000002',
  `
  </sodipodi:namedview>
  <defs
     id="defs1">
    <style
       id="style1">
      .his-wallbox-warning-styling-0, .his-wallbox-warning-styling-1 {
        fill: inherit;
      }
      .his-wallbox-warning-styling-0, .his-wallbox-warning-styling-2, .his-wallbox-warning-styling-3, .his-wallbox-warning-styling-4, .his-wallbox-warning-styling-5 {
        stroke: inherit;
        stroke-miterlimit: 10;
      }
      .his-wallbox-warning-styling-0, .his-wallbox-warning-styling-3 {
        stroke-width: 3px;
      }
      .his-wallbox-warning-styling-1 {
        stroke-width: 0px;
      }
      .his-wallbox-warning-styling-2 {
        stroke-width: 6px;
      }
      .his-wallbox-warning-styling-2, .his-wallbox-warning-styling-3, .his-wallbox-warning-styling-4, .his-wallbox-warning-styling-5 {
        fill: none;
      }
      .his-wallbox-warning-styling-4 {
        stroke-width: 5px;
      }
      .his-wallbox-warning-styling-5 {
        stroke-width: 2px;
      }
    </style>
  </defs>
  <g
     id="g9"
     transform="matrix(0.29262881,0,0,0.29262881,9.9297323,-0.02284245)">
    <path
       class="his-wallbox-warning-styling-5"
       d="m 26.54,124.63 c 0,0 4.94,-5.64 -11.79,-27.12 C -1.98,76.01 3.96,68.45 3.96,68.45"
       id="path1" />
    <path
       class="his-wallbox-warning-styling-3"
       d="m 28.22,124.12 c 0,0 4.94,-5.64 -11.79,-27.12 C -0.3,75.52 5.64,67.95 5.64,67.95"
       id="path2" />
    <path
       class="his-wallbox-warning-styling-2"
       d="m 62.54,25.04 h -32.5 c -1.43,0 -2.6,1.16 -2.6,2.6 v 103.53 c 0,1.43 1.16,2.6 2.6,2.6 h 45.54 c 1.43,0 2.6,-1.16 2.6,-2.6 v -89"
       id="path3" />
    <path
       class="his-wallbox-warning-styling-1"
       d="m 44.18,75.27 h 17.26 c 0.76,0 1.29,0.75 1.04,1.47 l -5.84,16.5 c -0.25,0.72 0.28,1.47 1.04,1.47 h 3.51 c 0.83,0 1.36,0.88 0.98,1.61 l -11.29,21.76 c -0.54,1.05 -2.13,0.62 -2.08,-0.56 l 0.56,-12.66 c 0.03,-0.63 -0.47,-1.15 -1.1,-1.15 h -4.08 c -0.61,0 -1.1,-0.49 -1.1,-1.1 V 76.37 c 0,-0.61 0.49,-1.1 1.1,-1.1 z"
       id="path4" />
    <path
       class="his-wallbox-warning-styling-2"
       d="M 56.87,33.57 H 38.28 c -1.28,0 -2.32,1.04 -2.32,2.32 v 21.94 c 0,1.28 1.04,2.32 2.32,2.32 h 29.04 c 1.28,0 2.32,-1.04 2.32,-2.32 V 42.17"
       id="path5" />
    <path
       class="his-wallbox-warning-styling-0"
       d="m 12.75,51.82 c 3.34,-1.92 7.25,-4.1 9.5,-5.34 -0.4,-0.7 -0.99,-1.44 -1.89,-2.07 -0.07,-0.05 -0.18,-0.06 -0.26,-0.01 l -4.73,2.63 -0.76,-0.5 -6.34,3.75 c 0,0 -1.56,0.77 -2.25,3 C 5.47,55.03 3,63.74 1.56,67.51 c -0.25,0.66 0.38,1.3 1.04,1.07 v -0.04 c 0,0 0,0.04 0,0.04 0,0 0,0 0,0 l -0.34,1.89 c -0.02,0.14 0.07,0.26 0.21,0.27 l 1.69,0.13 3.37,-13.05 c 0,0 0.22,-3.11 5.24,-5.98 z"
       id="path6" />
    <polygon
       class="his-wallbox-warning-styling-0"
       points="2.6,68.56 2.61,68.52 "
       id="polygon6" />
    <path
       class="his-wallbox-warning-styling-0"
       d="M 6.41,70.8 6.57,68.96 C 6.6,68.66 6.78,68.39 7.06,68.3 7.73,68.09 8.97,67.29 9.44,64.35 10.32,58.9 9.1,56.58 13,55.25 c 3.9,-1.33 5.36,-2.39 5.36,-2.39 l -0.29,-0.88 4.85,-2.9 C 23,49.03 23.04,48.96 23.03,48.87 23,48.52 22.85,47.55 22.25,46.49 20,47.74 16.09,49.92 12.75,51.83 7.74,54.71 7.51,57.81 7.51,57.81 l -3.37,13.05 2.01,0.16 c 0.13,0.01 0.24,-0.08 0.25,-0.21 z"
       id="path7" />
    <path
       class="his-wallbox-warning-styling-4"
       d="M 74.96,4.36 56.35,36.6 c -1.43,2.48 0.36,5.57 3.22,5.57 H 96.8 c 2.86,0 4.65,-3.1 3.22,-5.57 L 81.39,4.36 c -1.43,-2.48 -5.01,-2.48 -6.44,0 z"
       id="path8" />
    <path
       class="his-wallbox-warning-styling-1"
       d="M 77.06,30.56 75.98,19.55 v -4.6 h 4.38 v 4.6 l -1.02,11.01 z m -0.92,5.16 v -2.9 h 4.07 v 2.9 z"
       id="path9" />
  </g>
  `
]
